"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DLCLinks = exports.demoLinks = exports.editionsInfo = exports.comingSoon = exports.purchaseLinks = exports.platformsList = exports.editionsList = exports.countryList = void 0;
// Full demo button type: one entry for each language
// type DemoBtnMap = Record<LanguageKeyPurchase, DemoLinks>;
// Combo US
const physical_LE_640_combo_US_jpg_1 = __importDefault(require("../../img/purchase/physical_LE_640_combo_US.jpg"));
const physical_LE_640_combo_US_webp_1 = __importDefault(require("../../img/purchase/physical_LE_640_combo_US.webp"));
const physical_LE_1280_combo_US_jpg_1 = __importDefault(require("../../img/purchase/physical_LE_1280_combo_US.jpg"));
const physical_LE_1280_combo_US_webp_1 = __importDefault(require("../../img/purchase/physical_LE_1280_combo_US.webp"));
// Switch US
const physical_SE_640_NSW_US_png_1 = __importDefault(require("../../img/purchase/physical_SE_640_NSW_US.png"));
const physical_SE_640_NSW_US_webp_1 = __importDefault(require("../../img/purchase/physical_SE_640_NSW_US.webp"));
const physical_SE_1280_NSW_US_png_1 = __importDefault(require("../../img/purchase/physical_SE_1280_NSW_US.png"));
const physical_SE_1280_NSW_US_webp_1 = __importDefault(require("../../img/purchase/physical_SE_1280_NSW_US.webp"));
const physical_LE_640_NSW_png_1 = __importDefault(require("../../img/purchase/physical_LE_640_NSW.png"));
const physical_LE_640_NSW_webp_1 = __importDefault(require("../../img/purchase/physical_LE_640_NSW.webp"));
const physical_LE_1280_NSW_png_1 = __importDefault(require("../../img/purchase/physical_LE_1280_NSW.png"));
const physical_LE_1280_NSW_webp_1 = __importDefault(require("../../img/purchase/physical_LE_1280_NSW.webp"));
// PS5 US
const physical_SE_640_PS5_png_1 = __importDefault(require("../../img/purchase/physical_SE_640_PS5.png"));
const physical_SE_640_PS5_webp_1 = __importDefault(require("../../img/purchase/physical_SE_640_PS5.webp"));
const physical_SE_1280_PS5_png_1 = __importDefault(require("../../img/purchase/physical_SE_1280_PS5.png"));
const physical_SE_1280_PS5_webp_1 = __importDefault(require("../../img/purchase/physical_SE_1280_PS5.webp"));
// import physical_LE_640_ps5 from '../../img/purchase/physical_LE_640_ps5.jpg';
// import physical_LE_640_ps5_webp from '../../img/purchase/physical_LE_640_ps5.webp';
// import physical_LE_1280_ps5 from '../../img/purchase/physical_LE_1280_ps5.jpg';
// import physical_LE_1280_ps5_webp from '../../img/purchase/physical_LE_1280_ps5.webp';
// xbox US
const physical_SE_640_xbox_png_1 = __importDefault(require("../../img/purchase/physical_SE_640_xbox.png"));
const physical_SE_640_xbox_webp_1 = __importDefault(require("../../img/purchase/physical_SE_640_xbox.webp"));
const physical_SE_1280_xbox_png_1 = __importDefault(require("../../img/purchase/physical_SE_1280_xbox.png"));
const physical_SE_1280_xbox_webp_1 = __importDefault(require("../../img/purchase/physical_SE_1280_xbox.webp"));
// Switch LE AU
const physical_LE_640_AU_jpg_1 = __importDefault(require("../../img/purchase/physical_LE_640_AU.jpg"));
const physical_LE_640_AU_webp_1 = __importDefault(require("../../img/purchase/physical_LE_640_AU.webp"));
const physical_LE_1280_AU_jpg_1 = __importDefault(require("../../img/purchase/physical_LE_1280_AU.jpg"));
const physical_LE_1280_AU_webp_1 = __importDefault(require("../../img/purchase/physical_LE_1280_AU.webp"));
// Switch LE UK
const physical_LE_640_UK_jpg_1 = __importDefault(require("../../img/purchase/physical_LE_640_UK.jpg"));
const physical_LE_640_UK_webp_1 = __importDefault(require("../../img/purchase/physical_LE_640_UK.webp"));
const physical_LE_1280_UK_jpg_1 = __importDefault(require("../../img/purchase/physical_LE_1280_UK.jpg"));
const physical_LE_1280_UK_webp_1 = __importDefault(require("../../img/purchase/physical_LE_1280_UK.webp"));
// Switch LE ES
const physical_LE_640_ES_jpg_1 = __importDefault(require("../../img/purchase/physical_LE_640_ES.jpg"));
const physical_LE_640_ES_webp_1 = __importDefault(require("../../img/purchase/physical_LE_640_ES.webp"));
const physical_LE_1280_ES_jpg_1 = __importDefault(require("../../img/purchase/physical_LE_1280_ES.jpg"));
const physical_LE_1280_ES_webp_1 = __importDefault(require("../../img/purchase/physical_LE_1280_ES.webp"));
// Switch LE FR
const physical_LE_640_FR_jpg_1 = __importDefault(require("../../img/purchase/physical_LE_640_FR.jpg"));
const physical_LE_640_FR_webp_1 = __importDefault(require("../../img/purchase/physical_LE_640_FR.webp"));
const physical_LE_1280_FR_jpg_1 = __importDefault(require("../../img/purchase/physical_LE_1280_FR.jpg"));
const physical_LE_1280_FR_webp_1 = __importDefault(require("../../img/purchase/physical_LE_1280_FR.webp"));
// Switch LE IT
const physical_LE_640_IT_jpg_1 = __importDefault(require("../../img/purchase/physical_LE_640_IT.jpg"));
const physical_LE_640_IT_webp_1 = __importDefault(require("../../img/purchase/physical_LE_640_IT.webp"));
const physical_LE_1280_IT_jpg_1 = __importDefault(require("../../img/purchase/physical_LE_1280_IT.jpg"));
const physical_LE_1280_IT_webp_1 = __importDefault(require("../../img/purchase/physical_LE_1280_IT.webp"));
// Switch LE NL
const physical_LE_640_NL_jpg_1 = __importDefault(require("../../img/purchase/physical_LE_640_NL.jpg"));
const physical_LE_640_NL_webp_1 = __importDefault(require("../../img/purchase/physical_LE_640_NL.webp"));
const physical_LE_1280_NL_jpg_1 = __importDefault(require("../../img/purchase/physical_LE_1280_NL.jpg"));
const physical_LE_1280_NL_webp_1 = __importDefault(require("../../img/purchase/physical_LE_1280_NL.webp"));
// Switch LE PT
const physical_LE_640_PT_jpg_1 = __importDefault(require("../../img/purchase/physical_LE_640_PT.jpg"));
const physical_LE_640_PT_webp_1 = __importDefault(require("../../img/purchase/physical_LE_640_PT.webp"));
const physical_LE_1280_PT_jpg_1 = __importDefault(require("../../img/purchase/physical_LE_1280_PT.jpg"));
const physical_LE_1280_PT_webp_1 = __importDefault(require("../../img/purchase/physical_LE_1280_PT.webp"));
// Switch LE DE
const physical_LE_640_DE_jpg_1 = __importDefault(require("../../img/purchase/physical_LE_640_DE.jpg"));
const physical_LE_640_DE_webp_1 = __importDefault(require("../../img/purchase/physical_LE_640_DE.webp"));
const physical_LE_1280_DE_jpg_1 = __importDefault(require("../../img/purchase/physical_LE_1280_DE.jpg"));
const physical_LE_1280_DE_webp_1 = __importDefault(require("../../img/purchase/physical_LE_1280_DE.webp"));
// Switch SE ACB
const physical_SE_640_NSW_AU_png_1 = __importDefault(require("../../img/purchase/physical_SE_640_NSW_AU.png"));
const physical_SE_640_NSW_AU_webp_1 = __importDefault(require("../../img/purchase/physical_SE_640_NSW_AU.webp"));
const physical_SE_1280_NSW_AU_png_1 = __importDefault(require("../../img/purchase/physical_SE_1280_NSW_AU.png"));
const physical_SE_1280_NSW_AU_webp_1 = __importDefault(require("../../img/purchase/physical_SE_1280_NSW_AU.webp"));
// Switch SE PEGI
const physical_SE_640_NSW_PEGI_png_1 = __importDefault(require("../../img/purchase/physical_SE_640_NSW_PEGI.png"));
const physical_SE_640_NSW_PEGI_webp_1 = __importDefault(require("../../img/purchase/physical_SE_640_NSW_PEGI.webp"));
const physical_SE_1280_NSW_PEGI_png_1 = __importDefault(require("../../img/purchase/physical_SE_1280_NSW_PEGI.png"));
const physical_SE_1280_NSW_PEGI_webp_1 = __importDefault(require("../../img/purchase/physical_SE_1280_NSW_PEGI.webp"));
// Switch SE USK
const physical_SE_640_NSW_USK_png_1 = __importDefault(require("../../img/purchase/physical_SE_640_NSW_USK.png"));
const physical_SE_640_NSW_USK_webp_1 = __importDefault(require("../../img/purchase/physical_SE_640_NSW_USK.webp"));
const physical_SE_1280_NSW_USK_png_1 = __importDefault(require("../../img/purchase/physical_SE_1280_NSW_USK.png"));
const physical_SE_1280_NSW_USK_webp_1 = __importDefault(require("../../img/purchase/physical_SE_1280_NSW_USK.webp"));
// PS5 SE ACB
const physical_SE_640_PS5_ACB_png_1 = __importDefault(require("../../img/purchase/physical_SE_640_PS5_ACB.png"));
const physical_SE_640_PS5_ACB_webp_1 = __importDefault(require("../../img/purchase/physical_SE_640_PS5_ACB.webp"));
const physical_SE_1280_PS5_ACB_png_1 = __importDefault(require("../../img/purchase/physical_SE_1280_PS5_ACB.png"));
const physical_SE_1280_PS5_ACB_webp_1 = __importDefault(require("../../img/purchase/physical_SE_1280_PS5_ACB.webp"));
// PS5 SE PEGI
const physical_SE_640_ps5_PEGI_png_1 = __importDefault(require("../../img/purchase/physical_SE_640_ps5_PEGI.png"));
const physical_SE_640_ps5_PEGI_webp_1 = __importDefault(require("../../img/purchase/physical_SE_640_ps5_PEGI.webp"));
const physical_SE_1280_ps5_PEGI_png_1 = __importDefault(require("../../img/purchase/physical_SE_1280_ps5_PEGI.png"));
const physical_SE_1280_ps5_PEGI_webp_1 = __importDefault(require("../../img/purchase/physical_SE_1280_ps5_PEGI.webp"));
// PS5 SE USK
const physical_SE_640_ps5_USK_png_1 = __importDefault(require("../../img/purchase/physical_SE_640_ps5_USK.png"));
const physical_SE_640_ps5_USK_webp_1 = __importDefault(require("../../img/purchase/physical_SE_640_ps5_USK.webp"));
const physical_SE_1280_ps5_USK_png_1 = __importDefault(require("../../img/purchase/physical_SE_1280_ps5_USK.png"));
const physical_SE_1280_ps5_USK_webp_1 = __importDefault(require("../../img/purchase/physical_SE_1280_ps5_USK.webp"));
// xbox SE ACB
const physical_SE_640_xbox_ACB_png_1 = __importDefault(require("../../img/purchase/physical_SE_640_xbox_ACB.png"));
const physical_SE_640_xbox_ACB_webp_1 = __importDefault(require("../../img/purchase/physical_SE_640_xbox_ACB.webp"));
const physical_SE_1280_xbox_ACB_png_1 = __importDefault(require("../../img/purchase/physical_SE_1280_xbox_ACB.png"));
const physical_SE_1280_xbox_ACB_webp_1 = __importDefault(require("../../img/purchase/physical_SE_1280_xbox_ACB.webp"));
// XBOX SE PEGI
const physical_SE_640_xbox_PEGI_png_1 = __importDefault(require("../../img/purchase/physical_SE_640_xbox_PEGI.png"));
const physical_SE_640_xbox_PEGI_webp_1 = __importDefault(require("../../img/purchase/physical_SE_640_xbox_PEGI.webp"));
const physical_SE_1280_xbox_PEGI_png_1 = __importDefault(require("../../img/purchase/physical_SE_1280_xbox_PEGI.png"));
const physical_SE_1280_xbox_PEGI_webp_1 = __importDefault(require("../../img/purchase/physical_SE_1280_xbox_PEGI.webp"));
// XBOX SE USK
const physical_SE_640_xbox_USK_png_1 = __importDefault(require("../../img/purchase/physical_SE_640_xbox_USK.png"));
const physical_SE_640_xbox_USK_webp_1 = __importDefault(require("../../img/purchase/physical_SE_640_xbox_USK.webp"));
const physical_SE_1280_xbox_USK_png_1 = __importDefault(require("../../img/purchase/physical_SE_1280_xbox_USK.png"));
const physical_SE_1280_xbox_USK_webp_1 = __importDefault(require("../../img/purchase/physical_SE_1280_xbox_USK.webp"));
// Digital US
const digital_1280_esrb_jpg_1 = __importDefault(require("../../img/purchase/digital_1280_esrb.jpg"));
const digital_1280_esrb_webp_1 = __importDefault(require("../../img/purchase/digital_1280_esrb.webp"));
const digital_640_esrb_jpg_1 = __importDefault(require("../../img/purchase/digital_640_esrb.jpg"));
const digital_640_esrb_webp_1 = __importDefault(require("../../img/purchase/digital_640_esrb.webp"));
// Digital DE
const digital_1280_de_jpg_1 = __importDefault(require("../../img/purchase/digital_1280_de.jpg"));
const digital_1280_de_webp_1 = __importDefault(require("../../img/purchase/digital_1280_de.webp"));
const digital_640_de_jpg_1 = __importDefault(require("../../img/purchase/digital_640_de.jpg"));
const digital_640_de_webp_1 = __importDefault(require("../../img/purchase/digital_640_de.webp"));
// Digital PEGI
const digital_1280_pegi_jpg_1 = __importDefault(require("../../img/purchase/digital_1280_pegi.jpg"));
const digital_1280_pegi_webp_1 = __importDefault(require("../../img/purchase/digital_1280_pegi.webp"));
const digital_640_pegi_jpg_1 = __importDefault(require("../../img/purchase/digital_640_pegi.jpg"));
const digital_640_pegi_webp_1 = __importDefault(require("../../img/purchase/digital_640_pegi.webp"));
// Digital ES
const digital_1280_es_jpg_1 = __importDefault(require("../../img/purchase/digital_1280_es.jpg"));
const digital_1280_es_webp_1 = __importDefault(require("../../img/purchase/digital_1280_es.webp"));
const digital_640_es_jpg_1 = __importDefault(require("../../img/purchase/digital_640_es.jpg"));
const digital_640_es_webp_1 = __importDefault(require("../../img/purchase/digital_640_es.webp"));
// Digital FR
const digital_1280_fr_jpg_1 = __importDefault(require("../../img/purchase/digital_1280_fr.jpg"));
const digital_1280_fr_webp_1 = __importDefault(require("../../img/purchase/digital_1280_fr.webp"));
const digital_640_fr_jpg_1 = __importDefault(require("../../img/purchase/digital_640_fr.jpg"));
const digital_640_fr_webp_1 = __importDefault(require("../../img/purchase/digital_640_fr.webp"));
// Digital IT
const digital_1280_it_jpg_1 = __importDefault(require("../../img/purchase/digital_1280_it.jpg"));
const digital_1280_it_webp_1 = __importDefault(require("../../img/purchase/digital_1280_it.webp"));
const digital_640_it_jpg_1 = __importDefault(require("../../img/purchase/digital_640_it.jpg"));
const digital_640_it_webp_1 = __importDefault(require("../../img/purchase/digital_640_it.webp"));
// Digital NL
const digital_1280_nl_jpg_1 = __importDefault(require("../../img/purchase/digital_1280_nl.jpg"));
const digital_1280_nl_webp_1 = __importDefault(require("../../img/purchase/digital_1280_nl.webp"));
const digital_640_nl_jpg_1 = __importDefault(require("../../img/purchase/digital_640_nl.jpg"));
const digital_640_nl_webp_1 = __importDefault(require("../../img/purchase/digital_640_nl.webp"));
// Digital PT
const digital_1280_pt_jpg_1 = __importDefault(require("../../img/purchase/digital_1280_pt.jpg"));
const digital_1280_pt_webp_1 = __importDefault(require("../../img/purchase/digital_1280_pt.webp"));
const digital_640_pt_jpg_1 = __importDefault(require("../../img/purchase/digital_640_pt.jpg"));
const digital_640_pt_webp_1 = __importDefault(require("../../img/purchase/digital_640_pt.webp"));
// Digital AU
const digital_1280_au_jpg_1 = __importDefault(require("../../img/purchase/digital_1280_au.jpg"));
const digital_1280_au_webp_1 = __importDefault(require("../../img/purchase/digital_1280_au.webp"));
const digital_640_au_jpg_1 = __importDefault(require("../../img/purchase/digital_640_au.jpg"));
const digital_640_au_webp_1 = __importDefault(require("../../img/purchase/digital_640_au.webp"));
exports.countryList = [
    {
        country_name: 'United States of America',
        country_id: 'usa',
        country_cookie: 'en',
    },
    {
        country_name: 'Canada',
        country_id: 'ca',
        country_cookie: 'ca',
    },
    {
        country_name: 'United Kingdom',
        country_id: 'uk',
        country_cookie: 'uk',
    },
    {
        country_name: 'France',
        country_id: 'fr',
        country_cookie: 'fr',
    },
    {
        country_name: 'Italy',
        country_id: 'it',
        country_cookie: 'it',
    },
    {
        country_name: 'Germany',
        country_id: 'de',
        country_cookie: 'de',
    },
    {
        country_name: 'Spain',
        country_id: 'es',
        country_cookie: 'es',
    },
    {
        country_name: 'Netherlands',
        country_id: 'nl',
        country_cookie: 'nl',
    },
    {
        country_name: 'Portugal',
        country_id: 'pt',
        country_cookie: 'pt',
    },
    {
        country_name: 'Switzerland',
        country_id: 'ch',
        country_cookie: 'ch',
    },
    {
        country_name: 'Belgium',
        country_id: 'be',
        country_cookie: 'be',
    },
    {
        country_name: 'Poland',
        country_id: 'pl',
        country_cookie: 'pl',
    },
    {
        country_name: 'Sweden',
        country_id: 'se',
        country_cookie: 'se',
    },
    {
        country_name: 'Norway',
        country_id: 'no',
        country_cookie: 'no',
    },
    {
        country_name: 'Australia',
        country_id: 'au',
        country_cookie: 'au',
    },
    {
        country_name: 'New Zealand',
        country_id: 'nz',
        country_cookie: 'nz',
    },
    {
        country_name: 'Denmark',
        country_id: 'dk',
        country_cookie: 'dk',
    },
    {
        country_name: 'Austria',
        country_id: 'at',
        country_cookie: 'at',
    },
];
// NOTE: edition_id MUST include digital or physical in it.
exports.editionsList = {
    en: [
        {
            edition_name: 'Physical Limited Edition',
            edition_id: 'physicalLimited',
        },
        {
            edition_name: 'Physical Standard Edition',
            edition_id: 'physicalStandard',
        },
        {
            edition_name: 'Digital Standard Edition',
            edition_id: 'digitalStandard',
        },
        {
            edition_name: 'Digital Deluxe Edition',
            edition_id: 'digitalDeluxe',
        },
        {
            edition_name: 'Super Digital Deluxe Edition',
            edition_id: 'digitalSuper',
        },
    ],
    ca: [
        {
            edition_name: 'Physical Limited Edition',
            edition_id: 'physicalLimited',
        },
        {
            edition_name: 'Physical Standard Edition',
            edition_id: 'physicalStandard',
        },
        {
            edition_name: 'Digital Standard Edition',
            edition_id: 'digitalStandard',
        },
        {
            edition_name: 'Digital Deluxe Edition',
            edition_id: 'digitalDeluxe',
        },
        {
            edition_name: 'Super Digital Deluxe Edition',
            edition_id: 'digitalSuper',
        },
    ],
    uk: [
        {
            edition_name: 'Physical Limited Edition',
            edition_id: 'physicalLimited',
        },
        {
            edition_name: 'Physical Standard Edition',
            edition_id: 'physicalStandard',
        },
        {
            edition_name: 'Digital Standard Edition',
            edition_id: 'digitalStandard',
        },
        {
            edition_name: 'Digital Deluxe Edition',
            edition_id: 'digitalDeluxe',
        },
        {
            edition_name: 'Super Digital Deluxe Edition',
            edition_id: 'digitalSuper',
        },
    ],
    fr: [
        {
            edition_name: 'Édition limitée',
            edition_id: 'physicalLimited',
        },
        {
            edition_name: 'Édition standard',
            edition_id: 'physicalStandard',
        },
        {
            edition_name: 'Édition digital standard',
            edition_id: 'digitalStandard',
        },
        {
            edition_name: 'Édition digital deluxe',
            edition_id: 'digitalDeluxe',
        },
        {
            edition_name: 'Édition super digital deluxe',
            edition_id: 'digitalSuper',
        },
    ],
    de: [
        {
            edition_name: 'Limited Edition',
            edition_id: 'physicalLimited',
        },
        {
            edition_name: 'Standard Edition',
            edition_id: 'physicalStandard',
        },
        {
            edition_name: 'Digitale Standard Edition',
            edition_id: 'digitalStandard',
        },
        {
            edition_name: 'Digitale Deluxe Edition',
            edition_id: 'digitalDeluxe',
        },
        {
            edition_name: 'Super Digitale Deluxe Edition',
            edition_id: 'digitalSuper',
        },
    ],
    es: [
        {
            edition_name: 'Edición limitada',
            edition_id: 'physicalLimited',
        },
        {
            edition_name: 'Edición estándar',
            edition_id: 'physicalStandard',
        },
        {
            edition_name: 'Edición digital estándar',
            edition_id: 'digitalStandard',
        },
        {
            edition_name: 'Edición digital deluxe',
            edition_id: 'digitalDeluxe',
        },
        {
            edition_name: 'Edición digital super deluxe',
            edition_id: 'digitalSuper',
        },
    ],
    au: [
        {
            edition_name: 'Physical Limited Edition',
            edition_id: 'physicalLimited',
        },
        {
            edition_name: 'Physical Standard Edition',
            edition_id: 'physicalStandard',
        },
        {
            edition_name: 'Digital Standard Edition',
            edition_id: 'digitalStandard',
        },
        {
            edition_name: 'Digital Deluxe Edition',
            edition_id: 'digitalDeluxe',
        },
        {
            edition_name: 'Super Digital Deluxe Edition',
            edition_id: 'digitalSuper',
        },
    ],
    nz: [
        {
            edition_name: 'Physical Limited Edition',
            edition_id: 'physicalLimited',
        },
        {
            edition_name: 'Physical Standard Edition',
            edition_id: 'physicalStandard',
        },
        {
            edition_name: 'Digital Standard Edition',
            edition_id: 'digitalStandard',
        },
        {
            edition_name: 'Digital Deluxe Edition',
            edition_id: 'digitalDeluxe',
        },
        {
            edition_name: 'Super Digital Deluxe Edition',
            edition_id: 'digitalSuper',
        },
    ],
    it: [
        {
            edition_name: 'Edizione limitata',
            edition_id: 'physicalLimited',
        },
        {
            edition_name: 'Edizione standard',
            edition_id: 'physicalStandard',
        },
        {
            edition_name: 'Edizione digitale standard',
            edition_id: 'digitalStandard',
        },
        {
            edition_name: 'Edizione digitale deluxe',
            edition_id: 'digitalDeluxe',
        },
        {
            edition_name: 'Edizione digitale deluxe super',
            edition_id: 'digitalSuper',
        },
    ],
    pt: [
        {
            edition_name: 'Edição Limitada',
            edition_id: 'physicalLimited',
        },
        {
            edition_name: 'Edição Standard',
            edition_id: 'physicalStandard',
        },
        {
            edition_name: 'Edição Digital Standard',
            edition_id: 'digitalStandard',
        },
        {
            edition_name: 'Edição Digital Deluxe',
            edition_id: 'digitalDeluxe',
        },
        {
            edition_name: 'Edição Digital Super Deluxe ',
            edition_id: 'digitalSuper',
        },
    ],
    nl: [
        {
            edition_name: 'Limited Editie',
            edition_id: 'physicalLimited',
        },
        {
            edition_name: 'Standaard Editie',
            edition_id: 'physicalStandard',
        },
        {
            edition_name: 'Digitale standaard editie',
            edition_id: 'digitalStandard',
        },
        {
            edition_name: 'Digitale Deluxe-uitgave',
            edition_id: 'digitalDeluxe',
        },
        {
            edition_name: 'Super Digital Deluxe Edition',
            edition_id: 'digitalSuper',
        },
    ],
    ch: [
        {
            edition_name: 'Limited Editie',
            edition_id: 'physicalLimited',
        },
        {
            edition_name: 'Standaard Editie',
            edition_id: 'physicalStandard',
        },
        {
            edition_name: 'Digital Standard Edition',
            edition_id: 'digitalStandard',
        },
        {
            edition_name: 'Digital Deluxe Edition',
            edition_id: 'digitalDeluxe',
        },
        {
            edition_name: 'Super Digital Deluxe Edition',
            edition_id: 'digitalSuper',
        },
    ],
    be: [
        {
            edition_name: 'Physical Limited Edition',
            edition_id: 'physicalLimited',
        },
        {
            edition_name: 'Physical Standard Edition',
            edition_id: 'physicalStandard',
        },
        {
            edition_name: 'Digital Standard Edition',
            edition_id: 'digitalStandard',
        },
        {
            edition_name: 'Digital Deluxe Edition',
            edition_id: 'digitalDeluxe',
        },
        {
            edition_name: 'Super Digital Deluxe Edition',
            edition_id: 'digitalSuper',
        },
    ],
    pl: [
        {
            edition_name: 'Physical Limited Edition',
            edition_id: 'physicalLimited',
        },
        {
            edition_name: 'Physical Standard Edition',
            edition_id: 'physicalStandard',
        },
        {
            edition_name: 'Digital Standard Edition',
            edition_id: 'digitalStandard',
        },
        {
            edition_name: 'Digital Deluxe Edition',
            edition_id: 'digitalDeluxe',
        },
        {
            edition_name: 'Super Digital Deluxe Edition',
            edition_id: 'digitalSuper',
        },
    ],
    se: [
        {
            edition_name: 'Physical Limited Edition',
            edition_id: 'physicalLimited',
        },
        {
            edition_name: 'Physical Standard Edition',
            edition_id: 'physicalStandard',
        },
        {
            edition_name: 'Digital Standard Edition',
            edition_id: 'digitalStandard',
        },
        {
            edition_name: 'Digital Deluxe Edition',
            edition_id: 'digitalDeluxe',
        },
        {
            edition_name: 'Super Digital Deluxe Edition',
            edition_id: 'digitalSuper',
        },
    ],
    no: [
        {
            edition_name: 'Physical Limited Edition',
            edition_id: 'physicalLimited',
        },
        {
            edition_name: 'Physical Standard Edition',
            edition_id: 'physicalStandard',
        },
        {
            edition_name: 'Digital Standard Edition',
            edition_id: 'digitalStandard',
        },
        {
            edition_name: 'Digital Deluxe Edition',
            edition_id: 'digitalDeluxe',
        },
        {
            edition_name: 'Super Digital Deluxe Edition',
            edition_id: 'digitalSuper',
        },
    ],
    dk: [
        {
            edition_name: 'Physical Limited Edition',
            edition_id: 'physicalLimited',
        },
        {
            edition_name: 'Physical Standard Edition',
            edition_id: 'physicalStandard',
        },
        {
            edition_name: 'Digital Standard Edition',
            edition_id: 'digitalStandard',
        },
        {
            edition_name: 'Digital Deluxe Edition',
            edition_id: 'digitalDeluxe',
        },
        {
            edition_name: 'Super Digital Deluxe Edition',
            edition_id: 'digitalSuper',
        },
    ],
    at: [
        {
            edition_name: 'Physical Limited Edition',
            edition_id: 'physicalLimited',
        },
        {
            edition_name: 'Physical Standard Edition',
            edition_id: 'physicalStandard',
        },
        {
            edition_name: 'Digital Standard Edition',
            edition_id: 'digitalStandard',
        },
        {
            edition_name: 'Digital Deluxe Edition',
            edition_id: 'digitalDeluxe',
        },
        {
            edition_name: 'Super Digital Deluxe Edition',
            edition_id: 'digitalSuper',
        },
    ],
};
exports.platformsList = [
    {
        platform_name: 'Nintendo Switch 2',
        platform_name_digital: 'Nintendo Switch 2',
        platform_id: 'switch',
        platform_cookie: 'switch',
        digitalOnly: false,
        retailUsaOnly: false,
    },
    {
        platform_name: 'PlayStation®5', // Changed from `&reg;` to `®`
        platform_name_digital: 'PlayStation®5',
        platform_id: 'ps5',
        platform_cookie: 'ps5',
        digitalOnly: false,
        retailUsaOnly: true,
    },
    {
        platform_name: 'Xbox Series X|S',
        platform_name_digital: 'Xbox Series X|S',
        platform_id: 'xbox',
        platform_cookie: 'xbox',
        digitalOnly: false,
        retailUsaOnly: true,
    },
    {
        platform_name: 'Steam',
        platform_name_digital: 'Steam',
        platform_id: 'steam',
        platform_cookie: 'steam',
        digitalOnly: true,
        retailUsaOnly: false,
    },
];
exports.purchaseLinks = {
    en: {
        switch: {
            digital: {
                digitalStandard: {
                    name: 'Nintendo eShop',
                    link: 'https://www.nintendo.com/us/store/products/daemon-x-machina-titanic-scion-switch-2/',
                },
                digitalDeluxe: {
                    name: 'Nintendo eShop',
                    link: 'https://www.nintendo.com/us/store/products/daemon-x-machina-titanic-scion-digital-deluxe-edition-switch-2/',
                },
                digitalSuper: {
                    name: 'Nintendo eShop',
                    link: 'https://www.nintendo.com/us/store/products/daemon-x-machina-titanic-scion-super-digital-deluxe-edition-switch-2/',
                },
            },
            physical: {
                physicalLimited: [
                    {
                        name: 'Marvelous USA',
                        link: 'https://marvelous-usa.com/product/daemon-x-machina-titanic-scion/',
                    },
                    {
                        name: 'Amazon',
                        link: 'https://www.amazon.com/Machina-Titanic-Limited-Nintendo-Switch-2/dp/B0F3KJKKDT/ref=sr_1_1?crid=3FNGCWET3G7KH&dib=eyJ2IjoiMSJ9.GmHfH2i5jMys88MILWZqTCnMDJfyA4H9Mj-Zbm8JyVXoHzhTd9P94tgQ53MRXbFrNaUy3wYK03cb-sJ5Nq6xCw6oq4kjncyzdtpbdBMkkCRKat0jVBlB4lTqmgnOXznveVN2XYGOYN3XwsZ7GPk8SNgSQxT4XUis0fEzGFHBJv3AvH_aH2yNd3wpSWQ5r2NuV5lkn1ublO8ZHg3AjkU2zQ.7XJawSqoAoWfn5m7o8rWmPxfD-DFtwk5CByZ6FCRDsM&dib_tag=se&keywords=daemon+x+machina+titanic+scion&qid=1744045384&sprefix=daemon+x+machina+titan%2Caps%2C147&sr=8-1/',
                    },
                    {
                        name: 'Best Buy',
                        link: 'https://www.bestbuy.com/site/daemon-x-machina-titanic-scion-limited-edition-nintendo-switch-2/6628391.p?skuId=6628391',
                    },
                    {
                        name: 'Target',
                        link: 'https://www.target.com/p/daemon-x-machina-titanic-scion-limited-edition-nintendo-switch-2/-/A-94711028#lnk=sametab',
                    },
                    {
                        name: 'GameStop',
                        link: 'https://www.gamestop.com/video-games/nintendo-switch-2/products/daemon-x-machina-titanic-scion---limited-edition---nintendo-switch-2/425008.html',
                    },
                    {
                        name: 'Walmart',
                        link: 'https://www.walmart.com/ip/Daemon-X-Machina-Titanic-Scion-Limited-Edition-Nintendo-Switch-2/15913916155?classType=REGULAR&athbdg=L1102&from=/search',
                    },
                ],
                physicalStandard: [
                    {
                        name: 'Marvelous USA',
                        link: 'https://marvelous-usa.com/product/daemon-x-machina-titanic-scion/',
                    },
                    {
                        name: 'Amazon',
                        link: 'https://www.amazon.com/Machina-Titanic-Standard-Nintendo-Switch-2/dp/B0F3KWPW56/ref=sr_1_12?crid=3FNGCWET3G7KH&dib=eyJ2IjoiMSJ9.GmHfH2i5jMys88MILWZqTCnMDJfyA4H9Mj-Zbm8JyVXoHzhTd9P94tgQ53MRXbFrNaUy3wYK03cb-sJ5Nq6xCw6oq4kjncyzdtpbdBMkkCRKat0jVBlB4lTqmgnOXznveVN2XYGOYN3XwsZ7GPk8SNgSQxT4XUis0fEzGFHBJv3AvH_aH2yNd3wpSWQ5r2NuV5lkn1ublO8ZHg3AjkU2zQ.7XJawSqoAoWfn5m7o8rWmPxfD-DFtwk5CByZ6FCRDsM&dib_tag=se&keywords=daemon+x+machina+titanic+scion&qid=1744045384&sprefix=daemon+x+machina+titan%2Caps%2C147&sr=8-12',
                    },
                    {
                        name: 'Best Buy',
                        link: 'https://www.bestbuy.com/site/daemon-x-machina-titanic-scion-nintendo-switch-2/6628388.p?skuId=6628388',
                    },
                    {
                        name: 'Target',
                        link: 'https://www.target.com/p/daemon-x-machina-titanic-scion-nintendo-switch-2/-/A-94711031#lnk=sametab',
                    },
                    {
                        name: 'GameStop',
                        link: 'https://www.gamestop.com/video-games/nintendo-switch-2/products/daemon-x-machina-titanic-scion---nintendo-switch-2/425001.html',
                    },
                    {
                        name: 'Walmart',
                        link: 'https://www.walmart.com/ip/Daemon-X-Machina-Titanic-Scion-Nintendo-Switch-2/15991860811?classType=REGULAR&from=/search',
                    },
                ],
            },
        },
        ps5: {
            digital: {
                digitalStandard: {
                    name: 'PlayStation Store',
                    link: 'https://store.playstation.com/en-us/product/UP1023-PPSA29154_00-DXMTSFULLGAME000',
                },
                digitalDeluxe: {
                    name: 'PlayStation Store',
                    link: 'https://store.playstation.com/en-us/product/UP1023-PPSA29154_00-DXMTSDELUXE00000',
                },
                digitalSuper: {
                    name: 'PlayStation Store',
                    link: 'https://store.playstation.com/en-us/product/UP1023-PPSA29154_00-DXMTSPREDELUXE00',
                },
            },
            physical: {
                physicalLimited: [
                    {
                        name: 'Marvelous USA',
                        link: 'https://marvelous-usa.com/product/daemon-x-machina-titanic-scion/',
                    },
                    {
                        name: 'Amazon',
                        link: 'https://www.amazon.com/Daemon-Machina-Titanic-Limited-PlayStation-5/dp/B0F3KM2Q8L/ref=sr_1_11?crid=3FNGCWET3G7KH&dib=eyJ2IjoiMSJ9.GmHfH2i5jMys88MILWZqTCnMDJfyA4H9Mj-Zbm8JyVXoHzhTd9P94tgQ53MRXbFrNaUy3wYK03cb-sJ5Nq6xCw6oq4kjncyzdtpbdBMkkCRKat0jVBlB4lTqmgnOXznveVN2XYGOYN3XwsZ7GPk8SNgSQxT4XUis0fEzGFHBJv3AvH_aH2yNd3wpSWQ5r2NuV5lkn1ublO8ZHg3AjkU2zQ.7XJawSqoAoWfn5m7o8rWmPxfD-DFtwk5CByZ6FCRDsM&dib_tag=se&keywords=daemon+x+machina+titanic+scion&qid=1744045384&sprefix=daemon+x+machina+titan%2Caps%2C147&sr=8-11',
                    },
                    {
                        name: 'Best Buy',
                        link: 'https://www.bestbuy.com/site/daemon-x-machina-titanic-scion-limited-edition-playstation-5/6628392.p?skuId=6628392',
                    },
                    {
                        name: 'Target',
                        link: 'https://www.target.com/p/daemon-x-machina-titanic-scion-limited-edition-playstation-5/-/A-94711034#lnk=sametab',
                    },
                    {
                        name: 'GameStop',
                        link: 'https://www.gamestop.com/video-games/playstation-5/products/daemon-x-machina-titanic-scion---limited-edition---playstation-5/425006.html',
                    },
                    {
                        name: 'Walmart',
                        link: 'https://www.walmart.com/ip/Daemon-X-Machina-Titanic-Scion-Limited-Edition-PlayStation-5/15974370903?classType=REGULAR&from=/search',
                    },
                ],
                physicalStandard: [
                    {
                        name: 'Marvelous USA',
                        link: 'https://marvelous-usa.com/product/daemon-x-machina-titanic-scion/',
                    },
                    {
                        name: 'Amazon',
                        link: 'https://www.amazon.com/dp/B0F3Y142HG/ref=sr_1_14?crid=36J5V01ZQFH5E&dib=eyJ2IjoiMSJ9.99se2pik4USTBTlrytH09ns-U1mO9SUwgG4Ak-K9KTBI0IjuwrlYtI_5HKDQM6-kP61cUfuDZt-mJ8WKW703kUEPCBXPnlQ2H681EXbk-VWKN0SevmiUsRqU7QmKr7wR5UKiKhfs2u0dvBwX-L_sNKaX0P3gbeOBhS1SJx4xVH8i6bp0PHeuEeOaIcn_wv5OF9RGrtpmWguyGP9EsKnVQtHC_sfKDW66VKb0nlalGPs.zTK1rM8uoD_GuWZZZvPFSVTthoerXzFgh8lGNwozdV8&dib_tag=se&keywords=Daemon+X+Machina&qid=1744048915&sprefix=daemon+x+machi%2Caps%2C678&sr=8-14',
                    },
                    {
                        name: 'Best Buy',
                        link: 'https://www.bestbuy.com/site/daemon-x-machina-titanic-scion-playstation-5/6628396.p?skuId=6628396',
                    },
                    {
                        name: 'Target',
                        link: 'https://www.target.com/p/daemon-x-machina-titanic-scion-playstation-5/-/A-94711029#lnk=sametab',
                    },
                    {
                        name: 'GameStop',
                        link: 'https://www.gamestop.com/video-games/playstation-5/products/daemon-x-machina-titanic-scion---playstation-5/425000.html',
                    },
                    {
                        name: 'Walmart',
                        link: 'https://www.walmart.com/ip/Daemon-X-Machina-Titanic-Scion-PlayStation-5/15975611958?classType=REGULAR&from=/search',
                    },
                ],
            },
        },
        xbox: {
            digital: {
                digitalStandard: {
                    name: 'Microsoft Store',
                    link: 'https://www.xbox.com/en-us/games/store/daemon-x-machina-titanic-scion/9N43XQB60804',
                },
                digitalDeluxe: {
                    name: 'Microsoft Store',
                    link: 'https://www.xbox.com/en-US/games/store/daemon-x-machina-titanic-scion-digital-deluxe-edition/9PG3JS5ZDJCH',
                },
                digitalSuper: {
                    name: 'Microsoft Store',
                    link: 'https://www.xbox.com/en-US/games/store/daemon-x-machina-titanic-scion-super-digital-deluxe-edition/9P6MGWZD71N9',
                },
            },
            physical: {
                physicalLimited: [
                    {
                        name: 'Marvelous USA',
                        link: 'https://marvelous-usa.com/product/daemon-x-machina-titanic-scion/',
                    },
                    {
                        name: 'Amazon',
                        link: 'https://www.amazon.com/Daemon-Machina-Titanic-Limited-Xbox-X/dp/B0F3KVN6TY/ref=sr_1_3?crid=3FNGCWET3G7KH&dib=eyJ2IjoiMSJ9.GmHfH2i5jMys88MILWZqTCnMDJfyA4H9Mj-Zbm8JyVXoHzhTd9P94tgQ53MRXbFrNaUy3wYK03cb-sJ5Nq6xCw6oq4kjncyzdtpbdBMkkCRKat0jVBlB4lTqmgnOXznveVN2XYGOYN3XwsZ7GPk8SNgSQxT4XUis0fEzGFHBJv3AvH_aH2yNd3wpSWQ5r2NuV5lkn1ublO8ZHg3AjkU2zQ.7XJawSqoAoWfn5m7o8rWmPxfD-DFtwk5CByZ6FCRDsM&dib_tag=se&keywords=daemon+x+machina+titanic+scion&qid=1744045384&sprefix=daemon+x+machina+titan%2Caps%2C147&sr=8-3',
                    },
                    {
                        name: 'Best Buy',
                        link: 'https://www.bestbuy.com/site/daemon-x-machina-titanic-scion-limited-edition-xbox-series-x/6628395.p?skuId=6628395',
                    },
                    {
                        name: 'Target',
                        link: 'https://www.target.com/p/daemon-x-machina-titanic-scion-limited-edition-xbox-series-x/-/A-94711032#lnk=sametab',
                    },
                    {
                        name: 'GameStop',
                        link: 'https://www.gamestop.com/video-games/xbox-series-x%7Cs/products/daemon-x-machina-titanic-scion---limited-edition---xbox-series-x/425010.html',
                    },
                    {
                        name: 'Walmart',
                        link: 'https://www.walmart.com/ip/Daemon-X-Machina-Titanic-Scion-Limited-Edition-Xbox-Series-X/15962058251?classType=REGULAR&from=/search',
                    },
                ],
                physicalStandard: [
                    {
                        name: 'Marvelous USA',
                        link: 'https://marvelous-usa.com/product/daemon-x-machina-titanic-scion/',
                    },
                    {
                        name: 'Amazon',
                        link: 'https://www.amazon.com/Daemon-Machina-Titanic-Standard-Xbox-X/dp/B0F3JWV5HB/ref=sr_1_4?crid=3FNGCWET3G7KH&dib=eyJ2IjoiMSJ9.GmHfH2i5jMys88MILWZqTCnMDJfyA4H9Mj-Zbm8JyVXoHzhTd9P94tgQ53MRXbFrNaUy3wYK03cb-sJ5Nq6xCw6oq4kjncyzdtpbdBMkkCRKat0jVBlB4lTqmgnOXznveVN2XYGOYN3XwsZ7GPk8SNgSQxT4XUis0fEzGFHBJv3AvH_aH2yNd3wpSWQ5r2NuV5lkn1ublO8ZHg3AjkU2zQ.7XJawSqoAoWfn5m7o8rWmPxfD-DFtwk5CByZ6FCRDsM&dib_tag=se&keywords=daemon+x+machina+titanic+scion&qid=1744045384&sprefix=daemon+x+machina+titan%2Caps%2C147&sr=8-4',
                    },
                    {
                        name: 'Best Buy',
                        link: 'https://www.bestbuy.com/site/daemon-x-machina-titanic-scion-xbox-series-x/6628390.p?skuId=6628390',
                    },
                    {
                        name: 'Target',
                        link: 'https://www.target.com/p/daemon-x-machina-titanic-scion-xbox-series-x/-/A-94711030#lnk=sametab',
                    },
                    {
                        name: 'GameStop',
                        link: 'https://www.gamestop.com/video-games/xbox-series-x%7Cs/products/daemon-x-machina-titanic-scion---xbox-series-x/425002.html',
                    },
                    {
                        name: 'Walmart',
                        link: 'https://www.walmart.com/ip/Daemon-X-Machina-Titanic-Scion-Xbox-Series-X/15934573115?classType=REGULAR&from=/search',
                    },
                ],
            },
        },
        steam: {
            digital: {
                digitalStandard: {
                    name: 'steam',
                    link: 'https://store.steampowered.com/app/1342490/Daemon_X_Machina_Titanic_Scion/',
                },
                digitalDeluxe: {
                    name: 'steam',
                    link: 'https://store.steampowered.com/app/1342490/Daemon_X_Machina_Titanic_Scion/',
                },
                digitalSuper: {
                    name: 'steam',
                    link: 'https://store.steampowered.com/app/1342490/Daemon_X_Machina_Titanic_Scion/',
                },
            },
        },
    },
    ca: {
        switch: {
            digital: {
                digitalStandard: {
                    name: 'Nintendo eShop',
                    link: 'https://www.nintendo.com/en-ca/store/products/daemon-x-machina-titanic-scion-switch-2/',
                },
                digitalDeluxe: {
                    name: 'Nintendo eShop',
                    link: 'https://www.nintendo.com/en-ca/store/products/daemon-x-machina-titanic-scion-digital-deluxe-edition-switch-2/',
                },
                digitalSuper: {
                    name: 'Nintendo eShop',
                    link: 'https://www.nintendo.com/en-ca/store/products/daemon-x-machina-titanic-scion-super-digital-deluxe-edition-switch-2/',
                },
            },
            physical: {
                physicalLimited: [
                    {
                        name: 'GameStop CA',
                        link: 'https://www.gamestop.ca/Switch%202/Games/935988/daemon-x-machina-titanic-scion-limited-edition',
                    },
                    {
                        name: 'Amazon CA',
                        link: 'https://www.amazon.ca/Daemon-Machina-Titanic-Limited-Nintendo/dp/B0F3KJKKDT/ref=sr_1_7?crid=3M8ZRJE0LDBR0&dib=eyJ2IjoiMSJ9.7X9jkq5vRsWOYIcpSRrXmW5fL7EsS1sqRmDOOLN489trqy8ybyqdYUcKvMQJFTDpH8sNDlBZ5l-CTahXM4jhCLAt6qaMkr9g-GPuM3MVL4TszEoEouch5RoDh7kFMV3Um6XLiqdqkSitEPZ_Kw1nbPlH5GJwPruerunwSTwhH0UEec3gS37kwx4FA-aGKjdGPEOR05ZiELhR33m0E-Ef4pAeb-jI8TVAX3ssB-Ev0xDGkFwQSVAoNXe_2GvqPsUbw3plKwtpUaaZppikYRKpfMqYaklUbvTwyj0vZO9yIe4.cesT7RJS5dWPdajCyw0ctw4ZliMYOMgE4JX6GVyTO8o&dib_tag=se&keywords=daemon+x+machina&qid=1745518648&sprefix=daemon+x+,aps,165&sr=8-7',
                    },
                ],
                physicalStandard: [
                    {
                        name: 'GameStop CA',
                        link: 'https://www.gamestop.ca/Switch%202/Games/935989/daemon-x-machina-titanic-scion',
                    },
                ],
            },
        },
        ps5: {
            digital: {
                digitalStandard: {
                    name: 'PlayStation Store',
                    link: 'https://store.playstation.com/en-ca/product/UP1023-PPSA29154_00-DXMTSFULLGAME000',
                },
                digitalDeluxe: {
                    name: 'PlayStation Store',
                    link: 'https://store.playstation.com/en-ca/product/UP1023-PPSA29154_00-DXMTSDELUXE00000',
                },
                digitalSuper: {
                    name: 'PlayStation Store',
                    link: 'https://store.playstation.com/en-ca/product/UP1023-PPSA29154_00-DXMTSPREDELUXE00',
                },
            },
            physical: {
                physicalLimited: [
                    {
                        name: 'GameStop CA',
                        link: 'https://www.gamestop.ca/PS5/Games/935986/daemon-x-machina-titanic-scion-limited-edition',
                    },
                    {
                        name: 'Amazon CA',
                        link: 'https://www.amazon.ca/Daemon-Machina-Titanic-Scion-Limited/dp/B0F3KM2Q8L/ref=sr_1_1?crid=3M8ZRJE0LDBR0&dib=eyJ2IjoiMSJ9.7X9jkq5vRsWOYIcpSRrXmW5fL7EsS1sqRmDOOLN489trqy8ybyqdYUcKvMQJFTDpH8sNDlBZ5l-CTahXM4jhCLAt6qaMkr9g-GPuM3MVL4TszEoEouch5RoDh7kFMV3Um6XLiqdqkSitEPZ_Kw1nbPlH5GJwPruerunwSTwhH0UEec3gS37kwx4FA-aGKjdGPEOR05ZiELhR33m0E-Ef4pAeb-jI8TVAX3ssB-Ev0xDGkFwQSVAoNXe_2GvqPsUbw3plKwtpUaaZppikYRKpfMqYaklUbvTwyj0vZO9yIe4.cesT7RJS5dWPdajCyw0ctw4ZliMYOMgE4JX6GVyTO8o&dib_tag=se&keywords=daemon+x+machina&qid=1745518648&sprefix=daemon+x+,aps,165&sr=8-1',
                    },
                ],
                physicalStandard: [
                    {
                        name: 'GameStop CA',
                        link: 'https://www.gamestop.ca/PS5/Games/935987/daemon-x-machina-titanic-scion',
                    },
                    {
                        name: 'Amazon CA',
                        link: 'https://www.amazon.ca/Daemon-Machina-Titanic-Scion-Standard/dp/B0F3Y142HG/ref=sr_1_2?crid=3M8ZRJE0LDBR0&dib=eyJ2IjoiMSJ9.7X9jkq5vRsWOYIcpSRrXmW5fL7EsS1sqRmDOOLN489trqy8ybyqdYUcKvMQJFTDpH8sNDlBZ5l-CTahXM4jhCLAt6qaMkr9g-GPuM3MVL4TszEoEouch5RoDh7kFMV3Um6XLiqdqkSitEPZ_Kw1nbPlH5GJwPruerunwSTwhH0UEec3gS37kwx4FA-aGKjdGPEOR05ZiELhR33m0E-Ef4pAeb-jI8TVAX3ssB-Ev0xDGkFwQSVAoNXe_2GvqPsUbw3plKwtpUaaZppikYRKpfMqYaklUbvTwyj0vZO9yIe4.cesT7RJS5dWPdajCyw0ctw4ZliMYOMgE4JX6GVyTO8o&dib_tag=se&keywords=daemon%2Bx%2Bmachina&qid=1745518648&sprefix=daemon%2Bx%2B%2Caps%2C165&sr=8-2&th=1',
                    },
                ],
            },
        },
        xbox: {
            digital: {
                digitalStandard: {
                    name: 'Microsoft Store',
                    link: 'https://www.xbox.com/en-CA/games/store/daemon-x-machina-titanic-scion/9N43XQB60804',
                },
                digitalDeluxe: {
                    name: 'Microsoft Store',
                    link: 'https://www.xbox.com/en-CA/games/store/daemon-x-machina-titanic-scion-digital-deluxe-edition/9PG3JS5ZDJCH',
                },
                digitalSuper: {
                    name: 'Microsoft Store',
                    link: 'https://www.xbox.com/en-CA/games/store/daemon-x-machina-titanic-scion-super-digital-deluxe-edition/9P6MGWZD71N9',
                },
            },
            physical: {
                physicalLimited: [
                    {
                        name: 'GameStop CA',
                        link: 'https://www.gamestop.ca/Xbox%20Series%20X/Games/935985/daemon-x-machina-titanic-scion-limited-edition',
                    },
                    {
                        name: 'Amazon CA',
                        link: 'https://www.amazon.ca/Daemon-Machina-Titanic-Scion-Limited/dp/B0F3KVN6TY/ref=sr_1_2?crid=2ALICZCW8X04U&dib=eyJ2IjoiMSJ9._cJTjQKZi4iCMMAQh_CA2zpamVjRZRLZk0ngt7ip0kDGjHj071QN20LucGBJIEps.W0q4jUnAxiDWtuQpxYhPDEK3dR1W2FBx9enVSEvV9mg&dib_tag=se&keywords=daemon+x+machina+xbox&qid=1745518732&sprefix=daemon+x+machina+xbo,aps,136&sr=8-2',
                    },
                ],
                physicalStandard: [
                    {
                        name: 'GameStop CA',
                        link: 'https://www.gamestop.ca/Xbox%20Series%20X/Games/935984/daemon-x-machina-titanic-scion',
                    },
                    {
                        name: 'Amazon CA',
                        link: 'https://www.amazon.ca/Daemon-Machina-Titanic-Scion-Standard/dp/B0F3JWV5HB/ref=sr_1_1?crid=224ASMA11RPWP&dib=eyJ2IjoiMSJ9._cJTjQKZi4iCMMAQh_CA22D6kgPX1MP9TPvIZdAN02s.VdtZISubQL4RPRI-mPn3Q6ggw3adjxxrCXs6cZG8hho&dib_tag=se&keywords=Daemon+X+Machina+Titanic+Scion+Standard+Edition+-+Xbox+Series+X&qid=1745518708&sprefix=daemon+x+machina+titanic+scion+standard+edition+-+xbox+series+x,aps,225&sr=8-1',
                    },
                ],
            },
        },
        steam: {
            digital: {
                digitalStandard: {
                    name: 'steam',
                    link: 'https://store.steampowered.com/app/1342490/Daemon_X_Machina_Titanic_Scion/',
                },
                digitalDeluxe: {
                    name: 'steam',
                    link: 'https://store.steampowered.com/app/1342490/Daemon_X_Machina_Titanic_Scion/',
                },
                digitalSuper: {
                    name: 'steam',
                    link: 'https://store.steampowered.com/app/1342490/Daemon_X_Machina_Titanic_Scion/',
                },
            },
        },
    },
    uk: {
        switch: {
            digital: {
                digitalStandard: {
                    name: 'Nintendo eShop',
                    link: 'https://www.nintendo.com/en-gb/Games/Nintendo-Switch-2-games/Daemon-X-Machina-Titanic-Scion-2849025.html?s=countries',
                },
                digitalDeluxe: {
                    name: 'Nintendo eShop',
                    link: 'https://www.nintendo.com/en-gb/Games/Nintendo-Switch-2-games/Daemon-X-Machina-Titanic-Scion-2849025.html?s=countries&nsuid=70070000028510#Digital_Deluxe_Edition',
                },
                digitalSuper: {
                    name: 'Nintendo eShop',
                    link: 'https://www.nintendo.com/en-gb/Games/Nintendo-Switch-2-games/Daemon-X-Machina-Titanic-Scion-2849025.html?s=countries&nsuid=70070000028516#Super_Digital_Deluxe_Edition',
                },
            },
            physical: {
                physicalLimited: [
                    {
                        name: 'Amazon',
                        link: 'https://www.amazon.co.uk/Daemon-Machina-Titanic-Limited-Switch/dp/B0F3DPNWKS/',
                    },
                ],
                physicalStandard: [
                    {
                        name: 'Amazon',
                        link: 'https://www.amazon.co.uk/Daemon-Machina-Titanic-Scion-Switch/dp/B0F3DPTQT3/',
                    },
                    {
                        name: 'GAME',
                        link: 'https://www.game.co.uk/u-and-i-entertainment-daemon-x-machina-titanic-scion-940588',
                    },
                    {
                        name: 'Argos',
                        link: 'https://www.argos.co.uk/product/7618653',
                    },
                ],
            },
        },
        ps5: {
            digital: {
                digitalStandard: {
                    name: 'PlayStation Store',
                    link: 'https://store.playstation.com/product/EP4492-PPSA29136_00-DXMTSFULLGAME000',
                },
                digitalDeluxe: {
                    name: 'PlayStation Store',
                    link: 'https://store.playstation.com/product/EP4492-PPSA29136_00-DXMTSDELUXE00000',
                },
                digitalSuper: {
                    name: 'PlayStation Store',
                    link: 'https://store.playstation.com/product/EP4492-PPSA29136_00-DXMTSPREDELUXE00',
                },
            },
            physical: {
                physicalLimited: [],
                physicalStandard: [
                    {
                        name: 'Amazon',
                        link: 'https://www.amazon.co.uk/Daemon-Machina-Titanic-Scion-PS5/dp/B0F3KT4FNS',
                    },
                    {
                        name: 'GAME',
                        link: 'https://www.game.co.uk/marvelous-games-daemon-x-machina-titanic-scion-720271#colcode=72027169',
                    },
                    {
                        name: 'Argos',
                        link: 'https://www.argos.co.uk/product/7618646',
                    },
                ],
            },
        },
        xbox: {
            digital: {
                digitalStandard: {
                    name: 'Microsoft Store',
                    link: 'https://www.xbox.com/games/store/daemon-x-machina-titanic-scion/9MSTS8GMBR8P',
                },
                digitalDeluxe: {
                    name: 'Microsoft Store',
                    link: 'https://www.xbox.com/games/store/daemon-x-machina-titanic-scion-digital-deluxe-edition/9PFWGSJWV60W',
                },
                digitalSuper: {
                    name: 'Microsoft Store',
                    link: 'https://www.xbox.com/games/store/daemon-x-machina-titanic-scion-super-digital-deluxe-edition/9NHX85JHNBL5',
                },
            },
            physical: {
                physicalLimited: [],
                physicalStandard: [
                    {
                        name: 'Amazon',
                        link: 'https://www.amazon.co.uk/Daemon-Machina-Titanic-Scion-Xbox/dp/B0F3KSZ3B2/',
                    },
                    {
                        name: 'GAME',
                        link: 'https://www.game.co.uk/marvelous-games-daemon-x-machina-titanic-scion-430412#colcode=43041269',
                    },
                    {
                        name: 'Argos',
                        link: 'https://www.argos.co.uk/product/7618639',
                    },
                ],
            },
        },
        steam: {
            digital: {
                digitalStandard: {
                    name: 'steam',
                    link: 'https://store.steampowered.com/app/1342490/Daemon_X_Machina_Titanic_Scion/',
                },
                digitalDeluxe: {
                    name: 'steam',
                    link: 'https://store.steampowered.com/app/1342490/Daemon_X_Machina_Titanic_Scion/',
                },
                digitalSuper: {
                    name: 'steam',
                    link: 'https://store.steampowered.com/app/1342490/Daemon_X_Machina_Titanic_Scion/',
                },
            },
        },
    },
    fr: {
        switch: {
            digital: {
                digitalStandard: {
                    name: 'Nintendo eShop',
                    link: 'https://www.nintendo.com/en-gb/Games/Nintendo-Switch-2-games/Daemon-X-Machina-Titanic-Scion-2849025.html?s=countries',
                },
                digitalDeluxe: {
                    name: 'Nintendo eShop',
                    link: 'https://www.nintendo.com/en-gb/Games/Nintendo-Switch-2-games/Daemon-X-Machina-Titanic-Scion-2849025.html?s=countries&nsuid=70070000028510#Digital_Deluxe_Edition',
                },
                digitalSuper: {
                    name: 'Nintendo eShop',
                    link: 'https://www.nintendo.com/en-gb/Games/Nintendo-Switch-2-games/Daemon-X-Machina-Titanic-Scion-2849025.html?s=countries&nsuid=70070000028516#Super_Digital_Deluxe_Edition',
                },
            },
            physical: {
                physicalLimited: [
                    {
                        name: 'Amazon',
                        link: 'https://www.amazon.fr/dp/B0F3DPNWKS/',
                    },
                    {
                        name: 'Fnac',
                        link: 'https://www.fnac.com/a21521231/Daemon-X-Machina-Titanic-Scion-Limited-Edition-Nintendo-Switch-2-Jeu-video-Nintendo-Switch-2',
                    },
                    {
                        name: 'Micromania',
                        link: 'https://www.micromania.fr/daemon-x-machina-titanic-scion-limited-edition-149503.html',
                    },
                ],
                physicalStandard: [
                    {
                        name: 'Amazon',
                        link: 'https://www.amazon.fr/dp/B0F3DQ7J33/',
                    },
                    {
                        name: 'Fnac',
                        link: 'https://www.fnac.com/a21521232/Daemon-X-Machina-Titanic-Scion-Nintendo-Switch-2-Jeu-video-Nintendo-Switch-2',
                    },
                    {
                        name: 'Micromania',
                        link: 'https://www.micromania.fr/daemon-x-machina-titanic-scion-149501.html',
                    },
                ],
            },
        },
        ps5: {
            digital: {
                digitalStandard: {
                    name: 'PlayStation Store',
                    link: 'https://store.playstation.com/product/EP4492-PPSA29136_00-DXMTSFULLGAME000',
                },
                digitalDeluxe: {
                    name: 'PlayStation Store',
                    link: 'https://store.playstation.com/product/EP4492-PPSA29136_00-DXMTSDELUXE00000',
                },
                digitalSuper: {
                    name: 'PlayStation Store',
                    link: 'https://store.playstation.com/product/EP4492-PPSA29136_00-DXMTSPREDELUXE00',
                },
            },
            physical: {
                physicalLimited: [],
                physicalStandard: [
                    {
                        name: 'Amazon',
                        link: 'https://www.amazon.fr/Daemon-Machina-Titanic-Limited-Switch/dp/B0F3KDRGNB/?th=1',
                    },
                    {
                        name: 'Fnac',
                        link: 'https://www.fnac.com/a21501238/Daemon-X-Machina-Titanic-Scion-PS5-Jeu-video-Playstation-5',
                    },
                    {
                        name: 'Micromania',
                        link: 'https://www.micromania.fr/daemon-x-machina-titanic-scion-150058.html',
                    },
                    {
                        name: 'Carrefour',
                        link: 'https://www.carrefour.fr/p/daemon-x-machina-titanic-scion-ps5-5060540773012?s=2471',
                    },
                ],
            },
        },
        xbox: {
            digital: {
                digitalStandard: {
                    name: 'Microsoft Store',
                    link: 'https://www.xbox.com/games/store/daemon-x-machina-titanic-scion/9MSTS8GMBR8P',
                },
                digitalDeluxe: {
                    name: 'Microsoft Store',
                    link: 'https://www.xbox.com/games/store/daemon-x-machina-titanic-scion-digital-deluxe-edition/9PFWGSJWV60W',
                },
                digitalSuper: {
                    name: 'Microsoft Store',
                    link: 'https://www.xbox.com/games/store/daemon-x-machina-titanic-scion-super-digital-deluxe-edition/9NHX85JHNBL5',
                },
            },
            physical: {
                physicalLimited: [],
                physicalStandard: [
                    {
                        name: 'Fnac',
                        link: 'https://www.fnac.com/a21501239/Daemon-X-Machina-Titanic-Scion-Xbox-Series-X-Jeu-video-Xbox-Series',
                    },
                    {
                        name: 'Micromania',
                        link: 'https://www.micromania.fr/daemon-x-machina-titanic-scion-150060.html',
                    },
                    {
                        name: 'Amazon',
                        link: 'https://www.amazon.fr/Daemon-Machina-Titanic-Limited-Switch/dp/B0F3KSZ3B2/?th=1',
                    },
                ],
            },
        },
        steam: {
            digital: {
                digitalStandard: {
                    name: 'steam',
                    link: 'https://store.steampowered.com/app/1342490/Daemon_X_Machina_Titanic_Scion/',
                },
                digitalDeluxe: {
                    name: 'steam',
                    link: 'https://store.steampowered.com/app/1342490/Daemon_X_Machina_Titanic_Scion/',
                },
                digitalSuper: {
                    name: 'steam',
                    link: 'https://store.steampowered.com/app/1342490/Daemon_X_Machina_Titanic_Scion/',
                },
            },
        },
    },
    de: {
        switch: {
            digital: {
                digitalStandard: {
                    name: 'Nintendo eShop',
                    link: 'https://www.nintendo.com/en-gb/Games/Nintendo-Switch-2-games/Daemon-X-Machina-Titanic-Scion-2849025.html?s=countries',
                },
                digitalDeluxe: {
                    name: 'Nintendo eShop',
                    link: 'https://www.nintendo.com/en-gb/Games/Nintendo-Switch-2-games/Daemon-X-Machina-Titanic-Scion-2849025.html?s=countries&nsuid=70070000028510#Digital_Deluxe_Edition',
                },
                digitalSuper: {
                    name: 'Nintendo eShop',
                    link: 'https://www.nintendo.com/en-gb/Games/Nintendo-Switch-2-games/Daemon-X-Machina-Titanic-Scion-2849025.html?s=countries&nsuid=70070000028516#Super_Digital_Deluxe_Edition',
                },
            },
            physical: {
                physicalLimited: [
                    {
                        name: 'Amazon',
                        link: 'https://www.amazon.de/Daemon-Machina-Titanic-Limited-Switch/dp/B0F3DQ6K68/',
                    },
                ],
                physicalStandard: [
                    {
                        name: 'Amazon',
                        link: 'https://www.amazon.de/Daemon-Machina-Titanic-Scion-Switch/dp/B0F3DNF7C3',
                    },
                ],
            },
        },
        ps5: {
            digital: {
                digitalStandard: {
                    name: 'PlayStation Store',
                    link: 'https://store.playstation.com/product/EP4492-PPSA29136_00-DXMTSFULLGAME000',
                },
                digitalDeluxe: {
                    name: 'PlayStation Store',
                    link: 'https://store.playstation.com/product/EP4492-PPSA29136_00-DXMTSDELUXE00000',
                },
                digitalSuper: {
                    name: 'PlayStation Store',
                    link: 'https://store.playstation.com/product/EP4492-PPSA29136_00-DXMTSPREDELUXE00',
                },
            },
            physical: {
                physicalLimited: [],
                physicalStandard: [
                    {
                        name: 'Amazon',
                        link: 'https://www.amazon.de/dp/B0F3KNNDWY/',
                    },
                    {
                        name: 'MediaMarkt',
                        link: 'https://www.mediamarkt.de/de/product/_daemon-x-machina-titanic-scion-playstation-5-2992465.html',
                    },
                    {
                        name: 'Saturn',
                        link: 'https://www.saturn.de/de/product/_daemon-x-machina-titanic-scion-playstation-5-2992465.html',
                    },
                ],
            },
        },
        xbox: {
            digital: {
                digitalStandard: {
                    name: 'Microsoft Store',
                    link: 'https://www.xbox.com/games/store/daemon-x-machina-titanic-scion/9MSTS8GMBR8P',
                },
                digitalDeluxe: {
                    name: 'Microsoft Store',
                    link: 'https://www.xbox.com/games/store/daemon-x-machina-titanic-scion-digital-deluxe-edition/9PFWGSJWV60W',
                },
                digitalSuper: {
                    name: 'Microsoft Store',
                    link: 'https://www.xbox.com/games/store/daemon-x-machina-titanic-scion-super-digital-deluxe-edition/9NHX85JHNBL5',
                },
            },
            physical: {
                physicalLimited: [],
                physicalStandard: [
                    {
                        name: 'Amazon',
                        link: 'https://www.amazon.de/dp/B0F3L6B3GR/',
                    },
                    {
                        name: 'MediaMarkt',
                        link: 'https://www.mediamarkt.de/de/product/_daemon-x-machina-titanic-scion-xbox-series-x-2992466.html',
                    },
                    {
                        name: 'Saturn',
                        link: 'https://www.saturn.de/de/product/_daemon-x-machina-titanic-scion-xbox-series-x-2992466.html',
                    },
                ],
            },
        },
        steam: {
            digital: {
                digitalStandard: {
                    name: 'steam',
                    link: 'https://store.steampowered.com/app/1342490/Daemon_X_Machina_Titanic_Scion/',
                },
                digitalDeluxe: {
                    name: 'steam',
                    link: 'https://store.steampowered.com/app/1342490/Daemon_X_Machina_Titanic_Scion/',
                },
                digitalSuper: {
                    name: 'steam',
                    link: 'https://store.steampowered.com/app/1342490/Daemon_X_Machina_Titanic_Scion/',
                },
            },
        },
    },
    es: {
        switch: {
            digital: {
                digitalStandard: {
                    name: 'Nintendo eShop',
                    link: 'https://www.nintendo.com/en-gb/Games/Nintendo-Switch-2-games/Daemon-X-Machina-Titanic-Scion-2849025.html?s=countries',
                },
                digitalDeluxe: {
                    name: 'Nintendo eShop',
                    link: 'https://www.nintendo.com/en-gb/Games/Nintendo-Switch-2-games/Daemon-X-Machina-Titanic-Scion-2849025.html?s=countries&nsuid=70070000028510#Digital_Deluxe_Edition',
                },
                digitalSuper: {
                    name: 'Nintendo eShop',
                    link: 'https://www.nintendo.com/en-gb/Games/Nintendo-Switch-2-games/Daemon-X-Machina-Titanic-Scion-2849025.html?s=countries&nsuid=70070000028516#Super_Digital_Deluxe_Edition',
                },
            },
            physical: {
                physicalLimited: [
                    {
                        name: 'GAME',
                        link: 'https://www.game.es/VIDEOJUEGOS/SIMULADOR/NINTENDO-SWITCH-2/DAEMON-X-MACHINA-TITANIC-SCION-LIMITED-EDITION/243928',
                    },
                ],
                physicalStandard: [
                    {
                        name: 'Xtralife',
                        link: 'https://www.xtralife.com/producto/daemon-x-machina-titanic-scion-switch-2-estandar/79820',
                    },
                    {
                        name: 'GAME',
                        link: 'https://www.game.es/VIDEOJUEGOS/ACCION/NINTENDO-SWITCH-2/DAEMON-X-MACHINA-TITANIC-SCION/243927',
                    },
                    {
                        name: 'Amazon',
                        link: 'https://www.amazon.es/dp/B0F3DNQY4D/',
                    },
                    {
                        name: 'Fnac',
                        link: 'https://www.fnac.es/Daemon-X-Machina-Titanic-Scion-Nintendo-Switch-2-Videojuego-Nintendo-Switch-2/a11866827',
                    },
                    {
                        name: 'MediaMarkt',
                        link: 'https://www.mediamarkt.es/es/product/_nintendo-switch-2-daemon-x-machina-titanic-scion-1598472.html',
                    },
                ],
            },
        },
        ps5: {
            digital: {
                digitalStandard: {
                    name: 'PlayStation Store',
                    link: 'https://store.playstation.com/product/EP4492-PPSA29136_00-DXMTSFULLGAME000',
                },
                digitalDeluxe: {
                    name: 'PlayStation Store',
                    link: 'https://store.playstation.com/product/EP4492-PPSA29136_00-DXMTSDELUXE00000',
                },
                digitalSuper: {
                    name: 'PlayStation Store',
                    link: 'https://store.playstation.com/product/EP4492-PPSA29136_00-DXMTSPREDELUXE00',
                },
            },
            physical: {
                physicalLimited: [],
                physicalStandard: [
                    {
                        name: 'Amazon',
                        link: 'https://www.amazon.es/dp/B0F3KT3NZS/',
                    },
                    {
                        name: 'Xtralife',
                        link: 'https://www.xtralife.com/producto/daemon-x-machina-titanic-scion-ps5-estandar/103615',
                    },
                    {
                        name: 'GAME',
                        link: 'https://www.game.es/VIDEOJUEGOS/ACCION/PLAYSTATION-5/DAEMON-X-MACHINA-TITANIC-SCION/243929',
                    },
                    {
                        name: 'Fnac',
                        link: 'https://www.fnac.es/Daemon-X-Machina-Titanic-Scion-PS5-Videojuego-PS5/a11866826',
                    },
                    {
                        name: 'MediaMarkt',
                        link: 'https://www.mediamarkt.es/es/product/_ps5-daemon-x-machina-titanic-scion-1598471.html',
                    },
                ],
            },
        },
        xbox: {
            digital: {
                digitalStandard: {
                    name: 'Microsoft Store',
                    link: 'https://www.xbox.com/games/store/daemon-x-machina-titanic-scion/9MSTS8GMBR8P',
                },
                digitalDeluxe: {
                    name: 'Microsoft Store',
                    link: 'https://www.xbox.com/games/store/daemon-x-machina-titanic-scion-digital-deluxe-edition/9PFWGSJWV60W',
                },
                digitalSuper: {
                    name: 'Microsoft Store',
                    link: 'https://www.xbox.com/games/store/daemon-x-machina-titanic-scion-super-digital-deluxe-edition/9NHX85JHNBL5',
                },
            },
            physical: {
                physicalLimited: [],
                physicalStandard: [
                    {
                        name: 'Xtralife',
                        link: 'https://www.xtralife.com/producto/daemon-x-machina-titanic-scion-xbox-series-estandar/103701',
                    },
                    {
                        name: 'GAME',
                        link: 'https://www.game.es/VIDEOJUEGOS/ACCION/XBOX-ONE/DAEMON-X-MACHINA-TITANIC-SCION/243930',
                    },
                    {
                        name: 'Amazon',
                        link: 'https://www.amazon.es/dp/B0F3KSZ3B2/',
                    },
                    {
                        name: 'Fnac',
                        link: 'https://www.fnac.es/Daemon-X-Machina-Titanic-Scion-Xbox-Series-X-Videojuego-Xbox-Series/a11866828',
                    },
                    {
                        name: 'MediaMarkt',
                        link: 'https://www.mediamarkt.es/es/product/_xbox-series-x-daemon-x-machina-titanic-scion-1598524.html',
                    },
                ],
            },
        },
        steam: {
            digital: {
                digitalStandard: {
                    name: 'steam',
                    link: 'https://store.steampowered.com/app/1342490/Daemon_X_Machina_Titanic_Scion/',
                },
                digitalDeluxe: {
                    name: 'steam',
                    link: 'https://store.steampowered.com/app/1342490/Daemon_X_Machina_Titanic_Scion/',
                },
                digitalSuper: {
                    name: 'steam',
                    link: 'https://store.steampowered.com/app/1342490/Daemon_X_Machina_Titanic_Scion/',
                },
            },
        },
    },
    au: {
        switch: {
            digital: {
                digitalStandard: {
                    name: 'Nintendo eShop',
                    link: 'https://ec.nintendo.com/AU/en/titles/70010000098438',
                },
                digitalDeluxe: {
                    name: 'Nintendo eShop',
                    link: 'https://ec.nintendo.com/AU/en/bundles/70070000028510',
                },
                digitalSuper: {
                    name: 'Nintendo eShop',
                    link: 'https://ec.nintendo.com/AU/en/bundles/70070000028516',
                },
            },
            physical: {
                physicalLimited: [
                    {
                        name: 'EBGames',
                        link: 'https://www.ebgames.com.au/product/nintendo-switch/325405-daemon-x-machina-titanic-scion-limited-edition',
                    },
                    {
                        name: 'JB Hi-Fi',
                        link: 'https://www.jbhifi.com.au/products/nintendo-switch-2-daemon-x-machina-titanic-scion-limited-edition',
                    },
                    {
                        name: 'Amazon',
                        link: 'https://www.amazon.com.au/Daemon-Machina-Titanic-Limited-Nintendo/dp/B0F3HD5186/',
                    },
                ],
                physicalStandard: [
                    {
                        name: 'EBGames',
                        link: 'https://www.ebgames.com.au/product/nintendo-switch/325403-daemon-x-machina-titanic-scion',
                    },
                    {
                        name: 'JB Hi-Fi',
                        link: 'https://www.jbhifi.com.au/products/nintendo-switch-2-daemon-x-machina-titanic-scion',
                    },
                    {
                        name: 'Amazon',
                        link: 'https://www.amazon.com.au/Daemon-Machina-Titanic-Nintendo-Switch/dp/B0F3J2K447',
                    },
                    {
                        name: 'Big W',
                        link: 'https://www.bigw.com.au/product/daemon-x-machina-titanic-scion-nintendo-switch-2/p/6025682',
                    },
                ],
            },
        },
        ps5: {
            digital: {
                digitalStandard: {
                    name: 'PlayStation Store',
                    link: 'https://store.playstation.com/product/EP4492-PPSA29136_00-DXMTSFULLGAME000',
                },
                digitalDeluxe: {
                    name: 'PlayStation Store',
                    link: 'https://store.playstation.com/product/EP4492-PPSA29136_00-DXMTSDELUXE00000',
                },
                digitalSuper: {
                    name: 'PlayStation Store',
                    link: 'https://store.playstation.com/product/EP4492-PPSA29136_00-DXMTSPREDELUXE00',
                },
            },
            physical: {
                physicalLimited: [],
                physicalStandard: [
                    {
                        name: 'JB Hi-Fi',
                        link: 'https://www.jbhifi.com.au/products/playstation-5-daemon-x-machina-titanic-scion',
                    },
                    {
                        name: 'EBGames',
                        link: 'https://www.ebgames.com.au/product/ps5/325395-daemon-x-machina-titanic-scion',
                    },
                    {
                        name: 'Big W',
                        link: 'https://www.bigw.com.au/product/daemon-x-machina-titanic-scion-ps5/p/6025684',
                    },
                    {
                        name: 'Amazon',
                        link: 'https://www.amazon.com.au/Daemon-Machina-Titanic-Nintendo-Switch/dp/B0F3HJPSLF?th=1',
                    },
                ],
            },
        },
        xbox: {
            digital: {
                digitalStandard: {
                    name: 'Microsoft Store',
                    link: 'https://www.xbox.com/games/store/daemon-x-machina-titanic-scion/9MSTS8GMBR8P',
                },
                digitalDeluxe: {
                    name: 'Microsoft Store',
                    link: 'https://www.xbox.com/games/store/daemon-x-machina-titanic-scion-digital-deluxe-edition/9PFWGSJWV60W',
                },
                digitalSuper: {
                    name: 'Microsoft Store',
                    link: 'https://www.xbox.com/games/store/daemon-x-machina-titanic-scion-super-digital-deluxe-edition/9NHX85JHNBL5',
                },
            },
            physical: {
                physicalLimited: [],
                physicalStandard: [
                    {
                        name: 'JB Hi-Fi',
                        link: 'https://www.jbhifi.com.au/products/xbox-series-x-daemon-x-machina-titanic-scion',
                    },
                    {
                        name: 'Amazon',
                        link: 'https://www.amazon.com.au/Daemon-Machina-Titanic-Scion-Xbox/dp/B0F3HTH6JB',
                    },
                    {
                        name: 'EBGames',
                        link: 'https://www.ebgames.com.au/product/xbox-series-x/325397-daemon-x-machina-titanic-scion',
                    },
                    {
                        name: 'Big W',
                        link: 'https://www.bigw.com.au/product/daemon-x-machina-titanic-scion-xbox-series-x/p/6025685',
                    },
                ],
            },
        },
        steam: {
            digital: {
                digitalStandard: {
                    name: 'steam',
                    link: 'https://store.steampowered.com/app/1342490/Daemon_X_Machina_Titanic_Scion/',
                },
                digitalDeluxe: {
                    name: 'steam',
                    link: 'https://store.steampowered.com/app/1342490/Daemon_X_Machina_Titanic_Scion/',
                },
                digitalSuper: {
                    name: 'steam',
                    link: 'https://store.steampowered.com/app/1342490/Daemon_X_Machina_Titanic_Scion/',
                },
            },
        },
    },
    nz: {
        switch: {
            digital: {
                digitalStandard: {
                    name: 'Nintendo eShop',
                    link: 'https://ec.nintendo.com/AU/en/titles/70010000098438',
                },
                digitalDeluxe: {
                    name: 'Nintendo eShop',
                    link: 'https://ec.nintendo.com/AU/en/bundles/70070000028510',
                },
                digitalSuper: {
                    name: 'Nintendo eShop',
                    link: 'https://ec.nintendo.com/AU/en/bundles/70070000028516',
                },
            },
            physical: {
                physicalLimited: [
                    {
                        name: 'JB Hi-Fi',
                        link: 'https://www.jbhifi.co.nz/products/nintendo-switch-2-daemon-x-machina-titanic-scion-limited-edition',
                    },
                ],
                physicalStandard: [
                    {
                        name: 'JB Hi-Fi',
                        link: 'https://www.jbhifi.co.nz/products/nintendo-switch-2-daemon-x-machina-titanic-scion',
                    },
                ],
            },
        },
        ps5: {
            digital: {
                digitalStandard: {
                    name: 'PlayStation Store',
                    link: 'https://store.playstation.com/product/EP4492-PPSA29136_00-DXMTSFULLGAME000',
                },
                digitalDeluxe: {
                    name: 'PlayStation Store',
                    link: 'https://store.playstation.com/product/EP4492-PPSA29136_00-DXMTSDELUXE00000',
                },
                digitalSuper: {
                    name: 'PlayStation Store',
                    link: 'https://store.playstation.com/product/EP4492-PPSA29136_00-DXMTSPREDELUXE00',
                },
            },
            physical: {
                physicalLimited: [],
                physicalStandard: [
                    {
                        name: 'JB Hi-Fi',
                        link: 'https://www.jbhifi.co.nz/products/playstation-5-daemon-x-machina-titanic-scion',
                    },
                ],
            },
        },
        xbox: {
            digital: {
                digitalStandard: {
                    name: 'Microsoft Store',
                    link: 'https://www.xbox.com/games/store/daemon-x-machina-titanic-scion/9MSTS8GMBR8P',
                },
                digitalDeluxe: {
                    name: 'Microsoft Store',
                    link: 'https://www.xbox.com/games/store/daemon-x-machina-titanic-scion-digital-deluxe-edition/9PFWGSJWV60W',
                },
                digitalSuper: {
                    name: 'Microsoft Store',
                    link: 'https://www.xbox.com/games/store/daemon-x-machina-titanic-scion-super-digital-deluxe-edition/9NHX85JHNBL5',
                },
            },
            physical: {
                physicalLimited: [],
                physicalStandard: [
                    {
                        name: 'JB Hi-Fi',
                        link: 'https://www.jbhifi.co.nz/products/xbox-series-x-daemon-x-machina-titanic-scion',
                    },
                ],
            },
        },
        steam: {
            digital: {
                digitalStandard: {
                    name: 'steam',
                    link: 'https://store.steampowered.com/app/1342490/Daemon_X_Machina_Titanic_Scion/',
                },
                digitalDeluxe: {
                    name: 'steam',
                    link: 'https://store.steampowered.com/app/1342490/Daemon_X_Machina_Titanic_Scion/',
                },
                digitalSuper: {
                    name: 'steam',
                    link: 'https://store.steampowered.com/app/1342490/Daemon_X_Machina_Titanic_Scion/',
                },
            },
        },
    },
    it: {
        switch: {
            digital: {
                digitalStandard: {
                    name: 'Nintendo eShop',
                    link: 'https://www.nintendo.com/en-gb/Games/Nintendo-Switch-2-games/Daemon-X-Machina-Titanic-Scion-2849025.html?s=countries',
                },
                digitalDeluxe: {
                    name: 'Nintendo eShop',
                    link: 'https://www.nintendo.com/en-gb/Games/Nintendo-Switch-2-games/Daemon-X-Machina-Titanic-Scion-2849025.html?s=countries&nsuid=70070000028510#Digital_Deluxe_Edition',
                },
                digitalSuper: {
                    name: 'Nintendo eShop',
                    link: 'https://www.nintendo.com/en-gb/Games/Nintendo-Switch-2-games/Daemon-X-Machina-Titanic-Scion-2849025.html?s=countries&nsuid=70070000028516#Super_Digital_Deluxe_Edition',
                },
            },
            physical: {
                physicalLimited: [
                    {
                        name: 'Amazon',
                        link: 'https://www.amazon.it/dp/B0F3DPNWKS/',
                    },
                    {
                        name: 'GameStop',
                        link: 'https://www.gamestop.it/Switch2/Games/151448/daemon-x-machina-titanic-scion-limited-edition',
                    },
                ],
                physicalStandard: [
                    {
                        name: 'Amazon',
                        link: 'https://www.amazon.it/dp/B0F3DNQY4D/',
                    },
                    {
                        name: 'GameStop',
                        link: 'https://www.gamestop.it/Switch2/Games/151447/daemon-x-machina-titanic-scion',
                    },
                ],
            },
        },
        ps5: {
            digital: {
                digitalStandard: {
                    name: 'PlayStation Store',
                    link: 'https://store.playstation.com/product/EP4492-PPSA29136_00-DXMTSFULLGAME000',
                },
                digitalDeluxe: {
                    name: 'PlayStation Store',
                    link: 'https://store.playstation.com/product/EP4492-PPSA29136_00-DXMTSDELUXE00000',
                },
                digitalSuper: {
                    name: 'PlayStation Store',
                    link: 'https://store.playstation.com/product/EP4492-PPSA29136_00-DXMTSPREDELUXE00',
                },
            },
            physical: {
                physicalLimited: [],
                physicalStandard: [
                    {
                        name: 'Amazon',
                        link: 'https://www.amazon.it/dp/B0F3KT3NZS/',
                    },
                    {
                        name: 'GameStop',
                        link: 'https://www.gamestop.it/PS5/Games/151449/daemon-x-machina-titanic-scion',
                    },
                ],
            },
        },
        xbox: {
            digital: {
                digitalStandard: {
                    name: 'Microsoft Store',
                    link: 'https://www.xbox.com/games/store/daemon-x-machina-titanic-scion/9MSTS8GMBR8P',
                },
                digitalDeluxe: {
                    name: 'Microsoft Store',
                    link: 'https://www.xbox.com/games/store/daemon-x-machina-titanic-scion-digital-deluxe-edition/9PFWGSJWV60W',
                },
                digitalSuper: {
                    name: 'Microsoft Store',
                    link: 'https://www.xbox.com/games/store/daemon-x-machina-titanic-scion-super-digital-deluxe-edition/9NHX85JHNBL5',
                },
            },
            physical: {
                physicalLimited: [],
                physicalStandard: [
                    {
                        name: 'Amazon',
                        link: 'https://www.amazon.it/dp/B0F3KSZ3B2/',
                    },
                    {
                        name: 'GameStop',
                        link: 'https://www.gamestop.it/XboxSeries/Games/151451/daemon-x-machina-titanic-scion',
                    },
                ],
            },
        },
        steam: {
            digital: {
                digitalStandard: {
                    name: 'steam',
                    link: 'https://store.steampowered.com/app/1342490/Daemon_X_Machina_Titanic_Scion/',
                },
                digitalDeluxe: {
                    name: 'steam',
                    link: 'https://store.steampowered.com/app/1342490/Daemon_X_Machina_Titanic_Scion/',
                },
                digitalSuper: {
                    name: 'steam',
                    link: 'https://store.steampowered.com/app/1342490/Daemon_X_Machina_Titanic_Scion/',
                },
            },
        },
    },
    pt: {
        switch: {
            digital: {
                digitalStandard: {
                    name: 'Nintendo eShop',
                    link: 'https://www.nintendo.com/en-gb/Games/Nintendo-Switch-2-games/Daemon-X-Machina-Titanic-Scion-2849025.html?s=countries',
                },
                digitalDeluxe: {
                    name: 'Nintendo eShop',
                    link: 'https://www.nintendo.com/en-gb/Games/Nintendo-Switch-2-games/Daemon-X-Machina-Titanic-Scion-2849025.html?s=countries&nsuid=70070000028510#Digital_Deluxe_Edition',
                },
                digitalSuper: {
                    name: 'Nintendo eShop',
                    link: 'https://www.nintendo.com/en-gb/Games/Nintendo-Switch-2-games/Daemon-X-Machina-Titanic-Scion-2849025.html?s=countries&nsuid=70070000028516#Super_Digital_Deluxe_Edition',
                },
            },
            physical: {
                physicalLimited: [
                    {
                        name: 'Worten',
                        link: 'https://www.worten.pt/produtos/pre-venda-jogo-nintendo-switch-2-daemon-x-machina-titanic-scion-limited-edition-8489442',
                    },
                    {
                        name: 'FNAC',
                        link: 'https://www.fnac.pt/Daemon-X-Machina-Titanic-Scion-Limited-Edition-Nintendo-Switch-2-Videojogo-Nintendo-Switch-2/a12744291',
                    },
                ],
                physicalStandard: [
                    {
                        name: 'Worten',
                        link: 'https://www.worten.pt/produtos/pre-venda-jogo-nintendo-switch-2-daemon-x-machina-titanic-scion-8489439',
                    },
                    {
                        name: 'FNAC',
                        link: 'https://www.fnac.pt/Daemon-X-Machina-Titanic-Scion-Nintendo-Switch-2-Videojogo-Nintendo-Switch-2/a12744290',
                    },
                ],
            },
        },
        ps5: {
            digital: {
                digitalStandard: {
                    name: 'PlayStation Store',
                    link: 'https://store.playstation.com/product/EP4492-PPSA29136_00-DXMTSFULLGAME000',
                },
                digitalDeluxe: {
                    name: 'PlayStation Store',
                    link: 'https://store.playstation.com/product/EP4492-PPSA29136_00-DXMTSDELUXE00000',
                },
                digitalSuper: {
                    name: 'PlayStation Store',
                    link: 'https://store.playstation.com/product/EP4492-PPSA29136_00-DXMTSPREDELUXE00',
                },
            },
            physical: {
                physicalLimited: [],
                physicalStandard: [
                    {
                        name: 'Worten',
                        link: 'https://www.worten.pt/produtos/pre-venda-jogo-ps5-daemon-x-machina-titanic-scion-8489444',
                    },
                    {
                        name: 'FNAC',
                        link: 'https://www.fnac.pt/Daemon-X-Machina-Titanic-Scion-PS5-Videojogo-PlayStation-5/a12744292',
                    },
                ],
            },
        },
        xbox: {
            digital: {
                digitalStandard: {
                    name: 'Microsoft Store',
                    link: 'https://www.xbox.com/games/store/daemon-x-machina-titanic-scion/9MSTS8GMBR8P',
                },
                digitalDeluxe: {
                    name: 'Microsoft Store',
                    link: 'https://www.xbox.com/games/store/daemon-x-machina-titanic-scion-digital-deluxe-edition/9PFWGSJWV60W',
                },
                digitalSuper: {
                    name: 'Microsoft Store',
                    link: 'https://www.xbox.com/games/store/daemon-x-machina-titanic-scion-super-digital-deluxe-edition/9NHX85JHNBL5',
                },
            },
            physical: {
                physicalLimited: [],
                physicalStandard: [],
            },
        },
        steam: {
            digital: {
                digitalStandard: {
                    name: 'steam',
                    link: 'https://store.steampowered.com/app/1342490/Daemon_X_Machina_Titanic_Scion/',
                },
                digitalDeluxe: {
                    name: 'steam',
                    link: 'https://store.steampowered.com/app/1342490/Daemon_X_Machina_Titanic_Scion/',
                },
                digitalSuper: {
                    name: 'steam',
                    link: 'https://store.steampowered.com/app/1342490/Daemon_X_Machina_Titanic_Scion/',
                },
            },
        },
    },
    nl: {
        switch: {
            digital: {
                digitalStandard: {
                    name: 'Nintendo eShop',
                    link: 'https://www.nintendo.com/en-gb/Games/Nintendo-Switch-2-games/Daemon-X-Machina-Titanic-Scion-2849025.html?s=countries',
                },
                digitalDeluxe: {
                    name: 'Nintendo eShop',
                    link: 'https://www.nintendo.com/en-gb/Games/Nintendo-Switch-2-games/Daemon-X-Machina-Titanic-Scion-2849025.html?s=countries&nsuid=70070000028510#Digital_Deluxe_Edition',
                },
                digitalSuper: {
                    name: 'Nintendo eShop',
                    link: 'https://www.nintendo.com/en-gb/Games/Nintendo-Switch-2-games/Daemon-X-Machina-Titanic-Scion-2849025.html?s=countries&nsuid=70070000028516#Super_Digital_Deluxe_Edition',
                },
            },
            physical: {
                physicalLimited: [
                    {
                        name: 'Bol',
                        link: 'https://www.bol.com/nl/nl/p/daemon-x-machina-titanic-scion-limited-edition-nintendo-switch-2/9300000229378627/',
                    },
                    {
                        name: 'Amazon',
                        link: 'https://www.amazon.nl/Daemon-Machina-Titanic-Limited-Switch/dp/B0F3DPNWKS',
                    },
                    {
                        name: 'MediaMarkt',
                        link: 'https://www.mediamarkt.nl/nl/product/_mindscape-sw-daemon-x-machina-titanic-scion-limited-edition-or-switch-2-game-1884452.html',
                    },
                    {
                        name: 'FNAC',
                        link: 'https://www.nl.fnac.be/a21521231/Daemon-X-Machina-Titanic-Scion-Limited-Edition-Nintendo-Switch-2-Videospel-Nintendo-Switch-2',
                    },
                ],
                physicalStandard: [
                    {
                        name: 'Bol',
                        link: 'https://www.bol.com/nl/nl/p/daemon-x-machina-titanic-scion-nintendo-switch-2/9300000229378629/',
                    },
                    {
                        name: 'Amazon',
                        link: 'https://www.amazon.nl/Daemon-Machina-Titanic-Scion-Switch/dp/B0F3DPPHDL',
                    },
                    {
                        name: 'MediaMarkt',
                        link: 'https://www.mediamarkt.nl/nl/product/_mindscape-sw-daemon-x-machina-titanic-scion-or-switch-2-game-1884451.html',
                    },
                    {
                        name: 'FNAC',
                        link: 'https://www.nl.fnac.be/a21521232/Daemon-X-Machina-Titanic-Scion-Nintendo-Switch-2-Videospel-Nintendo-Switch-2',
                    },
                ],
            },
        },
        ps5: {
            digital: {
                digitalStandard: {
                    name: 'PlayStation Store',
                    link: 'https://store.playstation.com/product/EP4492-PPSA29136_00-DXMTSFULLGAME000',
                },
                digitalDeluxe: {
                    name: 'PlayStation Store',
                    link: 'https://store.playstation.com/product/EP4492-PPSA29136_00-DXMTSDELUXE00000',
                },
                digitalSuper: {
                    name: 'PlayStation Store',
                    link: 'https://store.playstation.com/product/EP4492-PPSA29136_00-DXMTSPREDELUXE00',
                },
            },
            physical: {
                physicalLimited: [],
                physicalStandard: [
                    {
                        name: 'Bol',
                        link: 'https://www.bol.com/nl/nl/p/daemon-x-machina-titanic-scion-ps5/9300000229378625/',
                    },
                    {
                        name: 'Amazon',
                        link: 'https://www.amazon.nl/Daemon-Machina-Titanic-Scion-PS5/dp/B0F3KT4FNS',
                    },
                    {
                        name: 'MediaMarkt',
                        link: 'https://www.mediamarkt.nl/nl/product/_mindscape-sw-daemon-x-machina-titanic-scion-or-switch-2-game-1884451.html',
                    },
                    {
                        name: 'FNAC',
                        link: 'https://www.nl.fnac.be/a21501238/Daemon-X-Machina-Titanic-Scion-PS5-Videospel-Playstation-5?oref=1d7efb24-f952-369d-3a54-539127e36aa3',
                    },
                ],
            },
        },
        xbox: {
            digital: {
                digitalStandard: {
                    name: 'Microsoft Store',
                    link: 'https://www.xbox.com/games/store/daemon-x-machina-titanic-scion/9MSTS8GMBR8P',
                },
                digitalDeluxe: {
                    name: 'Microsoft Store',
                    link: 'https://www.xbox.com/games/store/daemon-x-machina-titanic-scion-digital-deluxe-edition/9PFWGSJWV60W',
                },
                digitalSuper: {
                    name: 'Microsoft Store',
                    link: 'https://www.xbox.com/games/store/daemon-x-machina-titanic-scion-super-digital-deluxe-edition/9NHX85JHNBL5',
                },
            },
            physical: {
                physicalLimited: [],
                physicalStandard: [
                    {
                        name: 'FNAC',
                        link: 'https://www.nl.fnac.be/a21501239/Daemon-X-Machina-Titanic-Scion-Xbox-serie-X-Videospel-Xbox-Series',
                    },
                ],
            },
        },
        steam: {
            digital: {
                digitalStandard: {
                    name: 'steam',
                    link: 'https://store.steampowered.com/app/1342490/Daemon_X_Machina_Titanic_Scion/',
                },
                digitalDeluxe: {
                    name: 'steam',
                    link: 'https://store.steampowered.com/app/1342490/Daemon_X_Machina_Titanic_Scion/',
                },
                digitalSuper: {
                    name: 'steam',
                    link: 'https://store.steampowered.com/app/1342490/Daemon_X_Machina_Titanic_Scion/',
                },
            },
        },
    },
    ch: {
        switch: {
            digital: {
                digitalStandard: {
                    name: 'Nintendo eShop',
                    link: 'https://www.nintendo.com/en-gb/Games/Nintendo-Switch-2-games/Daemon-X-Machina-Titanic-Scion-2849025.html?s=countries',
                },
                digitalDeluxe: {
                    name: 'Nintendo eShop',
                    link: 'https://www.nintendo.com/en-gb/Games/Nintendo-Switch-2-games/Daemon-X-Machina-Titanic-Scion-2849025.html?s=countries&nsuid=70070000028510#Digital_Deluxe_Edition',
                },
                digitalSuper: {
                    name: 'Nintendo eShop',
                    link: 'https://www.nintendo.com/en-gb/Games/Nintendo-Switch-2-games/Daemon-X-Machina-Titanic-Scion-2849025.html?s=countries&nsuid=70070000028516#Super_Digital_Deluxe_Edition',
                },
            },
            physical: {
                physicalLimited: [
                    {
                        name: 'Wog',
                        link: 'https://www.wog.ch/de/index.cfm/details/product/220607-Daemon-X-Machina-Titanic-Scion-Limited-Edition',
                    },
                ],
                physicalStandard: [
                    {
                        name: 'Wog',
                        link: 'https://www.wog.ch/de/index.cfm/details/product/220489-Daemon-X-Machina-Titanic-Scion',
                    },
                ],
            },
        },
        ps5: {
            digital: {
                digitalStandard: {
                    name: 'PlayStation Store',
                    link: 'https://store.playstation.com/product/EP4492-PPSA29136_00-DXMTSFULLGAME000',
                },
                digitalDeluxe: {
                    name: 'PlayStation Store',
                    link: 'https://store.playstation.com/product/EP4492-PPSA29136_00-DXMTSDELUXE00000',
                },
                digitalSuper: {
                    name: 'PlayStation Store',
                    link: 'https://store.playstation.com/product/EP4492-PPSA29136_00-DXMTSPREDELUXE00',
                },
            },
            physical: {
                physicalLimited: [],
                physicalStandard: [
                    {
                        name: 'Wog',
                        link: 'https://www.wog.ch/de/index.cfm/details/product/220608-Daemon-X-Machina-Titanic-Scion',
                    },
                ],
            },
        },
        xbox: {
            digital: {
                digitalStandard: {
                    name: 'Microsoft Store',
                    link: 'https://www.xbox.com/games/store/daemon-x-machina-titanic-scion/9MSTS8GMBR8P',
                },
                digitalDeluxe: {
                    name: 'Microsoft Store',
                    link: 'https://www.xbox.com/games/store/daemon-x-machina-titanic-scion-digital-deluxe-edition/9PFWGSJWV60W',
                },
                digitalSuper: {
                    name: 'Microsoft Store',
                    link: 'https://www.xbox.com/games/store/daemon-x-machina-titanic-scion-super-digital-deluxe-edition/9NHX85JHNBL5',
                },
            },
            physical: {
                physicalLimited: [],
                physicalStandard: [
                    {
                        name: 'Wog',
                        link: 'https://www.wog.ch/de/index.cfm/details/product/220609-Daemon-X-Machina-Titanic-Scion',
                    },
                ],
            },
        },
        steam: {
            digital: {
                digitalStandard: {
                    name: 'steam',
                    link: 'https://store.steampowered.com/app/1342490/Daemon_X_Machina_Titanic_Scion/',
                },
                digitalDeluxe: {
                    name: 'steam',
                    link: 'https://store.steampowered.com/app/1342490/Daemon_X_Machina_Titanic_Scion/',
                },
                digitalSuper: {
                    name: 'steam',
                    link: 'https://store.steampowered.com/app/1342490/Daemon_X_Machina_Titanic_Scion/',
                },
            },
        },
    },
    be: {
        switch: {
            digital: {
                digitalStandard: {
                    name: 'Nintendo eShop',
                    link: 'https://www.nintendo.com/en-gb/Games/Nintendo-Switch-2-games/Daemon-X-Machina-Titanic-Scion-2849025.html?s=countries',
                },
                digitalDeluxe: {
                    name: 'Nintendo eShop',
                    link: 'https://www.nintendo.com/en-gb/Games/Nintendo-Switch-2-games/Daemon-X-Machina-Titanic-Scion-2849025.html?s=countries&nsuid=70070000028510#Digital_Deluxe_Edition',
                },
                digitalSuper: {
                    name: 'Nintendo eShop',
                    link: 'https://www.nintendo.com/en-gb/Games/Nintendo-Switch-2-games/Daemon-X-Machina-Titanic-Scion-2849025.html?s=countries&nsuid=70070000028516#Super_Digital_Deluxe_Edition',
                },
            },
            physical: {
                physicalLimited: [
                    {
                        name: 'Smartoys',
                        link: 'https://www.smartoys.be/catalog/jeux-vido-nintendo-switch-daemon-machina-titanic-scion-limited-edition-version-nintendo-switch-p-5060540773319.html',
                    },
                    {
                        name: 'Amazon',
                        link: 'https://www.amazon.com.be/Daemon-Machina-Titanic-Limited-Switch/dp/B0F3DPNWKS',
                    },
                    {
                        name: 'MediaMarkt',
                        link: 'https://www.mediamarkt.be/nl/product/_daemon-x-machina-titanic-scion-limited-edition-switch-2-2181001.html',
                    },
                    {
                        name: 'FNAC',
                        link: 'https://www.fr.fnac.be/a21521231/Daemon-X-Machina-Titanic-Scion-Limited-Edition-Nintendo-Switch-2-Jeu-video-Nintendo-Switch-2',
                    },
                ],
                physicalStandard: [
                    {
                        name: 'Smartoys',
                        link: 'https://www.smartoys.be/catalog/jeux-vido-nintendo-switch-daemon-machina-titanic-scion-version-nintendo-switch-p-5060540773296.html',
                    },
                    {
                        name: 'Amazon',
                        link: 'https://www.amazon.com.be/Daemon-Machina-Titanic-Version-fran%C3%A7aise/dp/B0F3DQ7J33/',
                    },
                    {
                        name: 'MediaMarkt',
                        link: 'https://www.mediamarkt.be/nl/product/_daemon-x-machina-titanic-scion-switch-2-2181000.html',
                    },
                    {
                        name: 'FNAC',
                        link: 'https://www.fr.fnac.be/a21521232/Daemon-X-Machina-Titanic-Scion-Nintendo-Switch-2-Jeu-video-Nintendo-Switch-2',
                    },
                ],
            },
        },
        ps5: {
            digital: {
                digitalStandard: {
                    name: 'PlayStation Store',
                    link: 'https://store.playstation.com/product/EP4492-PPSA29136_00-DXMTSFULLGAME000',
                },
                digitalDeluxe: {
                    name: 'PlayStation Store',
                    link: 'https://store.playstation.com/product/EP4492-PPSA29136_00-DXMTSDELUXE00000',
                },
                digitalSuper: {
                    name: 'PlayStation Store',
                    link: 'https://store.playstation.com/product/EP4492-PPSA29136_00-DXMTSPREDELUXE00',
                },
            },
            physical: {
                physicalLimited: [],
                physicalStandard: [
                    {
                        name: 'Smartoys',
                        link: 'https://www.smartoys.be/catalog/jeux-vido-playstation-daemon-machina-titanic-scion-version-ps5-p-5060540773043.html',
                    },
                    {
                        name: 'Amazon',
                        link: 'https://www.amazon.com.be/Daemon-Machina-Titanic-Scion-Xbox/dp/B0F3KX41HZ?th=1',
                    },
                    {
                        name: 'MediaMarkt',
                        link: 'https://www.mediamarkt.be/nl/product/_daemon-x-machina-titanic-scion-ps5-2180999.html',
                    },
                    {
                        name: 'FNAC',
                        link: 'https://www.fr.fnac.be/a21501238/Daemon-X-Machina-Titanic-Scion-PS5-Jeu-video-Playstation-5?oref=1d7efb24-f952-369d-3a54-539127e36aa3',
                    },
                ],
            },
        },
        xbox: {
            digital: {
                digitalStandard: {
                    name: 'Microsoft Store',
                    link: 'https://www.xbox.com/games/store/daemon-x-machina-titanic-scion/9MSTS8GMBR8P',
                },
                digitalDeluxe: {
                    name: 'Microsoft Store',
                    link: 'https://www.xbox.com/games/store/daemon-x-machina-titanic-scion-digital-deluxe-edition/9PFWGSJWV60W',
                },
                digitalSuper: {
                    name: 'Microsoft Store',
                    link: 'https://www.xbox.com/games/store/daemon-x-machina-titanic-scion-super-digital-deluxe-edition/9NHX85JHNBL5',
                },
            },
            physical: {
                physicalLimited: [],
                physicalStandard: [
                    {
                        name: 'Amazon',
                        link: 'https://www.amazon.com.be/Daemon-Machina-Titanic-Scion-Xbox/dp/B0F3KSZ3B2',
                    },
                    {
                        name: 'FNAC',
                        link: 'https://www.fr.fnac.be/a21501239/Daemon-X-Machina-Titanic-Scion-Xbox-Series-X-Jeu-video-Xbox-Series',
                    },
                ],
            },
        },
        steam: {
            digital: {
                digitalStandard: {
                    name: 'steam',
                    link: 'https://store.steampowered.com/app/1342490/Daemon_X_Machina_Titanic_Scion/',
                },
                digitalDeluxe: {
                    name: 'steam',
                    link: 'https://store.steampowered.com/app/1342490/Daemon_X_Machina_Titanic_Scion/',
                },
                digitalSuper: {
                    name: 'steam',
                    link: 'https://store.steampowered.com/app/1342490/Daemon_X_Machina_Titanic_Scion/',
                },
            },
        },
    },
    pl: {
        switch: {
            digital: {
                digitalStandard: {
                    name: 'Nintendo eShop',
                    link: 'https://www.nintendo.com/en-gb/Games/Nintendo-Switch-2-games/Daemon-X-Machina-Titanic-Scion-2849025.html?s=countries',
                },
                digitalDeluxe: {
                    name: 'Nintendo eShop',
                    link: 'https://www.nintendo.com/en-gb/Games/Nintendo-Switch-2-games/Daemon-X-Machina-Titanic-Scion-2849025.html?s=countries&nsuid=70070000028510#Digital_Deluxe_Edition',
                },
                digitalSuper: {
                    name: 'Nintendo eShop',
                    link: 'https://www.nintendo.com/en-gb/Games/Nintendo-Switch-2-games/Daemon-X-Machina-Titanic-Scion-2849025.html?s=countries&nsuid=70070000028516#Super_Digital_Deluxe_Edition',
                },
            },
            physical: {
                physicalLimited: [
                    {
                        name: 'Amazon',
                        link: 'https://www.amazon.pl/Daemon-Machina-Titanic-Limited-Switch/dp/B0F3DPNWKS',
                    },
                    {
                        name: 'Empik',
                        link: 'https://www.empik.com/daemon-x-machina-titanic-scion-edycja-limitowana-marvelous-inc,p1605228550,multimedia-p',
                    },
                ],
                physicalStandard: [
                    {
                        name: 'Amazon',
                        link: 'https://www.amazon.pl/Daemon-Machina-Titanic-Scion-Switch/dp/B0F3DPTQT3',
                    },
                    {
                        name: 'Empik',
                        link: 'https://www.empik.com/daemon-x-machina-titanic-scion-marvelous-inc,p1605228985,multimedia-p',
                    },
                ],
            },
        },
        ps5: {
            digital: {
                digitalStandard: {
                    name: 'PlayStation Store',
                    link: 'https://store.playstation.com/product/EP4492-PPSA29136_00-DXMTSFULLGAME000',
                },
                digitalDeluxe: {
                    name: 'PlayStation Store',
                    link: 'https://store.playstation.com/product/EP4492-PPSA29136_00-DXMTSDELUXE00000',
                },
                digitalSuper: {
                    name: 'PlayStation Store',
                    link: 'https://store.playstation.com/product/EP4492-PPSA29136_00-DXMTSPREDELUXE00',
                },
            },
            physical: {
                physicalLimited: [],
                physicalStandard: [
                    {
                        name: 'Amazon',
                        link: 'https://www.amazon.pl/Daemon-Machina-Titanic-Scion-Switch/dp/B0F3KT4FNS?th=1',
                    },
                    {
                        name: 'Empik',
                        link: 'https://www.empik.com/daemon-x-machina-titanic-scion-marvelous-inc,p1605228985,multimedia-p',
                    },
                ],
            },
        },
        xbox: {
            digital: {
                digitalStandard: {
                    name: 'Microsoft Store',
                    link: 'https://www.xbox.com/games/store/daemon-x-machina-titanic-scion/9MSTS8GMBR8P',
                },
                digitalDeluxe: {
                    name: 'Microsoft Store',
                    link: 'https://www.xbox.com/games/store/daemon-x-machina-titanic-scion-digital-deluxe-edition/9PFWGSJWV60W',
                },
                digitalSuper: {
                    name: 'Microsoft Store',
                    link: 'https://www.xbox.com/games/store/daemon-x-machina-titanic-scion-super-digital-deluxe-edition/9NHX85JHNBL5',
                },
            },
            physical: {
                physicalLimited: [],
                physicalStandard: [
                    {
                        name: 'Amazon',
                        link: 'https://www.amazon.pl/Daemon-Machina-Titanic-Scion-Switch/dp/B0F3KSZ3B2?th=1',
                    },
                    {
                        name: 'Empik',
                        link: 'https://www.empik.com/daemon-x-machina-titanic-scion-marvelous-inc,p1605229407,multimedia-p',
                    },
                ],
            },
        },
        steam: {
            digital: {
                digitalStandard: {
                    name: 'steam',
                    link: 'https://store.steampowered.com/app/1342490/Daemon_X_Machina_Titanic_Scion/',
                },
                digitalDeluxe: {
                    name: 'steam',
                    link: 'https://store.steampowered.com/app/1342490/Daemon_X_Machina_Titanic_Scion/',
                },
                digitalSuper: {
                    name: 'steam',
                    link: 'https://store.steampowered.com/app/1342490/Daemon_X_Machina_Titanic_Scion/',
                },
            },
        },
    },
    se: {
        switch: {
            digital: {
                digitalStandard: {
                    name: 'Nintendo eShop',
                    link: 'https://www.nintendo.com/en-gb/Games/Nintendo-Switch-2-games/Daemon-X-Machina-Titanic-Scion-2849025.html?s=countries',
                },
                digitalDeluxe: {
                    name: 'Nintendo eShop',
                    link: 'https://www.nintendo.com/en-gb/Games/Nintendo-Switch-2-games/Daemon-X-Machina-Titanic-Scion-2849025.html?s=countries&nsuid=70070000028510#Digital_Deluxe_Edition',
                },
                digitalSuper: {
                    name: 'Nintendo eShop',
                    link: 'https://www.nintendo.com/en-gb/Games/Nintendo-Switch-2-games/Daemon-X-Machina-Titanic-Scion-2849025.html?s=countries&nsuid=70070000028516#Super_Digital_Deluxe_Edition',
                },
            },
            physical: {
                physicalLimited: [
                    {
                        name: 'Amazon',
                        link: 'https://www.amazon.se/Daemon-Machina-Titanic-Limited-Switch/dp/B0F3DPNWKS',
                    },
                ],
                physicalStandard: [
                    {
                        name: 'Amazon',
                        link: 'https://www.amazon.se/Daemon-Machina-Titanic-Scion-Switch/dp/B0F3DPTQT3',
                    },
                    {
                        name: 'Spelbutiken',
                        link: 'https://www.spelbutiken.se/produkt/daemon-x-machina-titanic-scion/23R867/',
                    },
                ],
            },
        },
        ps5: {
            digital: {
                digitalStandard: {
                    name: 'PlayStation Store',
                    link: 'https://store.playstation.com/product/EP4492-PPSA29136_00-DXMTSFULLGAME000',
                },
                digitalDeluxe: {
                    name: 'PlayStation Store',
                    link: 'https://store.playstation.com/product/EP4492-PPSA29136_00-DXMTSDELUXE00000',
                },
                digitalSuper: {
                    name: 'PlayStation Store',
                    link: 'https://store.playstation.com/product/EP4492-PPSA29136_00-DXMTSPREDELUXE00',
                },
            },
            physical: {
                physicalLimited: [],
                physicalStandard: [
                    {
                        name: 'Amazon',
                        link: 'https://www.amazon.se/Daemon-Machina-Titanic-Scion-Switch/dp/B0F3KT4FNS?th=1',
                    },
                    {
                        name: 'Spelbutiken',
                        link: 'https://www.spelbutiken.se/produkt/daemon-x-machina-titanic-scion/23R869/',
                    },
                ],
            },
        },
        xbox: {
            digital: {
                digitalStandard: {
                    name: 'Microsoft Store',
                    link: 'https://www.xbox.com/games/store/daemon-x-machina-titanic-scion/9MSTS8GMBR8P',
                },
                digitalDeluxe: {
                    name: 'Microsoft Store',
                    link: 'https://www.xbox.com/games/store/daemon-x-machina-titanic-scion-digital-deluxe-edition/9PFWGSJWV60W',
                },
                digitalSuper: {
                    name: 'Microsoft Store',
                    link: 'https://www.xbox.com/games/store/daemon-x-machina-titanic-scion-super-digital-deluxe-edition/9NHX85JHNBL5',
                },
            },
            physical: {
                physicalLimited: [],
                physicalStandard: [
                    {
                        name: 'Amazon',
                        link: 'https://www.amazon.se/Daemon-Machina-Titanic-Scion-Switch/dp/B0F3KSZ3B2?th=1',
                    },
                    {
                        name: 'Spelbutiken',
                        link: 'https://www.spelbutiken.se/produkt/daemon-x-machina-titanic-scion/23R86A/',
                    },
                ],
            },
        },
        steam: {
            digital: {
                digitalStandard: {
                    name: 'steam',
                    link: 'https://store.steampowered.com/app/1342490/Daemon_X_Machina_Titanic_Scion/',
                },
                digitalDeluxe: {
                    name: 'steam',
                    link: 'https://store.steampowered.com/app/1342490/Daemon_X_Machina_Titanic_Scion/',
                },
                digitalSuper: {
                    name: 'steam',
                    link: 'https://store.steampowered.com/app/1342490/Daemon_X_Machina_Titanic_Scion/',
                },
            },
        },
    },
    no: {
        switch: {
            digital: {
                digitalStandard: {
                    name: 'Nintendo eShop',
                    link: 'https://www.nintendo.com/en-gb/Games/Nintendo-Switch-2-games/Daemon-X-Machina-Titanic-Scion-2849025.html?s=countries',
                },
                digitalDeluxe: {
                    name: 'Nintendo eShop',
                    link: 'https://www.nintendo.com/en-gb/Games/Nintendo-Switch-2-games/Daemon-X-Machina-Titanic-Scion-2849025.html?s=countries&nsuid=70070000028510#Digital_Deluxe_Edition',
                },
                digitalSuper: {
                    name: 'Nintendo eShop',
                    link: 'https://www.nintendo.com/en-gb/Games/Nintendo-Switch-2-games/Daemon-X-Machina-Titanic-Scion-2849025.html?s=countries&nsuid=70070000028516#Super_Digital_Deluxe_Edition',
                },
            },
            physical: {
                physicalLimited: [],
                physicalStandard: [
                    {
                        name: 'Proshop',
                        link: 'https://www.proshop.no/Spill/Daemon-X-Machina-Titanic-Scion-Nintendo-Switch-2/3360007',
                    },
                    {
                        name: 'CoolShop',
                        link: 'https://www.coolshop.no/produkt/daemon-x-machina-titanic-scion/23R867/',
                    },
                ],
            },
        },
        ps5: {
            digital: {
                digitalStandard: {
                    name: 'PlayStation Store',
                    link: 'https://store.playstation.com/product/EP4492-PPSA29136_00-DXMTSFULLGAME000',
                },
                digitalDeluxe: {
                    name: 'PlayStation Store',
                    link: 'https://store.playstation.com/product/EP4492-PPSA29136_00-DXMTSDELUXE00000',
                },
                digitalSuper: {
                    name: 'PlayStation Store',
                    link: 'https://store.playstation.com/product/EP4492-PPSA29136_00-DXMTSPREDELUXE00',
                },
            },
            physical: {
                physicalLimited: [],
                physicalStandard: [
                    {
                        name: 'Proshop',
                        link: 'https://www.proshop.no/Spill/Daemon-X-Machina-Titanic-Scion-Sony-PlayStation-5-Action/3401137',
                    },
                    {
                        name: 'CoolShop',
                        link: 'https://www.coolshop.no/produkt/daemon-x-machina-titanic-scion/23R869/',
                    },
                ],
            },
        },
        xbox: {
            digital: {
                digitalStandard: {
                    name: 'Microsoft Store',
                    link: 'https://www.xbox.com/games/store/daemon-x-machina-titanic-scion/9MSTS8GMBR8P',
                },
                digitalDeluxe: {
                    name: 'Microsoft Store',
                    link: 'https://www.xbox.com/games/store/daemon-x-machina-titanic-scion-digital-deluxe-edition/9PFWGSJWV60W',
                },
                digitalSuper: {
                    name: 'Microsoft Store',
                    link: 'https://www.xbox.com/games/store/daemon-x-machina-titanic-scion-super-digital-deluxe-edition/9NHX85JHNBL5',
                },
            },
            physical: {
                physicalLimited: [],
                physicalStandard: [
                    {
                        name: 'Proshop',
                        link: 'https://www.proshop.no/Spill/Daemon-X-Machina-Titanic-Scion-Microsoft-Xbox-Series-X-Action/3401376',
                    },
                    {
                        name: 'CoolShop',
                        link: 'https://www.coolshop.no/produkt/daemon-x-machina-titanic-scion/23R86A/',
                    },
                ],
            },
        },
        steam: {
            digital: {
                digitalStandard: {
                    name: 'steam',
                    link: 'https://store.steampowered.com/app/1342490/Daemon_X_Machina_Titanic_Scion/',
                },
                digitalDeluxe: {
                    name: 'steam',
                    link: 'https://store.steampowered.com/app/1342490/Daemon_X_Machina_Titanic_Scion/',
                },
                digitalSuper: {
                    name: 'steam',
                    link: 'https://store.steampowered.com/app/1342490/Daemon_X_Machina_Titanic_Scion/',
                },
            },
        },
    },
    dk: {
        switch: {
            digital: {
                digitalStandard: {
                    name: 'Nintendo eShop',
                    link: 'https://www.nintendo.com/en-gb/Games/Nintendo-Switch-2-games/Daemon-X-Machina-Titanic-Scion-2849025.html?s=countries',
                },
                digitalDeluxe: {
                    name: 'Nintendo eShop',
                    link: 'https://www.nintendo.com/en-gb/Games/Nintendo-Switch-2-games/Daemon-X-Machina-Titanic-Scion-2849025.html?s=countries&nsuid=70070000028510#Digital_Deluxe_Edition',
                },
                digitalSuper: {
                    name: 'Nintendo eShop',
                    link: 'https://www.nintendo.com/en-gb/Games/Nintendo-Switch-2-games/Daemon-X-Machina-Titanic-Scion-2849025.html?s=countries&nsuid=70070000028516#Super_Digital_Deluxe_Edition',
                },
            },
            physical: {
                physicalLimited: [],
                physicalStandard: [
                    {
                        name: 'Proshop',
                        link: 'https://www.proshop.dk/Spil/Daemon-X-Machina-Titanic-Scion-Nintendo-Switch-2/3360007',
                    },
                    {
                        name: 'CoolShop',
                        link: 'https://www.coolshop.dk/produkt/daemon-x-machina-titanic-scion/23R867/',
                    },
                ],
            },
        },
        ps5: {
            digital: {
                digitalStandard: {
                    name: 'PlayStation Store',
                    link: 'https://store.playstation.com/product/EP4492-PPSA29136_00-DXMTSFULLGAME000',
                },
                digitalDeluxe: {
                    name: 'PlayStation Store',
                    link: 'https://store.playstation.com/product/EP4492-PPSA29136_00-DXMTSDELUXE00000',
                },
                digitalSuper: {
                    name: 'PlayStation Store',
                    link: 'https://store.playstation.com/product/EP4492-PPSA29136_00-DXMTSPREDELUXE00',
                },
            },
            physical: {
                physicalLimited: [],
                physicalStandard: [
                    {
                        name: 'Proshop',
                        link: 'https://www.proshop.dk/Spil/Daemon-X-Machina-Titanic-Scion-Sony-PlayStation-5-Action/3401137',
                    },
                    {
                        name: 'CoolShop',
                        link: 'https://www.coolshop.dk/produkt/daemon-x-machina-titanic-scion/23R867/',
                    },
                ],
            },
        },
        xbox: {
            digital: {
                digitalStandard: {
                    name: 'Microsoft Store',
                    link: 'https://www.xbox.com/games/store/daemon-x-machina-titanic-scion/9MSTS8GMBR8P',
                },
                digitalDeluxe: {
                    name: 'Microsoft Store',
                    link: 'https://www.xbox.com/games/store/daemon-x-machina-titanic-scion-digital-deluxe-edition/9PFWGSJWV60W',
                },
                digitalSuper: {
                    name: 'Microsoft Store',
                    link: 'https://www.xbox.com/games/store/daemon-x-machina-titanic-scion-super-digital-deluxe-edition/9NHX85JHNBL5',
                },
            },
            physical: {
                physicalLimited: [],
                physicalStandard: [
                    {
                        name: 'Proshop',
                        link: 'https://www.proshop.dk/Spil/Daemon-X-Machina-Titanic-Scion-Microsoft-Xbox-Series-X-Action/3401376',
                    },
                    {
                        name: 'CoolShop',
                        link: 'https://www.coolshop.dk/produkt/daemon-x-machina-titanic-scion/23R86A/',
                    },
                ],
            },
        },
        steam: {
            digital: {
                digitalStandard: {
                    name: 'steam',
                    link: 'https://store.steampowered.com/app/1342490/Daemon_X_Machina_Titanic_Scion/',
                },
                digitalDeluxe: {
                    name: 'steam',
                    link: 'https://store.steampowered.com/app/1342490/Daemon_X_Machina_Titanic_Scion/',
                },
                digitalSuper: {
                    name: 'steam',
                    link: 'https://store.steampowered.com/app/1342490/Daemon_X_Machina_Titanic_Scion/',
                },
            },
        },
    },
    at: {
        switch: {
            digital: {
                digitalStandard: {
                    name: 'Nintendo eShop',
                    link: 'https://www.nintendo.com/en-gb/Games/Nintendo-Switch-2-games/Daemon-X-Machina-Titanic-Scion-2849025.html?s=countries',
                },
                digitalDeluxe: {
                    name: 'Nintendo eShop',
                    link: 'https://www.nintendo.com/en-gb/Games/Nintendo-Switch-2-games/Daemon-X-Machina-Titanic-Scion-2849025.html?s=countries&nsuid=70070000028510#Digital_Deluxe_Edition',
                },
                digitalSuper: {
                    name: 'Nintendo eShop',
                    link: 'https://www.nintendo.com/en-gb/Games/Nintendo-Switch-2-games/Daemon-X-Machina-Titanic-Scion-2849025.html?s=countries&nsuid=70070000028516#Super_Digital_Deluxe_Edition',
                },
            },
            physical: {
                physicalLimited: [],
                physicalStandard: [],
            },
        },
        ps5: {
            digital: {
                digitalStandard: {
                    name: 'PlayStation Store',
                    link: 'https://store.playstation.com/product/EP4492-PPSA29136_00-DXMTSFULLGAME000',
                },
                digitalDeluxe: {
                    name: 'PlayStation Store',
                    link: 'https://store.playstation.com/product/EP4492-PPSA29136_00-DXMTSDELUXE00000',
                },
                digitalSuper: {
                    name: 'PlayStation Store',
                    link: 'https://store.playstation.com/product/EP4492-PPSA29136_00-DXMTSPREDELUXE00',
                },
            },
            physical: {
                physicalLimited: [],
                physicalStandard: [],
            },
        },
        xbox: {
            digital: {
                digitalStandard: {
                    name: 'Microsoft Store',
                    link: 'https://www.xbox.com/games/store/daemon-x-machina-titanic-scion/9MSTS8GMBR8P',
                },
                digitalDeluxe: {
                    name: 'Microsoft Store',
                    link: 'https://www.xbox.com/games/store/daemon-x-machina-titanic-scion-digital-deluxe-edition/9PFWGSJWV60W',
                },
                digitalSuper: {
                    name: 'Microsoft Store',
                    link: 'https://www.xbox.com/games/store/daemon-x-machina-titanic-scion-super-digital-deluxe-edition/9NHX85JHNBL5',
                },
            },
            physical: {
                physicalLimited: [],
                physicalStandard: [],
            },
        },
        steam: {
            digital: {
                digitalStandard: {
                    name: 'steam',
                    link: 'https://store.steampowered.com/app/1342490/Daemon_X_Machina_Titanic_Scion/',
                },
                digitalDeluxe: {
                    name: 'steam',
                    link: 'https://store.steampowered.com/app/1342490/Daemon_X_Machina_Titanic_Scion/',
                },
                digitalSuper: {
                    name: 'steam',
                    link: 'https://store.steampowered.com/app/1342490/Daemon_X_Machina_Titanic_Scion/',
                },
            },
        },
    },
};
exports.comingSoon = {
    en: 'Links Coming Soon',
    ca: 'Links Coming Soon',
    uk: 'Links Coming Soon',
    au: 'Links Coming Soon',
    nz: 'Links Coming Soon',
    fr: 'Liens bientôt disponibles',
    de: 'Links bald verfügbar',
    es: 'Enlaces muy pronto',
    it: 'Link in arrivo',
    nl: 'Links binnenkort beschikbaar',
    pt: 'Links disponíveis em breve',
    ch: 'Links Coming Soon',
    be: 'Links Coming Soon',
    pl: 'Links Coming Soon',
    se: 'Links Coming Soon',
    no: 'Links Coming Soon',
    dk: 'Links Coming Soon',
    at: 'Links Coming Soon',
};
exports.editionsInfo = {
    en: {
        switch: {
            physicalLimited: {
                image_640: physical_LE_640_combo_US_jpg_1.default,
                image_1280: physical_LE_1280_combo_US_jpg_1.default,
                image_640_webp: physical_LE_640_combo_US_webp_1.default,
                image_1280_webp: physical_LE_1280_combo_US_webp_1.default,
            },
            physicalStandard: {
                image_640: physical_SE_640_NSW_US_png_1.default,
                image_1280: physical_SE_1280_NSW_US_png_1.default,
                image_640_webp: physical_SE_640_NSW_US_webp_1.default,
                image_1280_webp: physical_SE_1280_NSW_US_webp_1.default,
            },
            digitalStandard: {
                image_640: digital_640_esrb_jpg_1.default,
                image_1280: digital_1280_esrb_jpg_1.default,
                image_640_webp: digital_640_esrb_webp_1.default,
                image_1280_webp: digital_1280_esrb_webp_1.default,
            },
            digitalDeluxe: {
                image_640: digital_640_esrb_jpg_1.default,
                image_1280: digital_1280_esrb_jpg_1.default,
                image_640_webp: digital_640_esrb_webp_1.default,
                image_1280_webp: digital_1280_esrb_webp_1.default,
            },
            digitalSuper: {
                image_640: digital_640_esrb_jpg_1.default,
                image_1280: digital_1280_esrb_jpg_1.default,
                image_640_webp: digital_640_esrb_webp_1.default,
                image_1280_webp: digital_1280_esrb_webp_1.default,
            },
        },
        ps5: {
            physicalLimited: {
                image_640: physical_LE_640_combo_US_jpg_1.default,
                image_1280: physical_LE_1280_combo_US_jpg_1.default,
                image_640_webp: physical_LE_640_combo_US_webp_1.default,
                image_1280_webp: physical_LE_1280_combo_US_webp_1.default,
            },
            physicalStandard: {
                image_640: physical_SE_640_PS5_png_1.default,
                image_1280: physical_SE_1280_PS5_png_1.default,
                image_640_webp: physical_SE_640_PS5_webp_1.default,
                image_1280_webp: physical_SE_1280_PS5_webp_1.default,
            },
            digitalStandard: {
                image_640: digital_640_esrb_jpg_1.default,
                image_1280: digital_1280_esrb_jpg_1.default,
                image_640_webp: digital_640_esrb_webp_1.default,
                image_1280_webp: digital_1280_esrb_webp_1.default,
            },
            digitalDeluxe: {
                image_640: digital_640_esrb_jpg_1.default,
                image_1280: digital_1280_esrb_jpg_1.default,
                image_640_webp: digital_640_esrb_webp_1.default,
                image_1280_webp: digital_1280_esrb_webp_1.default,
            },
            digitalSuper: {
                image_640: digital_640_esrb_jpg_1.default,
                image_1280: digital_1280_esrb_jpg_1.default,
                image_640_webp: digital_640_esrb_webp_1.default,
                image_1280_webp: digital_1280_esrb_webp_1.default,
            },
        },
        xbox: {
            physicalLimited: {
                image_640: physical_LE_640_combo_US_jpg_1.default,
                image_1280: physical_LE_1280_combo_US_jpg_1.default,
                image_640_webp: physical_LE_640_combo_US_webp_1.default,
                image_1280_webp: physical_LE_1280_combo_US_webp_1.default,
            },
            physicalStandard: {
                image_640: physical_SE_640_xbox_png_1.default,
                image_1280: physical_SE_1280_xbox_png_1.default,
                image_640_webp: physical_SE_640_xbox_webp_1.default,
                image_1280_webp: physical_SE_1280_xbox_webp_1.default,
            },
            digitalStandard: {
                image_640: digital_640_esrb_jpg_1.default,
                image_1280: digital_1280_esrb_jpg_1.default,
                image_640_webp: digital_640_esrb_webp_1.default,
                image_1280_webp: digital_1280_esrb_webp_1.default,
            },
            digitalDeluxe: {
                image_640: digital_640_esrb_jpg_1.default,
                image_1280: digital_1280_esrb_jpg_1.default,
                image_640_webp: digital_640_esrb_webp_1.default,
                image_1280_webp: digital_1280_esrb_webp_1.default,
            },
            digitalSuper: {
                image_640: digital_640_esrb_jpg_1.default,
                image_1280: digital_1280_esrb_jpg_1.default,
                image_640_webp: digital_640_esrb_webp_1.default,
                image_1280_webp: digital_1280_esrb_webp_1.default,
            },
        },
        steam: {
            digitalStandard: {
                image_640: digital_640_esrb_jpg_1.default,
                image_1280: digital_1280_esrb_jpg_1.default,
                image_640_webp: digital_640_esrb_webp_1.default,
                image_1280_webp: digital_1280_esrb_webp_1.default,
            },
            digitalDeluxe: {
                image_640: digital_640_esrb_jpg_1.default,
                image_1280: digital_1280_esrb_jpg_1.default,
                image_640_webp: digital_640_esrb_webp_1.default,
                image_1280_webp: digital_1280_esrb_webp_1.default,
            },
            digitalSuper: {
                image_640: digital_640_esrb_jpg_1.default,
                image_1280: digital_1280_esrb_jpg_1.default,
                image_640_webp: digital_640_esrb_webp_1.default,
                image_1280_webp: digital_1280_esrb_webp_1.default,
            },
        },
    },
    ca: {
        switch: {
            physicalLimited: {
                image_640: physical_LE_640_combo_US_jpg_1.default,
                image_1280: physical_LE_1280_combo_US_jpg_1.default,
                image_640_webp: physical_LE_640_combo_US_webp_1.default,
                image_1280_webp: physical_LE_1280_combo_US_webp_1.default,
            },
            physicalStandard: {
                image_640: physical_SE_640_NSW_US_png_1.default,
                image_1280: physical_SE_1280_NSW_US_png_1.default,
                image_640_webp: physical_SE_640_NSW_US_webp_1.default,
                image_1280_webp: physical_SE_1280_NSW_US_webp_1.default,
            },
            digitalStandard: {
                image_640: digital_640_esrb_jpg_1.default,
                image_1280: digital_1280_esrb_jpg_1.default,
                image_640_webp: digital_640_esrb_webp_1.default,
                image_1280_webp: digital_1280_esrb_webp_1.default,
            },
            digitalDeluxe: {
                image_640: digital_640_esrb_jpg_1.default,
                image_1280: digital_1280_esrb_jpg_1.default,
                image_640_webp: digital_640_esrb_webp_1.default,
                image_1280_webp: digital_1280_esrb_webp_1.default,
            },
            digitalSuper: {
                image_640: digital_640_esrb_jpg_1.default,
                image_1280: digital_1280_esrb_jpg_1.default,
                image_640_webp: digital_640_esrb_webp_1.default,
                image_1280_webp: digital_1280_esrb_webp_1.default,
            },
        },
        ps5: {
            physicalLimited: {
                image_640: physical_LE_640_combo_US_jpg_1.default,
                image_1280: physical_LE_1280_combo_US_jpg_1.default,
                image_640_webp: physical_LE_640_combo_US_webp_1.default,
                image_1280_webp: physical_LE_1280_combo_US_webp_1.default,
            },
            physicalStandard: {
                image_640: physical_SE_640_PS5_png_1.default,
                image_1280: physical_SE_1280_PS5_png_1.default,
                image_640_webp: physical_SE_640_PS5_webp_1.default,
                image_1280_webp: physical_SE_1280_PS5_webp_1.default,
            },
            digitalStandard: {
                image_640: digital_640_esrb_jpg_1.default,
                image_1280: digital_1280_esrb_jpg_1.default,
                image_640_webp: digital_640_esrb_webp_1.default,
                image_1280_webp: digital_1280_esrb_webp_1.default,
            },
            digitalDeluxe: {
                image_640: digital_640_esrb_jpg_1.default,
                image_1280: digital_1280_esrb_jpg_1.default,
                image_640_webp: digital_640_esrb_webp_1.default,
                image_1280_webp: digital_1280_esrb_webp_1.default,
            },
            digitalSuper: {
                image_640: digital_640_esrb_jpg_1.default,
                image_1280: digital_1280_esrb_jpg_1.default,
                image_640_webp: digital_640_esrb_webp_1.default,
                image_1280_webp: digital_1280_esrb_webp_1.default,
            },
        },
        xbox: {
            physicalLimited: {
                image_640: physical_LE_640_combo_US_jpg_1.default,
                image_1280: physical_LE_1280_combo_US_jpg_1.default,
                image_640_webp: physical_LE_640_combo_US_webp_1.default,
                image_1280_webp: physical_LE_1280_combo_US_webp_1.default,
            },
            physicalStandard: {
                image_640: physical_SE_640_xbox_png_1.default,
                image_1280: physical_SE_1280_xbox_png_1.default,
                image_640_webp: physical_SE_640_xbox_webp_1.default,
                image_1280_webp: physical_SE_1280_xbox_webp_1.default,
            },
            digitalStandard: {
                image_640: digital_640_esrb_jpg_1.default,
                image_1280: digital_1280_esrb_jpg_1.default,
                image_640_webp: digital_640_esrb_webp_1.default,
                image_1280_webp: digital_1280_esrb_webp_1.default,
            },
            digitalDeluxe: {
                image_640: digital_640_esrb_jpg_1.default,
                image_1280: digital_1280_esrb_jpg_1.default,
                image_640_webp: digital_640_esrb_webp_1.default,
                image_1280_webp: digital_1280_esrb_webp_1.default,
            },
            digitalSuper: {
                image_640: digital_640_esrb_jpg_1.default,
                image_1280: digital_1280_esrb_jpg_1.default,
                image_640_webp: digital_640_esrb_webp_1.default,
                image_1280_webp: digital_1280_esrb_webp_1.default,
            },
        },
        steam: {
            digitalStandard: {
                image_640: digital_640_esrb_jpg_1.default,
                image_1280: digital_1280_esrb_jpg_1.default,
                image_640_webp: digital_640_esrb_webp_1.default,
                image_1280_webp: digital_1280_esrb_webp_1.default,
            },
            digitalDeluxe: {
                image_640: digital_640_esrb_jpg_1.default,
                image_1280: digital_1280_esrb_jpg_1.default,
                image_640_webp: digital_640_esrb_webp_1.default,
                image_1280_webp: digital_1280_esrb_webp_1.default,
            },
            digitalSuper: {
                image_640: digital_640_esrb_jpg_1.default,
                image_1280: digital_1280_esrb_jpg_1.default,
                image_640_webp: digital_640_esrb_webp_1.default,
                image_1280_webp: digital_1280_esrb_webp_1.default,
            },
        },
    },
    uk: {
        switch: {
            physicalLimited: {
                image_640: physical_LE_640_UK_jpg_1.default,
                image_1280: physical_LE_1280_UK_jpg_1.default,
                image_640_webp: physical_LE_640_UK_webp_1.default,
                image_1280_webp: physical_LE_1280_UK_webp_1.default,
            },
            physicalStandard: {
                image_640: physical_SE_640_NSW_PEGI_png_1.default,
                image_1280: physical_SE_1280_NSW_PEGI_png_1.default,
                image_640_webp: physical_SE_640_NSW_PEGI_webp_1.default,
                image_1280_webp: physical_SE_1280_NSW_PEGI_webp_1.default,
            },
            digitalStandard: {
                image_640: digital_640_pegi_jpg_1.default,
                image_1280: digital_1280_pegi_jpg_1.default,
                image_640_webp: digital_640_pegi_webp_1.default,
                image_1280_webp: digital_1280_pegi_webp_1.default,
            },
            digitalDeluxe: {
                image_640: digital_640_pegi_jpg_1.default,
                image_1280: digital_1280_pegi_jpg_1.default,
                image_640_webp: digital_640_pegi_webp_1.default,
                image_1280_webp: digital_1280_pegi_webp_1.default,
            },
            digitalSuper: {
                image_640: digital_640_pegi_jpg_1.default,
                image_1280: digital_1280_pegi_jpg_1.default,
                image_640_webp: digital_640_pegi_webp_1.default,
                image_1280_webp: digital_1280_pegi_webp_1.default,
            },
        },
        ps5: {
            physicalLimited: {
                image_640: physical_LE_640_NSW_png_1.default,
                image_1280: physical_LE_1280_NSW_png_1.default,
                image_640_webp: physical_LE_640_NSW_webp_1.default,
                image_1280_webp: physical_LE_1280_NSW_webp_1.default,
            },
            physicalStandard: {
                image_640: physical_SE_640_ps5_PEGI_png_1.default,
                image_1280: physical_SE_1280_ps5_PEGI_png_1.default,
                image_640_webp: physical_SE_640_ps5_PEGI_webp_1.default,
                image_1280_webp: physical_SE_1280_ps5_PEGI_webp_1.default,
            },
            digitalStandard: {
                image_640: digital_640_pegi_jpg_1.default,
                image_1280: digital_1280_pegi_jpg_1.default,
                image_640_webp: digital_640_pegi_webp_1.default,
                image_1280_webp: digital_1280_pegi_webp_1.default,
            },
            digitalDeluxe: {
                image_640: digital_640_pegi_jpg_1.default,
                image_1280: digital_1280_pegi_jpg_1.default,
                image_640_webp: digital_640_pegi_webp_1.default,
                image_1280_webp: digital_1280_pegi_webp_1.default,
            },
            digitalSuper: {
                image_640: digital_640_pegi_jpg_1.default,
                image_1280: digital_1280_pegi_jpg_1.default,
                image_640_webp: digital_640_pegi_webp_1.default,
                image_1280_webp: digital_1280_pegi_webp_1.default,
            },
        },
        xbox: {
            physicalLimited: {
                image_640: physical_LE_640_NSW_png_1.default,
                image_1280: physical_LE_1280_NSW_png_1.default,
                image_640_webp: physical_LE_640_NSW_webp_1.default,
                image_1280_webp: physical_LE_1280_NSW_webp_1.default,
            },
            physicalStandard: {
                image_640: physical_SE_640_xbox_PEGI_png_1.default,
                image_1280: physical_SE_1280_xbox_PEGI_png_1.default,
                image_640_webp: physical_SE_640_xbox_PEGI_webp_1.default,
                image_1280_webp: physical_SE_1280_xbox_PEGI_webp_1.default,
            },
            digitalStandard: {
                image_640: digital_640_pegi_jpg_1.default,
                image_1280: digital_1280_pegi_jpg_1.default,
                image_640_webp: digital_640_pegi_webp_1.default,
                image_1280_webp: digital_1280_pegi_webp_1.default,
            },
            digitalDeluxe: {
                image_640: digital_640_pegi_jpg_1.default,
                image_1280: digital_1280_pegi_jpg_1.default,
                image_640_webp: digital_640_pegi_webp_1.default,
                image_1280_webp: digital_1280_pegi_webp_1.default,
            },
            digitalSuper: {
                image_640: digital_640_pegi_jpg_1.default,
                image_1280: digital_1280_pegi_jpg_1.default,
                image_640_webp: digital_640_pegi_webp_1.default,
                image_1280_webp: digital_1280_pegi_webp_1.default,
            },
        },
        steam: {
            digitalStandard: {
                image_640: digital_640_pegi_jpg_1.default,
                image_1280: digital_1280_pegi_jpg_1.default,
                image_640_webp: digital_640_pegi_webp_1.default,
                image_1280_webp: digital_1280_pegi_webp_1.default,
            },
            digitalDeluxe: {
                image_640: digital_640_pegi_jpg_1.default,
                image_1280: digital_1280_pegi_jpg_1.default,
                image_640_webp: digital_640_pegi_webp_1.default,
                image_1280_webp: digital_1280_pegi_webp_1.default,
            },
            digitalSuper: {
                image_640: digital_640_pegi_jpg_1.default,
                image_1280: digital_1280_pegi_jpg_1.default,
                image_640_webp: digital_640_pegi_webp_1.default,
                image_1280_webp: digital_1280_pegi_webp_1.default,
            },
        },
    },
    fr: {
        switch: {
            physicalLimited: {
                image_640: physical_LE_640_FR_jpg_1.default,
                image_1280: physical_LE_1280_FR_jpg_1.default,
                image_640_webp: physical_LE_640_FR_webp_1.default,
                image_1280_webp: physical_LE_1280_FR_webp_1.default,
            },
            physicalStandard: {
                image_640: physical_SE_640_NSW_PEGI_png_1.default,
                image_1280: physical_SE_1280_NSW_PEGI_png_1.default,
                image_640_webp: physical_SE_640_NSW_PEGI_webp_1.default,
                image_1280_webp: physical_SE_1280_NSW_PEGI_webp_1.default,
            },
            digitalStandard: {
                image_640: digital_640_fr_jpg_1.default,
                image_1280: digital_1280_fr_jpg_1.default,
                image_640_webp: digital_640_fr_webp_1.default,
                image_1280_webp: digital_1280_fr_webp_1.default,
            },
            digitalDeluxe: {
                image_640: digital_640_fr_jpg_1.default,
                image_1280: digital_1280_fr_jpg_1.default,
                image_640_webp: digital_640_fr_webp_1.default,
                image_1280_webp: digital_1280_fr_webp_1.default,
            },
            digitalSuper: {
                image_640: digital_640_fr_jpg_1.default,
                image_1280: digital_1280_fr_jpg_1.default,
                image_640_webp: digital_640_fr_webp_1.default,
                image_1280_webp: digital_1280_fr_webp_1.default,
            },
        },
        ps5: {
            physicalLimited: {
                image_640: physical_LE_640_NSW_png_1.default,
                image_1280: physical_LE_1280_NSW_png_1.default,
                image_640_webp: physical_LE_640_NSW_webp_1.default,
                image_1280_webp: physical_LE_1280_NSW_webp_1.default,
            },
            physicalStandard: {
                image_640: physical_SE_640_ps5_PEGI_png_1.default,
                image_1280: physical_SE_1280_ps5_PEGI_png_1.default,
                image_640_webp: physical_SE_640_ps5_PEGI_webp_1.default,
                image_1280_webp: physical_SE_1280_ps5_PEGI_webp_1.default,
            },
            digitalStandard: {
                image_640: digital_640_fr_jpg_1.default,
                image_1280: digital_1280_fr_jpg_1.default,
                image_640_webp: digital_640_fr_webp_1.default,
                image_1280_webp: digital_1280_fr_webp_1.default,
            },
            digitalDeluxe: {
                image_640: digital_640_fr_jpg_1.default,
                image_1280: digital_1280_fr_jpg_1.default,
                image_640_webp: digital_640_fr_webp_1.default,
                image_1280_webp: digital_1280_fr_webp_1.default,
            },
            digitalSuper: {
                image_640: digital_640_fr_jpg_1.default,
                image_1280: digital_1280_fr_jpg_1.default,
                image_640_webp: digital_640_fr_webp_1.default,
                image_1280_webp: digital_1280_fr_webp_1.default,
            },
        },
        xbox: {
            physicalLimited: {
                image_640: physical_LE_640_NSW_png_1.default,
                image_1280: physical_LE_1280_NSW_png_1.default,
                image_640_webp: physical_LE_640_NSW_webp_1.default,
                image_1280_webp: physical_LE_1280_NSW_webp_1.default,
            },
            physicalStandard: {
                image_640: physical_SE_640_xbox_PEGI_png_1.default,
                image_1280: physical_SE_1280_xbox_PEGI_png_1.default,
                image_640_webp: physical_SE_640_xbox_PEGI_webp_1.default,
                image_1280_webp: physical_SE_1280_xbox_PEGI_webp_1.default,
            },
            digitalStandard: {
                image_640: digital_640_fr_jpg_1.default,
                image_1280: digital_1280_fr_jpg_1.default,
                image_640_webp: digital_640_fr_webp_1.default,
                image_1280_webp: digital_1280_fr_webp_1.default,
            },
            digitalDeluxe: {
                image_640: digital_640_fr_jpg_1.default,
                image_1280: digital_1280_fr_jpg_1.default,
                image_640_webp: digital_640_fr_webp_1.default,
                image_1280_webp: digital_1280_fr_webp_1.default,
            },
            digitalSuper: {
                image_640: digital_640_fr_jpg_1.default,
                image_1280: digital_1280_fr_jpg_1.default,
                image_640_webp: digital_640_fr_webp_1.default,
                image_1280_webp: digital_1280_fr_webp_1.default,
            },
        },
        steam: {
            digitalStandard: {
                image_640: digital_640_fr_jpg_1.default,
                image_1280: digital_1280_fr_jpg_1.default,
                image_640_webp: digital_640_fr_webp_1.default,
                image_1280_webp: digital_1280_fr_webp_1.default,
            },
            digitalDeluxe: {
                image_640: digital_640_fr_jpg_1.default,
                image_1280: digital_1280_fr_jpg_1.default,
                image_640_webp: digital_640_fr_webp_1.default,
                image_1280_webp: digital_1280_fr_webp_1.default,
            },
            digitalSuper: {
                image_640: digital_640_fr_jpg_1.default,
                image_1280: digital_1280_fr_jpg_1.default,
                image_640_webp: digital_640_fr_webp_1.default,
                image_1280_webp: digital_1280_fr_webp_1.default,
            },
        },
    },
    de: {
        switch: {
            physicalLimited: {
                image_640: physical_LE_640_DE_jpg_1.default,
                image_1280: physical_LE_1280_DE_jpg_1.default,
                image_640_webp: physical_LE_640_DE_webp_1.default,
                image_1280_webp: physical_LE_1280_DE_webp_1.default,
            },
            physicalStandard: {
                image_640: physical_SE_640_NSW_USK_png_1.default,
                image_1280: physical_SE_1280_NSW_USK_png_1.default,
                image_640_webp: physical_SE_640_NSW_USK_webp_1.default,
                image_1280_webp: physical_SE_1280_NSW_USK_webp_1.default,
            },
            digitalStandard: {
                image_640: digital_640_de_jpg_1.default,
                image_1280: digital_1280_de_jpg_1.default,
                image_640_webp: digital_640_de_webp_1.default,
                image_1280_webp: digital_1280_de_webp_1.default,
            },
            digitalDeluxe: {
                image_640: digital_640_de_jpg_1.default,
                image_1280: digital_1280_de_jpg_1.default,
                image_640_webp: digital_640_de_webp_1.default,
                image_1280_webp: digital_1280_de_webp_1.default,
            },
            digitalSuper: {
                image_640: digital_640_de_jpg_1.default,
                image_1280: digital_1280_de_jpg_1.default,
                image_640_webp: digital_640_de_webp_1.default,
                image_1280_webp: digital_1280_de_webp_1.default,
            },
        },
        ps5: {
            physicalLimited: {
                image_640: physical_LE_640_NSW_png_1.default,
                image_1280: physical_LE_1280_NSW_png_1.default,
                image_640_webp: physical_LE_640_NSW_webp_1.default,
                image_1280_webp: physical_LE_1280_NSW_webp_1.default,
            },
            physicalStandard: {
                image_640: physical_SE_640_ps5_USK_png_1.default,
                image_1280: physical_SE_1280_ps5_USK_png_1.default,
                image_640_webp: physical_SE_640_ps5_USK_webp_1.default,
                image_1280_webp: physical_SE_1280_ps5_USK_webp_1.default,
            },
            digitalStandard: {
                image_640: digital_640_de_jpg_1.default,
                image_1280: digital_1280_de_jpg_1.default,
                image_640_webp: digital_640_de_webp_1.default,
                image_1280_webp: digital_1280_de_webp_1.default,
            },
            digitalDeluxe: {
                image_640: digital_640_de_jpg_1.default,
                image_1280: digital_1280_de_jpg_1.default,
                image_640_webp: digital_640_de_webp_1.default,
                image_1280_webp: digital_1280_de_webp_1.default,
            },
            digitalSuper: {
                image_640: digital_640_de_jpg_1.default,
                image_1280: digital_1280_de_jpg_1.default,
                image_640_webp: digital_640_de_webp_1.default,
                image_1280_webp: digital_1280_de_webp_1.default,
            },
        },
        xbox: {
            physicalLimited: {
                image_640: physical_LE_640_NSW_png_1.default,
                image_1280: physical_LE_1280_NSW_png_1.default,
                image_640_webp: physical_LE_640_NSW_webp_1.default,
                image_1280_webp: physical_LE_1280_NSW_webp_1.default,
            },
            physicalStandard: {
                image_640: physical_SE_640_xbox_USK_png_1.default,
                image_1280: physical_SE_1280_xbox_USK_png_1.default,
                image_640_webp: physical_SE_640_xbox_USK_webp_1.default,
                image_1280_webp: physical_SE_1280_xbox_USK_webp_1.default,
            },
            digitalStandard: {
                image_640: digital_640_de_jpg_1.default,
                image_1280: digital_1280_de_jpg_1.default,
                image_640_webp: digital_640_de_webp_1.default,
                image_1280_webp: digital_1280_de_webp_1.default,
            },
            digitalDeluxe: {
                image_640: digital_640_de_jpg_1.default,
                image_1280: digital_1280_de_jpg_1.default,
                image_640_webp: digital_640_de_webp_1.default,
                image_1280_webp: digital_1280_de_webp_1.default,
            },
            digitalSuper: {
                image_640: digital_640_de_jpg_1.default,
                image_1280: digital_1280_de_jpg_1.default,
                image_640_webp: digital_640_de_webp_1.default,
                image_1280_webp: digital_1280_de_webp_1.default,
            },
        },
        steam: {
            digitalStandard: {
                image_640: digital_640_de_jpg_1.default,
                image_1280: digital_1280_de_jpg_1.default,
                image_640_webp: digital_640_de_webp_1.default,
                image_1280_webp: digital_1280_de_webp_1.default,
            },
            digitalDeluxe: {
                image_640: digital_640_de_jpg_1.default,
                image_1280: digital_1280_de_jpg_1.default,
                image_640_webp: digital_640_de_webp_1.default,
                image_1280_webp: digital_1280_de_webp_1.default,
            },
            digitalSuper: {
                image_640: digital_640_de_jpg_1.default,
                image_1280: digital_1280_de_jpg_1.default,
                image_640_webp: digital_640_de_webp_1.default,
                image_1280_webp: digital_1280_de_webp_1.default,
            },
        },
    },
    es: {
        switch: {
            physicalLimited: {
                image_640: physical_LE_640_ES_jpg_1.default,
                image_1280: physical_LE_1280_ES_jpg_1.default,
                image_640_webp: physical_LE_640_ES_webp_1.default,
                image_1280_webp: physical_LE_1280_ES_webp_1.default,
            },
            physicalStandard: {
                image_640: physical_SE_640_NSW_PEGI_png_1.default,
                image_1280: physical_SE_1280_NSW_PEGI_png_1.default,
                image_640_webp: physical_SE_640_NSW_PEGI_webp_1.default,
                image_1280_webp: physical_SE_1280_NSW_PEGI_webp_1.default,
            },
            digitalStandard: {
                image_640: digital_640_es_jpg_1.default,
                image_1280: digital_1280_es_jpg_1.default,
                image_640_webp: digital_640_es_webp_1.default,
                image_1280_webp: digital_1280_es_webp_1.default,
            },
            digitalDeluxe: {
                image_640: digital_640_es_jpg_1.default,
                image_1280: digital_1280_es_jpg_1.default,
                image_640_webp: digital_640_es_webp_1.default,
                image_1280_webp: digital_1280_es_webp_1.default,
            },
            digitalSuper: {
                image_640: digital_640_es_jpg_1.default,
                image_1280: digital_1280_es_jpg_1.default,
                image_640_webp: digital_640_es_webp_1.default,
                image_1280_webp: digital_1280_es_webp_1.default,
            },
        },
        ps5: {
            physicalLimited: {
                image_640: physical_LE_640_NSW_png_1.default,
                image_1280: physical_LE_1280_NSW_png_1.default,
                image_640_webp: physical_LE_640_NSW_webp_1.default,
                image_1280_webp: physical_LE_1280_NSW_webp_1.default,
            },
            physicalStandard: {
                image_640: physical_SE_640_ps5_PEGI_png_1.default,
                image_1280: physical_SE_1280_ps5_PEGI_png_1.default,
                image_640_webp: physical_SE_640_ps5_PEGI_webp_1.default,
                image_1280_webp: physical_SE_1280_ps5_PEGI_webp_1.default,
            },
            digitalStandard: {
                image_640: digital_640_es_jpg_1.default,
                image_1280: digital_1280_es_jpg_1.default,
                image_640_webp: digital_640_es_webp_1.default,
                image_1280_webp: digital_1280_es_webp_1.default,
            },
            digitalDeluxe: {
                image_640: digital_640_es_jpg_1.default,
                image_1280: digital_1280_es_jpg_1.default,
                image_640_webp: digital_640_es_webp_1.default,
                image_1280_webp: digital_1280_es_webp_1.default,
            },
            digitalSuper: {
                image_640: digital_640_es_jpg_1.default,
                image_1280: digital_1280_es_jpg_1.default,
                image_640_webp: digital_640_es_webp_1.default,
                image_1280_webp: digital_1280_es_webp_1.default,
            },
        },
        xbox: {
            physicalLimited: {
                image_640: physical_LE_640_NSW_png_1.default,
                image_1280: physical_LE_1280_NSW_png_1.default,
                image_640_webp: physical_LE_640_NSW_webp_1.default,
                image_1280_webp: physical_LE_1280_NSW_webp_1.default,
            },
            physicalStandard: {
                image_640: physical_SE_640_xbox_PEGI_png_1.default,
                image_1280: physical_SE_1280_xbox_PEGI_png_1.default,
                image_640_webp: physical_SE_640_xbox_PEGI_webp_1.default,
                image_1280_webp: physical_SE_1280_xbox_PEGI_webp_1.default,
            },
            digitalStandard: {
                image_640: digital_640_es_jpg_1.default,
                image_1280: digital_1280_es_jpg_1.default,
                image_640_webp: digital_640_es_webp_1.default,
                image_1280_webp: digital_1280_es_webp_1.default,
            },
            digitalDeluxe: {
                image_640: digital_640_es_jpg_1.default,
                image_1280: digital_1280_es_jpg_1.default,
                image_640_webp: digital_640_es_webp_1.default,
                image_1280_webp: digital_1280_es_webp_1.default,
            },
            digitalSuper: {
                image_640: digital_640_es_jpg_1.default,
                image_1280: digital_1280_es_jpg_1.default,
                image_640_webp: digital_640_es_webp_1.default,
                image_1280_webp: digital_1280_es_webp_1.default,
            },
        },
        steam: {
            digitalStandard: {
                image_640: digital_640_es_jpg_1.default,
                image_1280: digital_1280_es_jpg_1.default,
                image_640_webp: digital_640_es_webp_1.default,
                image_1280_webp: digital_1280_es_webp_1.default,
            },
            digitalDeluxe: {
                image_640: digital_640_es_jpg_1.default,
                image_1280: digital_1280_es_jpg_1.default,
                image_640_webp: digital_640_es_webp_1.default,
                image_1280_webp: digital_1280_es_webp_1.default,
            },
            digitalSuper: {
                image_640: digital_640_es_jpg_1.default,
                image_1280: digital_1280_es_jpg_1.default,
                image_640_webp: digital_640_es_webp_1.default,
                image_1280_webp: digital_1280_es_webp_1.default,
            },
        },
    },
    au: {
        switch: {
            physicalLimited: {
                image_640: physical_LE_640_AU_jpg_1.default,
                image_1280: physical_LE_1280_AU_jpg_1.default,
                image_640_webp: physical_LE_640_AU_webp_1.default,
                image_1280_webp: physical_LE_1280_AU_webp_1.default,
            },
            physicalStandard: {
                image_640: physical_SE_640_NSW_AU_png_1.default,
                image_1280: physical_SE_1280_NSW_AU_png_1.default,
                image_640_webp: physical_SE_640_NSW_AU_webp_1.default,
                image_1280_webp: physical_SE_1280_NSW_AU_webp_1.default,
            },
            digitalStandard: {
                image_640: digital_640_au_jpg_1.default,
                image_1280: digital_1280_au_jpg_1.default,
                image_640_webp: digital_640_au_webp_1.default,
                image_1280_webp: digital_1280_au_webp_1.default,
            },
            digitalDeluxe: {
                image_640: digital_640_au_jpg_1.default,
                image_1280: digital_1280_au_jpg_1.default,
                image_640_webp: digital_640_au_webp_1.default,
                image_1280_webp: digital_1280_au_webp_1.default,
            },
            digitalSuper: {
                image_640: digital_640_au_jpg_1.default,
                image_1280: digital_1280_au_jpg_1.default,
                image_640_webp: digital_640_au_webp_1.default,
                image_1280_webp: digital_1280_au_webp_1.default,
            },
        },
        ps5: {
            physicalLimited: {
                image_640: physical_LE_640_NSW_png_1.default,
                image_1280: physical_LE_1280_NSW_png_1.default,
                image_640_webp: physical_LE_640_NSW_webp_1.default,
                image_1280_webp: physical_LE_1280_NSW_webp_1.default,
            },
            physicalStandard: {
                image_640: physical_SE_640_PS5_ACB_png_1.default,
                image_1280: physical_SE_1280_PS5_ACB_png_1.default,
                image_640_webp: physical_SE_640_PS5_ACB_webp_1.default,
                image_1280_webp: physical_SE_1280_PS5_ACB_webp_1.default,
            },
            digitalStandard: {
                image_640: digital_640_au_jpg_1.default,
                image_1280: digital_1280_au_jpg_1.default,
                image_640_webp: digital_640_au_webp_1.default,
                image_1280_webp: digital_1280_au_webp_1.default,
            },
            digitalDeluxe: {
                image_640: digital_640_au_jpg_1.default,
                image_1280: digital_1280_au_jpg_1.default,
                image_640_webp: digital_640_au_webp_1.default,
                image_1280_webp: digital_1280_au_webp_1.default,
            },
            digitalSuper: {
                image_640: digital_640_au_jpg_1.default,
                image_1280: digital_1280_au_jpg_1.default,
                image_640_webp: digital_640_au_webp_1.default,
                image_1280_webp: digital_1280_au_webp_1.default,
            },
        },
        xbox: {
            physicalLimited: {
                image_640: physical_LE_640_NSW_png_1.default,
                image_1280: physical_LE_1280_NSW_png_1.default,
                image_640_webp: physical_LE_640_NSW_webp_1.default,
                image_1280_webp: physical_LE_1280_NSW_webp_1.default,
            },
            physicalStandard: {
                image_640: physical_SE_640_xbox_ACB_png_1.default,
                image_1280: physical_SE_1280_xbox_ACB_png_1.default,
                image_640_webp: physical_SE_640_xbox_ACB_webp_1.default,
                image_1280_webp: physical_SE_1280_xbox_ACB_webp_1.default,
            },
            digitalStandard: {
                image_640: digital_640_au_jpg_1.default,
                image_1280: digital_1280_au_jpg_1.default,
                image_640_webp: digital_640_au_webp_1.default,
                image_1280_webp: digital_1280_au_webp_1.default,
            },
            digitalDeluxe: {
                image_640: digital_640_au_jpg_1.default,
                image_1280: digital_1280_au_jpg_1.default,
                image_640_webp: digital_640_au_webp_1.default,
                image_1280_webp: digital_1280_au_webp_1.default,
            },
            digitalSuper: {
                image_640: digital_640_au_jpg_1.default,
                image_1280: digital_1280_au_jpg_1.default,
                image_640_webp: digital_640_au_webp_1.default,
                image_1280_webp: digital_1280_au_webp_1.default,
            },
        },
        steam: {
            digitalStandard: {
                image_640: digital_640_au_jpg_1.default,
                image_1280: digital_1280_au_jpg_1.default,
                image_640_webp: digital_640_au_webp_1.default,
                image_1280_webp: digital_1280_au_webp_1.default,
            },
            digitalDeluxe: {
                image_640: digital_640_au_jpg_1.default,
                image_1280: digital_1280_au_jpg_1.default,
                image_640_webp: digital_640_au_webp_1.default,
                image_1280_webp: digital_1280_au_webp_1.default,
            },
            digitalSuper: {
                image_640: digital_640_au_jpg_1.default,
                image_1280: digital_1280_au_jpg_1.default,
                image_640_webp: digital_640_au_webp_1.default,
                image_1280_webp: digital_1280_au_webp_1.default,
            },
        },
    },
    nz: {
        switch: {
            physicalLimited: {
                image_640: physical_LE_640_AU_jpg_1.default,
                image_1280: physical_LE_1280_AU_jpg_1.default,
                image_640_webp: physical_LE_640_AU_webp_1.default,
                image_1280_webp: physical_LE_1280_AU_webp_1.default,
            },
            physicalStandard: {
                image_640: physical_SE_640_NSW_AU_png_1.default,
                image_1280: physical_SE_1280_NSW_AU_png_1.default,
                image_640_webp: physical_SE_640_NSW_AU_webp_1.default,
                image_1280_webp: physical_SE_1280_NSW_AU_webp_1.default,
            },
            digitalStandard: {
                image_640: digital_640_au_jpg_1.default,
                image_1280: digital_1280_au_jpg_1.default,
                image_640_webp: digital_640_au_webp_1.default,
                image_1280_webp: digital_1280_au_webp_1.default,
            },
            digitalDeluxe: {
                image_640: digital_640_au_jpg_1.default,
                image_1280: digital_1280_au_jpg_1.default,
                image_640_webp: digital_640_au_webp_1.default,
                image_1280_webp: digital_1280_au_webp_1.default,
            },
            digitalSuper: {
                image_640: digital_640_au_jpg_1.default,
                image_1280: digital_1280_au_jpg_1.default,
                image_640_webp: digital_640_au_webp_1.default,
                image_1280_webp: digital_1280_au_webp_1.default,
            },
        },
        ps5: {
            physicalLimited: {
                image_640: physical_LE_640_NSW_png_1.default,
                image_1280: physical_LE_1280_NSW_png_1.default,
                image_640_webp: physical_LE_640_NSW_webp_1.default,
                image_1280_webp: physical_LE_1280_NSW_webp_1.default,
            },
            physicalStandard: {
                image_640: physical_SE_640_PS5_ACB_png_1.default,
                image_1280: physical_SE_1280_PS5_ACB_png_1.default,
                image_640_webp: physical_SE_640_PS5_ACB_webp_1.default,
                image_1280_webp: physical_SE_1280_PS5_ACB_webp_1.default,
            },
            digitalStandard: {
                image_640: digital_640_au_jpg_1.default,
                image_1280: digital_1280_au_jpg_1.default,
                image_640_webp: digital_640_au_webp_1.default,
                image_1280_webp: digital_1280_au_webp_1.default,
            },
            digitalDeluxe: {
                image_640: digital_640_au_jpg_1.default,
                image_1280: digital_1280_au_jpg_1.default,
                image_640_webp: digital_640_au_webp_1.default,
                image_1280_webp: digital_1280_au_webp_1.default,
            },
            digitalSuper: {
                image_640: digital_640_au_jpg_1.default,
                image_1280: digital_1280_au_jpg_1.default,
                image_640_webp: digital_640_au_webp_1.default,
                image_1280_webp: digital_1280_au_webp_1.default,
            },
        },
        xbox: {
            physicalLimited: {
                image_640: physical_LE_640_NSW_png_1.default,
                image_1280: physical_LE_1280_NSW_png_1.default,
                image_640_webp: physical_LE_640_NSW_webp_1.default,
                image_1280_webp: physical_LE_1280_NSW_webp_1.default,
            },
            physicalStandard: {
                image_640: physical_SE_640_xbox_ACB_png_1.default,
                image_1280: physical_SE_1280_xbox_ACB_png_1.default,
                image_640_webp: physical_SE_640_xbox_ACB_webp_1.default,
                image_1280_webp: physical_SE_1280_xbox_ACB_webp_1.default,
            },
            digitalStandard: {
                image_640: digital_640_au_jpg_1.default,
                image_1280: digital_1280_au_jpg_1.default,
                image_640_webp: digital_640_au_webp_1.default,
                image_1280_webp: digital_1280_au_webp_1.default,
            },
            digitalDeluxe: {
                image_640: digital_640_au_jpg_1.default,
                image_1280: digital_1280_au_jpg_1.default,
                image_640_webp: digital_640_au_webp_1.default,
                image_1280_webp: digital_1280_au_webp_1.default,
            },
            digitalSuper: {
                image_640: digital_640_au_jpg_1.default,
                image_1280: digital_1280_au_jpg_1.default,
                image_640_webp: digital_640_au_webp_1.default,
                image_1280_webp: digital_1280_au_webp_1.default,
            },
        },
        steam: {
            digitalStandard: {
                image_640: digital_640_au_jpg_1.default,
                image_1280: digital_1280_au_jpg_1.default,
                image_640_webp: digital_640_au_webp_1.default,
                image_1280_webp: digital_1280_au_webp_1.default,
            },
            digitalDeluxe: {
                image_640: digital_640_au_jpg_1.default,
                image_1280: digital_1280_au_jpg_1.default,
                image_640_webp: digital_640_au_webp_1.default,
                image_1280_webp: digital_1280_au_webp_1.default,
            },
            digitalSuper: {
                image_640: digital_640_au_jpg_1.default,
                image_1280: digital_1280_au_jpg_1.default,
                image_640_webp: digital_640_au_webp_1.default,
                image_1280_webp: digital_1280_au_webp_1.default,
            },
        },
    },
    it: {
        switch: {
            physicalLimited: {
                image_640: physical_LE_640_IT_jpg_1.default,
                image_1280: physical_LE_1280_IT_jpg_1.default,
                image_640_webp: physical_LE_640_IT_webp_1.default,
                image_1280_webp: physical_LE_1280_IT_webp_1.default,
            },
            physicalStandard: {
                image_640: physical_SE_640_NSW_PEGI_png_1.default,
                image_1280: physical_SE_1280_NSW_PEGI_png_1.default,
                image_640_webp: physical_SE_640_NSW_PEGI_webp_1.default,
                image_1280_webp: physical_SE_1280_NSW_PEGI_webp_1.default,
            },
            digitalStandard: {
                image_640: digital_640_it_jpg_1.default,
                image_1280: digital_1280_it_jpg_1.default,
                image_640_webp: digital_640_it_webp_1.default,
                image_1280_webp: digital_1280_it_webp_1.default,
            },
            digitalDeluxe: {
                image_640: digital_640_it_jpg_1.default,
                image_1280: digital_1280_it_jpg_1.default,
                image_640_webp: digital_640_it_webp_1.default,
                image_1280_webp: digital_1280_it_webp_1.default,
            },
            digitalSuper: {
                image_640: digital_640_it_jpg_1.default,
                image_1280: digital_1280_it_jpg_1.default,
                image_640_webp: digital_640_it_webp_1.default,
                image_1280_webp: digital_1280_it_webp_1.default,
            },
        },
        ps5: {
            physicalLimited: {
                image_640: physical_LE_640_NSW_png_1.default,
                image_1280: physical_LE_1280_NSW_png_1.default,
                image_640_webp: physical_LE_640_NSW_webp_1.default,
                image_1280_webp: physical_LE_1280_NSW_webp_1.default,
            },
            physicalStandard: {
                image_640: physical_SE_640_ps5_PEGI_png_1.default,
                image_1280: physical_SE_1280_ps5_PEGI_png_1.default,
                image_640_webp: physical_SE_640_ps5_PEGI_webp_1.default,
                image_1280_webp: physical_SE_1280_ps5_PEGI_webp_1.default,
            },
            digitalStandard: {
                image_640: digital_640_it_jpg_1.default,
                image_1280: digital_1280_it_jpg_1.default,
                image_640_webp: digital_640_it_webp_1.default,
                image_1280_webp: digital_1280_it_webp_1.default,
            },
            digitalDeluxe: {
                image_640: digital_640_it_jpg_1.default,
                image_1280: digital_1280_it_jpg_1.default,
                image_640_webp: digital_640_it_webp_1.default,
                image_1280_webp: digital_1280_it_webp_1.default,
            },
            digitalSuper: {
                image_640: digital_640_it_jpg_1.default,
                image_1280: digital_1280_it_jpg_1.default,
                image_640_webp: digital_640_it_webp_1.default,
                image_1280_webp: digital_1280_it_webp_1.default,
            },
        },
        xbox: {
            physicalLimited: {
                image_640: physical_LE_640_NSW_png_1.default,
                image_1280: physical_LE_1280_NSW_png_1.default,
                image_640_webp: physical_LE_640_NSW_webp_1.default,
                image_1280_webp: physical_LE_1280_NSW_webp_1.default,
            },
            physicalStandard: {
                image_640: physical_SE_640_xbox_PEGI_png_1.default,
                image_1280: physical_SE_1280_xbox_PEGI_png_1.default,
                image_640_webp: physical_SE_640_xbox_PEGI_webp_1.default,
                image_1280_webp: physical_SE_1280_xbox_PEGI_webp_1.default,
            },
            digitalStandard: {
                image_640: digital_640_it_jpg_1.default,
                image_1280: digital_1280_it_jpg_1.default,
                image_640_webp: digital_640_it_webp_1.default,
                image_1280_webp: digital_1280_it_webp_1.default,
            },
            digitalDeluxe: {
                image_640: digital_640_it_jpg_1.default,
                image_1280: digital_1280_it_jpg_1.default,
                image_640_webp: digital_640_it_webp_1.default,
                image_1280_webp: digital_1280_it_webp_1.default,
            },
            digitalSuper: {
                image_640: digital_640_it_jpg_1.default,
                image_1280: digital_1280_it_jpg_1.default,
                image_640_webp: digital_640_it_webp_1.default,
                image_1280_webp: digital_1280_it_webp_1.default,
            },
        },
        steam: {
            digitalStandard: {
                image_640: digital_640_it_jpg_1.default,
                image_1280: digital_1280_it_jpg_1.default,
                image_640_webp: digital_640_it_webp_1.default,
                image_1280_webp: digital_1280_it_webp_1.default,
            },
            digitalDeluxe: {
                image_640: digital_640_it_jpg_1.default,
                image_1280: digital_1280_it_jpg_1.default,
                image_640_webp: digital_640_it_webp_1.default,
                image_1280_webp: digital_1280_it_webp_1.default,
            },
            digitalSuper: {
                image_640: digital_640_it_jpg_1.default,
                image_1280: digital_1280_it_jpg_1.default,
                image_640_webp: digital_640_it_webp_1.default,
                image_1280_webp: digital_1280_it_webp_1.default,
            },
        },
    },
    pt: {
        switch: {
            physicalLimited: {
                image_640: physical_LE_640_PT_jpg_1.default,
                image_1280: physical_LE_1280_PT_jpg_1.default,
                image_640_webp: physical_LE_640_PT_webp_1.default,
                image_1280_webp: physical_LE_1280_PT_webp_1.default,
            },
            physicalStandard: {
                image_640: physical_SE_640_NSW_PEGI_png_1.default,
                image_1280: physical_SE_1280_NSW_PEGI_png_1.default,
                image_640_webp: physical_SE_640_NSW_PEGI_webp_1.default,
                image_1280_webp: physical_SE_1280_NSW_PEGI_webp_1.default,
            },
            digitalStandard: {
                image_640: digital_640_pt_jpg_1.default,
                image_1280: digital_1280_pt_jpg_1.default,
                image_640_webp: digital_640_pt_webp_1.default,
                image_1280_webp: digital_1280_pt_webp_1.default,
            },
            digitalDeluxe: {
                image_640: digital_640_pt_jpg_1.default,
                image_1280: digital_1280_pt_jpg_1.default,
                image_640_webp: digital_640_pt_webp_1.default,
                image_1280_webp: digital_1280_pt_webp_1.default,
            },
            digitalSuper: {
                image_640: digital_640_pt_jpg_1.default,
                image_1280: digital_1280_pt_jpg_1.default,
                image_640_webp: digital_640_pt_webp_1.default,
                image_1280_webp: digital_1280_pt_webp_1.default,
            },
        },
        ps5: {
            physicalLimited: {
                image_640: physical_LE_640_NSW_png_1.default,
                image_1280: physical_LE_1280_NSW_png_1.default,
                image_640_webp: physical_LE_640_NSW_webp_1.default,
                image_1280_webp: physical_LE_1280_NSW_webp_1.default,
            },
            physicalStandard: {
                image_640: physical_SE_640_ps5_PEGI_png_1.default,
                image_1280: physical_SE_1280_ps5_PEGI_png_1.default,
                image_640_webp: physical_SE_640_ps5_PEGI_webp_1.default,
                image_1280_webp: physical_SE_1280_ps5_PEGI_webp_1.default,
            },
            digitalStandard: {
                image_640: digital_640_pt_jpg_1.default,
                image_1280: digital_1280_pt_jpg_1.default,
                image_640_webp: digital_640_pt_webp_1.default,
                image_1280_webp: digital_1280_pt_webp_1.default,
            },
            digitalDeluxe: {
                image_640: digital_640_pt_jpg_1.default,
                image_1280: digital_1280_pt_jpg_1.default,
                image_640_webp: digital_640_pt_webp_1.default,
                image_1280_webp: digital_1280_pt_webp_1.default,
            },
            digitalSuper: {
                image_640: digital_640_pt_jpg_1.default,
                image_1280: digital_1280_pt_jpg_1.default,
                image_640_webp: digital_640_pt_webp_1.default,
                image_1280_webp: digital_1280_pt_webp_1.default,
            },
        },
        xbox: {
            physicalLimited: {
                image_640: physical_LE_640_NSW_png_1.default,
                image_1280: physical_LE_1280_NSW_png_1.default,
                image_640_webp: physical_LE_640_NSW_webp_1.default,
                image_1280_webp: physical_LE_1280_NSW_webp_1.default,
            },
            physicalStandard: {
                image_640: physical_SE_640_xbox_PEGI_png_1.default,
                image_1280: physical_SE_1280_xbox_PEGI_png_1.default,
                image_640_webp: physical_SE_640_xbox_PEGI_webp_1.default,
                image_1280_webp: physical_SE_1280_xbox_PEGI_webp_1.default,
            },
            digitalStandard: {
                image_640: digital_640_pt_jpg_1.default,
                image_1280: digital_1280_pt_jpg_1.default,
                image_640_webp: digital_640_pt_webp_1.default,
                image_1280_webp: digital_1280_pt_webp_1.default,
            },
            digitalDeluxe: {
                image_640: digital_640_pt_jpg_1.default,
                image_1280: digital_1280_pt_jpg_1.default,
                image_640_webp: digital_640_pt_webp_1.default,
                image_1280_webp: digital_1280_pt_webp_1.default,
            },
            digitalSuper: {
                image_640: digital_640_pt_jpg_1.default,
                image_1280: digital_1280_pt_jpg_1.default,
                image_640_webp: digital_640_pt_webp_1.default,
                image_1280_webp: digital_1280_pt_webp_1.default,
            },
        },
        steam: {
            digitalStandard: {
                image_640: digital_640_pt_jpg_1.default,
                image_1280: digital_1280_pt_jpg_1.default,
                image_640_webp: digital_640_pt_webp_1.default,
                image_1280_webp: digital_1280_pt_webp_1.default,
            },
            digitalDeluxe: {
                image_640: digital_640_pt_jpg_1.default,
                image_1280: digital_1280_pt_jpg_1.default,
                image_640_webp: digital_640_pt_webp_1.default,
                image_1280_webp: digital_1280_pt_webp_1.default,
            },
            digitalSuper: {
                image_640: digital_640_pt_jpg_1.default,
                image_1280: digital_1280_pt_jpg_1.default,
                image_640_webp: digital_640_pt_webp_1.default,
                image_1280_webp: digital_1280_pt_webp_1.default,
            },
        },
    },
    nl: {
        switch: {
            physicalLimited: {
                image_640: physical_LE_640_NL_jpg_1.default,
                image_1280: physical_LE_1280_NL_jpg_1.default,
                image_640_webp: physical_LE_640_NL_webp_1.default,
                image_1280_webp: physical_LE_1280_NL_webp_1.default,
            },
            physicalStandard: {
                image_640: physical_SE_640_NSW_PEGI_png_1.default,
                image_1280: physical_SE_1280_NSW_PEGI_png_1.default,
                image_640_webp: physical_SE_640_NSW_PEGI_webp_1.default,
                image_1280_webp: physical_SE_1280_NSW_PEGI_webp_1.default,
            },
            digitalStandard: {
                image_640: digital_640_nl_jpg_1.default,
                image_1280: digital_1280_nl_jpg_1.default,
                image_640_webp: digital_640_nl_webp_1.default,
                image_1280_webp: digital_1280_nl_webp_1.default,
            },
            digitalDeluxe: {
                image_640: digital_640_nl_jpg_1.default,
                image_1280: digital_1280_nl_jpg_1.default,
                image_640_webp: digital_640_nl_webp_1.default,
                image_1280_webp: digital_1280_nl_webp_1.default,
            },
            digitalSuper: {
                image_640: digital_640_nl_jpg_1.default,
                image_1280: digital_1280_nl_jpg_1.default,
                image_640_webp: digital_640_nl_webp_1.default,
                image_1280_webp: digital_1280_nl_webp_1.default,
            },
        },
        ps5: {
            physicalLimited: {
                image_640: physical_LE_640_NSW_png_1.default,
                image_1280: physical_LE_1280_NSW_png_1.default,
                image_640_webp: physical_LE_640_NSW_webp_1.default,
                image_1280_webp: physical_LE_1280_NSW_webp_1.default,
            },
            physicalStandard: {
                image_640: physical_SE_640_ps5_PEGI_png_1.default,
                image_1280: physical_SE_1280_ps5_PEGI_png_1.default,
                image_640_webp: physical_SE_640_ps5_PEGI_webp_1.default,
                image_1280_webp: physical_SE_1280_ps5_PEGI_webp_1.default,
            },
            digitalStandard: {
                image_640: digital_640_nl_jpg_1.default,
                image_1280: digital_1280_nl_jpg_1.default,
                image_640_webp: digital_640_nl_webp_1.default,
                image_1280_webp: digital_1280_nl_webp_1.default,
            },
            digitalDeluxe: {
                image_640: digital_640_nl_jpg_1.default,
                image_1280: digital_1280_nl_jpg_1.default,
                image_640_webp: digital_640_nl_webp_1.default,
                image_1280_webp: digital_1280_nl_webp_1.default,
            },
            digitalSuper: {
                image_640: digital_640_nl_jpg_1.default,
                image_1280: digital_1280_nl_jpg_1.default,
                image_640_webp: digital_640_nl_webp_1.default,
                image_1280_webp: digital_1280_nl_webp_1.default,
            },
        },
        xbox: {
            physicalLimited: {
                image_640: physical_LE_640_NSW_png_1.default,
                image_1280: physical_LE_1280_NSW_png_1.default,
                image_640_webp: physical_LE_640_NSW_webp_1.default,
                image_1280_webp: physical_LE_1280_NSW_webp_1.default,
            },
            physicalStandard: {
                image_640: physical_SE_640_xbox_PEGI_png_1.default,
                image_1280: physical_SE_1280_xbox_PEGI_png_1.default,
                image_640_webp: physical_SE_640_xbox_PEGI_webp_1.default,
                image_1280_webp: physical_SE_1280_xbox_PEGI_webp_1.default,
            },
            digitalStandard: {
                image_640: digital_640_nl_jpg_1.default,
                image_1280: digital_1280_nl_jpg_1.default,
                image_640_webp: digital_640_nl_webp_1.default,
                image_1280_webp: digital_1280_nl_webp_1.default,
            },
            digitalDeluxe: {
                image_640: digital_640_nl_jpg_1.default,
                image_1280: digital_1280_nl_jpg_1.default,
                image_640_webp: digital_640_nl_webp_1.default,
                image_1280_webp: digital_1280_nl_webp_1.default,
            },
            digitalSuper: {
                image_640: digital_640_nl_jpg_1.default,
                image_1280: digital_1280_nl_jpg_1.default,
                image_640_webp: digital_640_nl_webp_1.default,
                image_1280_webp: digital_1280_nl_webp_1.default,
            },
        },
        steam: {
            digitalStandard: {
                image_640: digital_640_nl_jpg_1.default,
                image_1280: digital_1280_nl_jpg_1.default,
                image_640_webp: digital_640_nl_webp_1.default,
                image_1280_webp: digital_1280_nl_webp_1.default,
            },
            digitalDeluxe: {
                image_640: digital_640_nl_jpg_1.default,
                image_1280: digital_1280_nl_jpg_1.default,
                image_640_webp: digital_640_nl_webp_1.default,
                image_1280_webp: digital_1280_nl_webp_1.default,
            },
            digitalSuper: {
                image_640: digital_640_nl_jpg_1.default,
                image_1280: digital_1280_nl_jpg_1.default,
                image_640_webp: digital_640_nl_webp_1.default,
                image_1280_webp: digital_1280_nl_webp_1.default,
            },
        },
    },
    ch: {
        switch: {
            physicalLimited: {
                image_640: physical_LE_640_UK_jpg_1.default,
                image_1280: physical_LE_1280_UK_jpg_1.default,
                image_640_webp: physical_LE_640_UK_webp_1.default,
                image_1280_webp: physical_LE_1280_UK_webp_1.default,
            },
            physicalStandard: {
                image_640: physical_SE_640_NSW_PEGI_png_1.default,
                image_1280: physical_SE_1280_NSW_PEGI_png_1.default,
                image_640_webp: physical_SE_640_NSW_PEGI_webp_1.default,
                image_1280_webp: physical_SE_1280_NSW_PEGI_webp_1.default,
            },
            digitalStandard: {
                image_640: digital_640_pegi_jpg_1.default,
                image_1280: digital_1280_pegi_jpg_1.default,
                image_640_webp: digital_640_pegi_webp_1.default,
                image_1280_webp: digital_1280_pegi_webp_1.default,
            },
            digitalDeluxe: {
                image_640: digital_640_pegi_jpg_1.default,
                image_1280: digital_1280_pegi_jpg_1.default,
                image_640_webp: digital_640_pegi_webp_1.default,
                image_1280_webp: digital_1280_pegi_webp_1.default,
            },
            digitalSuper: {
                image_640: digital_640_pegi_jpg_1.default,
                image_1280: digital_1280_pegi_jpg_1.default,
                image_640_webp: digital_640_pegi_webp_1.default,
                image_1280_webp: digital_1280_pegi_webp_1.default,
            },
        },
        ps5: {
            physicalLimited: {
                image_640: physical_LE_640_NSW_png_1.default,
                image_1280: physical_LE_1280_NSW_png_1.default,
                image_640_webp: physical_LE_640_NSW_webp_1.default,
                image_1280_webp: physical_LE_1280_NSW_webp_1.default,
            },
            physicalStandard: {
                image_640: physical_SE_640_ps5_PEGI_png_1.default,
                image_1280: physical_SE_1280_ps5_PEGI_png_1.default,
                image_640_webp: physical_SE_640_ps5_PEGI_webp_1.default,
                image_1280_webp: physical_SE_1280_ps5_PEGI_webp_1.default,
            },
            digitalStandard: {
                image_640: digital_640_pegi_jpg_1.default,
                image_1280: digital_1280_pegi_jpg_1.default,
                image_640_webp: digital_640_pegi_webp_1.default,
                image_1280_webp: digital_1280_pegi_webp_1.default,
            },
            digitalDeluxe: {
                image_640: digital_640_pegi_jpg_1.default,
                image_1280: digital_1280_pegi_jpg_1.default,
                image_640_webp: digital_640_pegi_webp_1.default,
                image_1280_webp: digital_1280_pegi_webp_1.default,
            },
            digitalSuper: {
                image_640: digital_640_pegi_jpg_1.default,
                image_1280: digital_1280_pegi_jpg_1.default,
                image_640_webp: digital_640_pegi_webp_1.default,
                image_1280_webp: digital_1280_pegi_webp_1.default,
            },
        },
        xbox: {
            physicalLimited: {
                image_640: physical_LE_640_NSW_png_1.default,
                image_1280: physical_LE_1280_NSW_png_1.default,
                image_640_webp: physical_LE_640_NSW_webp_1.default,
                image_1280_webp: physical_LE_1280_NSW_webp_1.default,
            },
            physicalStandard: {
                image_640: physical_SE_640_xbox_PEGI_png_1.default,
                image_1280: physical_SE_1280_xbox_PEGI_png_1.default,
                image_640_webp: physical_SE_640_xbox_PEGI_webp_1.default,
                image_1280_webp: physical_SE_1280_xbox_PEGI_webp_1.default,
            },
            digitalStandard: {
                image_640: digital_640_pegi_jpg_1.default,
                image_1280: digital_1280_pegi_jpg_1.default,
                image_640_webp: digital_640_pegi_webp_1.default,
                image_1280_webp: digital_1280_pegi_webp_1.default,
            },
            digitalDeluxe: {
                image_640: digital_640_pegi_jpg_1.default,
                image_1280: digital_1280_pegi_jpg_1.default,
                image_640_webp: digital_640_pegi_webp_1.default,
                image_1280_webp: digital_1280_pegi_webp_1.default,
            },
            digitalSuper: {
                image_640: digital_640_pegi_jpg_1.default,
                image_1280: digital_1280_pegi_jpg_1.default,
                image_640_webp: digital_640_pegi_webp_1.default,
                image_1280_webp: digital_1280_pegi_webp_1.default,
            },
        },
        steam: {
            digitalStandard: {
                image_640: digital_640_pegi_jpg_1.default,
                image_1280: digital_1280_pegi_jpg_1.default,
                image_640_webp: digital_640_pegi_webp_1.default,
                image_1280_webp: digital_1280_pegi_webp_1.default,
            },
            digitalDeluxe: {
                image_640: digital_640_pegi_jpg_1.default,
                image_1280: digital_1280_pegi_jpg_1.default,
                image_640_webp: digital_640_pegi_webp_1.default,
                image_1280_webp: digital_1280_pegi_webp_1.default,
            },
            digitalSuper: {
                image_640: digital_640_pegi_jpg_1.default,
                image_1280: digital_1280_pegi_jpg_1.default,
                image_640_webp: digital_640_pegi_webp_1.default,
                image_1280_webp: digital_1280_pegi_webp_1.default,
            },
        },
    },
    be: {
        switch: {
            physicalLimited: {
                image_640: physical_LE_640_UK_jpg_1.default,
                image_1280: physical_LE_1280_UK_jpg_1.default,
                image_640_webp: physical_LE_640_UK_webp_1.default,
                image_1280_webp: physical_LE_1280_UK_webp_1.default,
            },
            physicalStandard: {
                image_640: physical_SE_640_NSW_PEGI_png_1.default,
                image_1280: physical_SE_1280_NSW_PEGI_png_1.default,
                image_640_webp: physical_SE_640_NSW_PEGI_webp_1.default,
                image_1280_webp: physical_SE_1280_NSW_PEGI_webp_1.default,
            },
            digitalStandard: {
                image_640: digital_640_pegi_jpg_1.default,
                image_1280: digital_1280_pegi_jpg_1.default,
                image_640_webp: digital_640_pegi_webp_1.default,
                image_1280_webp: digital_1280_pegi_webp_1.default,
            },
            digitalDeluxe: {
                image_640: digital_640_pegi_jpg_1.default,
                image_1280: digital_1280_pegi_jpg_1.default,
                image_640_webp: digital_640_pegi_webp_1.default,
                image_1280_webp: digital_1280_pegi_webp_1.default,
            },
            digitalSuper: {
                image_640: digital_640_pegi_jpg_1.default,
                image_1280: digital_1280_pegi_jpg_1.default,
                image_640_webp: digital_640_pegi_webp_1.default,
                image_1280_webp: digital_1280_pegi_webp_1.default,
            },
        },
        ps5: {
            physicalLimited: {
                image_640: physical_LE_640_NSW_png_1.default,
                image_1280: physical_LE_1280_NSW_png_1.default,
                image_640_webp: physical_LE_640_NSW_webp_1.default,
                image_1280_webp: physical_LE_1280_NSW_webp_1.default,
            },
            physicalStandard: {
                image_640: physical_SE_640_ps5_PEGI_png_1.default,
                image_1280: physical_SE_1280_ps5_PEGI_png_1.default,
                image_640_webp: physical_SE_640_ps5_PEGI_webp_1.default,
                image_1280_webp: physical_SE_1280_ps5_PEGI_webp_1.default,
            },
            digitalStandard: {
                image_640: digital_640_pegi_jpg_1.default,
                image_1280: digital_1280_pegi_jpg_1.default,
                image_640_webp: digital_640_pegi_webp_1.default,
                image_1280_webp: digital_1280_pegi_webp_1.default,
            },
            digitalDeluxe: {
                image_640: digital_640_pegi_jpg_1.default,
                image_1280: digital_1280_pegi_jpg_1.default,
                image_640_webp: digital_640_pegi_webp_1.default,
                image_1280_webp: digital_1280_pegi_webp_1.default,
            },
            digitalSuper: {
                image_640: digital_640_pegi_jpg_1.default,
                image_1280: digital_1280_pegi_jpg_1.default,
                image_640_webp: digital_640_pegi_webp_1.default,
                image_1280_webp: digital_1280_pegi_webp_1.default,
            },
        },
        xbox: {
            physicalLimited: {
                image_640: physical_LE_640_NSW_png_1.default,
                image_1280: physical_LE_1280_NSW_png_1.default,
                image_640_webp: physical_LE_640_NSW_webp_1.default,
                image_1280_webp: physical_LE_1280_NSW_webp_1.default,
            },
            physicalStandard: {
                image_640: physical_SE_640_xbox_PEGI_png_1.default,
                image_1280: physical_SE_1280_xbox_PEGI_png_1.default,
                image_640_webp: physical_SE_640_xbox_PEGI_webp_1.default,
                image_1280_webp: physical_SE_1280_xbox_PEGI_webp_1.default,
            },
            digitalStandard: {
                image_640: digital_640_pegi_jpg_1.default,
                image_1280: digital_1280_pegi_jpg_1.default,
                image_640_webp: digital_640_pegi_webp_1.default,
                image_1280_webp: digital_1280_pegi_webp_1.default,
            },
            digitalDeluxe: {
                image_640: digital_640_pegi_jpg_1.default,
                image_1280: digital_1280_pegi_jpg_1.default,
                image_640_webp: digital_640_pegi_webp_1.default,
                image_1280_webp: digital_1280_pegi_webp_1.default,
            },
            digitalSuper: {
                image_640: digital_640_pegi_jpg_1.default,
                image_1280: digital_1280_pegi_jpg_1.default,
                image_640_webp: digital_640_pegi_webp_1.default,
                image_1280_webp: digital_1280_pegi_webp_1.default,
            },
        },
        steam: {
            digitalStandard: {
                image_640: digital_640_pegi_jpg_1.default,
                image_1280: digital_1280_pegi_jpg_1.default,
                image_640_webp: digital_640_pegi_webp_1.default,
                image_1280_webp: digital_1280_pegi_webp_1.default,
            },
            digitalDeluxe: {
                image_640: digital_640_pegi_jpg_1.default,
                image_1280: digital_1280_pegi_jpg_1.default,
                image_640_webp: digital_640_pegi_webp_1.default,
                image_1280_webp: digital_1280_pegi_webp_1.default,
            },
            digitalSuper: {
                image_640: digital_640_pegi_jpg_1.default,
                image_1280: digital_1280_pegi_jpg_1.default,
                image_640_webp: digital_640_pegi_webp_1.default,
                image_1280_webp: digital_1280_pegi_webp_1.default,
            },
        },
    },
    pl: {
        switch: {
            physicalLimited: {
                image_640: physical_LE_640_UK_jpg_1.default,
                image_1280: physical_LE_1280_UK_jpg_1.default,
                image_640_webp: physical_LE_640_UK_webp_1.default,
                image_1280_webp: physical_LE_1280_UK_webp_1.default,
            },
            physicalStandard: {
                image_640: physical_SE_640_NSW_PEGI_png_1.default,
                image_1280: physical_SE_1280_NSW_PEGI_png_1.default,
                image_640_webp: physical_SE_640_NSW_PEGI_webp_1.default,
                image_1280_webp: physical_SE_1280_NSW_PEGI_webp_1.default,
            },
            digitalStandard: {
                image_640: digital_640_pegi_jpg_1.default,
                image_1280: digital_1280_pegi_jpg_1.default,
                image_640_webp: digital_640_pegi_webp_1.default,
                image_1280_webp: digital_1280_pegi_webp_1.default,
            },
            digitalDeluxe: {
                image_640: digital_640_pegi_jpg_1.default,
                image_1280: digital_1280_pegi_jpg_1.default,
                image_640_webp: digital_640_pegi_webp_1.default,
                image_1280_webp: digital_1280_pegi_webp_1.default,
            },
            digitalSuper: {
                image_640: digital_640_pegi_jpg_1.default,
                image_1280: digital_1280_pegi_jpg_1.default,
                image_640_webp: digital_640_pegi_webp_1.default,
                image_1280_webp: digital_1280_pegi_webp_1.default,
            },
        },
        ps5: {
            physicalLimited: {
                image_640: physical_LE_640_NSW_png_1.default,
                image_1280: physical_LE_1280_NSW_png_1.default,
                image_640_webp: physical_LE_640_NSW_webp_1.default,
                image_1280_webp: physical_LE_1280_NSW_webp_1.default,
            },
            physicalStandard: {
                image_640: physical_SE_640_ps5_PEGI_png_1.default,
                image_1280: physical_SE_1280_ps5_PEGI_png_1.default,
                image_640_webp: physical_SE_640_ps5_PEGI_webp_1.default,
                image_1280_webp: physical_SE_1280_ps5_PEGI_webp_1.default,
            },
            digitalStandard: {
                image_640: digital_640_pegi_jpg_1.default,
                image_1280: digital_1280_pegi_jpg_1.default,
                image_640_webp: digital_640_pegi_webp_1.default,
                image_1280_webp: digital_1280_pegi_webp_1.default,
            },
            digitalDeluxe: {
                image_640: digital_640_pegi_jpg_1.default,
                image_1280: digital_1280_pegi_jpg_1.default,
                image_640_webp: digital_640_pegi_webp_1.default,
                image_1280_webp: digital_1280_pegi_webp_1.default,
            },
            digitalSuper: {
                image_640: digital_640_pegi_jpg_1.default,
                image_1280: digital_1280_pegi_jpg_1.default,
                image_640_webp: digital_640_pegi_webp_1.default,
                image_1280_webp: digital_1280_pegi_webp_1.default,
            },
        },
        xbox: {
            physicalLimited: {
                image_640: physical_LE_640_NSW_png_1.default,
                image_1280: physical_LE_1280_NSW_png_1.default,
                image_640_webp: physical_LE_640_NSW_webp_1.default,
                image_1280_webp: physical_LE_1280_NSW_webp_1.default,
            },
            physicalStandard: {
                image_640: physical_SE_640_xbox_PEGI_png_1.default,
                image_1280: physical_SE_1280_xbox_PEGI_png_1.default,
                image_640_webp: physical_SE_640_xbox_PEGI_webp_1.default,
                image_1280_webp: physical_SE_1280_xbox_PEGI_webp_1.default,
            },
            digitalStandard: {
                image_640: digital_640_pegi_jpg_1.default,
                image_1280: digital_1280_pegi_jpg_1.default,
                image_640_webp: digital_640_pegi_webp_1.default,
                image_1280_webp: digital_1280_pegi_webp_1.default,
            },
            digitalDeluxe: {
                image_640: digital_640_pegi_jpg_1.default,
                image_1280: digital_1280_pegi_jpg_1.default,
                image_640_webp: digital_640_pegi_webp_1.default,
                image_1280_webp: digital_1280_pegi_webp_1.default,
            },
            digitalSuper: {
                image_640: digital_640_pegi_jpg_1.default,
                image_1280: digital_1280_pegi_jpg_1.default,
                image_640_webp: digital_640_pegi_webp_1.default,
                image_1280_webp: digital_1280_pegi_webp_1.default,
            },
        },
        steam: {
            digitalStandard: {
                image_640: digital_640_pegi_jpg_1.default,
                image_1280: digital_1280_pegi_jpg_1.default,
                image_640_webp: digital_640_pegi_webp_1.default,
                image_1280_webp: digital_1280_pegi_webp_1.default,
            },
            digitalDeluxe: {
                image_640: digital_640_pegi_jpg_1.default,
                image_1280: digital_1280_pegi_jpg_1.default,
                image_640_webp: digital_640_pegi_webp_1.default,
                image_1280_webp: digital_1280_pegi_webp_1.default,
            },
            digitalSuper: {
                image_640: digital_640_pegi_jpg_1.default,
                image_1280: digital_1280_pegi_jpg_1.default,
                image_640_webp: digital_640_pegi_webp_1.default,
                image_1280_webp: digital_1280_pegi_webp_1.default,
            },
        },
    },
    se: {
        switch: {
            physicalLimited: {
                image_640: physical_LE_640_UK_jpg_1.default,
                image_1280: physical_LE_1280_UK_jpg_1.default,
                image_640_webp: physical_LE_640_UK_webp_1.default,
                image_1280_webp: physical_LE_1280_UK_webp_1.default,
            },
            physicalStandard: {
                image_640: physical_SE_640_NSW_PEGI_png_1.default,
                image_1280: physical_SE_1280_NSW_PEGI_png_1.default,
                image_640_webp: physical_SE_640_NSW_PEGI_webp_1.default,
                image_1280_webp: physical_SE_1280_NSW_PEGI_webp_1.default,
            },
            digitalStandard: {
                image_640: digital_640_pegi_jpg_1.default,
                image_1280: digital_1280_pegi_jpg_1.default,
                image_640_webp: digital_640_pegi_webp_1.default,
                image_1280_webp: digital_1280_pegi_webp_1.default,
            },
            digitalDeluxe: {
                image_640: digital_640_pegi_jpg_1.default,
                image_1280: digital_1280_pegi_jpg_1.default,
                image_640_webp: digital_640_pegi_webp_1.default,
                image_1280_webp: digital_1280_pegi_webp_1.default,
            },
            digitalSuper: {
                image_640: digital_640_pegi_jpg_1.default,
                image_1280: digital_1280_pegi_jpg_1.default,
                image_640_webp: digital_640_pegi_webp_1.default,
                image_1280_webp: digital_1280_pegi_webp_1.default,
            },
        },
        ps5: {
            physicalLimited: {
                image_640: physical_LE_640_NSW_png_1.default,
                image_1280: physical_LE_1280_NSW_png_1.default,
                image_640_webp: physical_LE_640_NSW_webp_1.default,
                image_1280_webp: physical_LE_1280_NSW_webp_1.default,
            },
            physicalStandard: {
                image_640: physical_SE_640_ps5_PEGI_png_1.default,
                image_1280: physical_SE_1280_ps5_PEGI_png_1.default,
                image_640_webp: physical_SE_640_ps5_PEGI_webp_1.default,
                image_1280_webp: physical_SE_1280_ps5_PEGI_webp_1.default,
            },
            digitalStandard: {
                image_640: digital_640_pegi_jpg_1.default,
                image_1280: digital_1280_pegi_jpg_1.default,
                image_640_webp: digital_640_pegi_webp_1.default,
                image_1280_webp: digital_1280_pegi_webp_1.default,
            },
            digitalDeluxe: {
                image_640: digital_640_pegi_jpg_1.default,
                image_1280: digital_1280_pegi_jpg_1.default,
                image_640_webp: digital_640_pegi_webp_1.default,
                image_1280_webp: digital_1280_pegi_webp_1.default,
            },
            digitalSuper: {
                image_640: digital_640_pegi_jpg_1.default,
                image_1280: digital_1280_pegi_jpg_1.default,
                image_640_webp: digital_640_pegi_webp_1.default,
                image_1280_webp: digital_1280_pegi_webp_1.default,
            },
        },
        xbox: {
            physicalLimited: {
                image_640: physical_LE_640_NSW_png_1.default,
                image_1280: physical_LE_1280_NSW_png_1.default,
                image_640_webp: physical_LE_640_NSW_webp_1.default,
                image_1280_webp: physical_LE_1280_NSW_webp_1.default,
            },
            physicalStandard: {
                image_640: physical_SE_640_xbox_PEGI_png_1.default,
                image_1280: physical_SE_1280_xbox_PEGI_png_1.default,
                image_640_webp: physical_SE_640_xbox_PEGI_webp_1.default,
                image_1280_webp: physical_SE_1280_xbox_PEGI_webp_1.default,
            },
            digitalStandard: {
                image_640: digital_640_pegi_jpg_1.default,
                image_1280: digital_1280_pegi_jpg_1.default,
                image_640_webp: digital_640_pegi_webp_1.default,
                image_1280_webp: digital_1280_pegi_webp_1.default,
            },
            digitalDeluxe: {
                image_640: digital_640_pegi_jpg_1.default,
                image_1280: digital_1280_pegi_jpg_1.default,
                image_640_webp: digital_640_pegi_webp_1.default,
                image_1280_webp: digital_1280_pegi_webp_1.default,
            },
            digitalSuper: {
                image_640: digital_640_pegi_jpg_1.default,
                image_1280: digital_1280_pegi_jpg_1.default,
                image_640_webp: digital_640_pegi_webp_1.default,
                image_1280_webp: digital_1280_pegi_webp_1.default,
            },
        },
        steam: {
            digitalStandard: {
                image_640: digital_640_pegi_jpg_1.default,
                image_1280: digital_1280_pegi_jpg_1.default,
                image_640_webp: digital_640_pegi_webp_1.default,
                image_1280_webp: digital_1280_pegi_webp_1.default,
            },
            digitalDeluxe: {
                image_640: digital_640_pegi_jpg_1.default,
                image_1280: digital_1280_pegi_jpg_1.default,
                image_640_webp: digital_640_pegi_webp_1.default,
                image_1280_webp: digital_1280_pegi_webp_1.default,
            },
            digitalSuper: {
                image_640: digital_640_pegi_jpg_1.default,
                image_1280: digital_1280_pegi_jpg_1.default,
                image_640_webp: digital_640_pegi_webp_1.default,
                image_1280_webp: digital_1280_pegi_webp_1.default,
            },
        },
    },
    no: {
        switch: {
            physicalLimited: {
                image_640: physical_LE_640_UK_jpg_1.default,
                image_1280: physical_LE_1280_UK_jpg_1.default,
                image_640_webp: physical_LE_640_UK_webp_1.default,
                image_1280_webp: physical_LE_1280_UK_webp_1.default,
            },
            physicalStandard: {
                image_640: physical_SE_640_NSW_PEGI_png_1.default,
                image_1280: physical_SE_1280_NSW_PEGI_png_1.default,
                image_640_webp: physical_SE_640_NSW_PEGI_webp_1.default,
                image_1280_webp: physical_SE_1280_NSW_PEGI_webp_1.default,
            },
            digitalStandard: {
                image_640: digital_640_pegi_jpg_1.default,
                image_1280: digital_1280_pegi_jpg_1.default,
                image_640_webp: digital_640_pegi_webp_1.default,
                image_1280_webp: digital_1280_pegi_webp_1.default,
            },
            digitalDeluxe: {
                image_640: digital_640_pegi_jpg_1.default,
                image_1280: digital_1280_pegi_jpg_1.default,
                image_640_webp: digital_640_pegi_webp_1.default,
                image_1280_webp: digital_1280_pegi_webp_1.default,
            },
            digitalSuper: {
                image_640: digital_640_pegi_jpg_1.default,
                image_1280: digital_1280_pegi_jpg_1.default,
                image_640_webp: digital_640_pegi_webp_1.default,
                image_1280_webp: digital_1280_pegi_webp_1.default,
            },
        },
        ps5: {
            physicalLimited: {
                image_640: physical_LE_640_NSW_png_1.default,
                image_1280: physical_LE_1280_NSW_png_1.default,
                image_640_webp: physical_LE_640_NSW_webp_1.default,
                image_1280_webp: physical_LE_1280_NSW_webp_1.default,
            },
            physicalStandard: {
                image_640: physical_SE_640_ps5_PEGI_png_1.default,
                image_1280: physical_SE_1280_ps5_PEGI_png_1.default,
                image_640_webp: physical_SE_640_ps5_PEGI_webp_1.default,
                image_1280_webp: physical_SE_1280_ps5_PEGI_webp_1.default,
            },
            digitalStandard: {
                image_640: digital_640_pegi_jpg_1.default,
                image_1280: digital_1280_pegi_jpg_1.default,
                image_640_webp: digital_640_pegi_webp_1.default,
                image_1280_webp: digital_1280_pegi_webp_1.default,
            },
            digitalDeluxe: {
                image_640: digital_640_pegi_jpg_1.default,
                image_1280: digital_1280_pegi_jpg_1.default,
                image_640_webp: digital_640_pegi_webp_1.default,
                image_1280_webp: digital_1280_pegi_webp_1.default,
            },
            digitalSuper: {
                image_640: digital_640_pegi_jpg_1.default,
                image_1280: digital_1280_pegi_jpg_1.default,
                image_640_webp: digital_640_pegi_webp_1.default,
                image_1280_webp: digital_1280_pegi_webp_1.default,
            },
        },
        xbox: {
            physicalLimited: {
                image_640: physical_LE_640_NSW_png_1.default,
                image_1280: physical_LE_1280_NSW_png_1.default,
                image_640_webp: physical_LE_640_NSW_webp_1.default,
                image_1280_webp: physical_LE_1280_NSW_webp_1.default,
            },
            physicalStandard: {
                image_640: physical_SE_640_xbox_PEGI_png_1.default,
                image_1280: physical_SE_1280_xbox_PEGI_png_1.default,
                image_640_webp: physical_SE_640_xbox_PEGI_webp_1.default,
                image_1280_webp: physical_SE_1280_xbox_PEGI_webp_1.default,
            },
            digitalStandard: {
                image_640: digital_640_pegi_jpg_1.default,
                image_1280: digital_1280_pegi_jpg_1.default,
                image_640_webp: digital_640_pegi_webp_1.default,
                image_1280_webp: digital_1280_pegi_webp_1.default,
            },
            digitalDeluxe: {
                image_640: digital_640_pegi_jpg_1.default,
                image_1280: digital_1280_pegi_jpg_1.default,
                image_640_webp: digital_640_pegi_webp_1.default,
                image_1280_webp: digital_1280_pegi_webp_1.default,
            },
            digitalSuper: {
                image_640: digital_640_pegi_jpg_1.default,
                image_1280: digital_1280_pegi_jpg_1.default,
                image_640_webp: digital_640_pegi_webp_1.default,
                image_1280_webp: digital_1280_pegi_webp_1.default,
            },
        },
        steam: {
            digitalStandard: {
                image_640: digital_640_pegi_jpg_1.default,
                image_1280: digital_1280_pegi_jpg_1.default,
                image_640_webp: digital_640_pegi_webp_1.default,
                image_1280_webp: digital_1280_pegi_webp_1.default,
            },
            digitalDeluxe: {
                image_640: digital_640_pegi_jpg_1.default,
                image_1280: digital_1280_pegi_jpg_1.default,
                image_640_webp: digital_640_pegi_webp_1.default,
                image_1280_webp: digital_1280_pegi_webp_1.default,
            },
            digitalSuper: {
                image_640: digital_640_pegi_jpg_1.default,
                image_1280: digital_1280_pegi_jpg_1.default,
                image_640_webp: digital_640_pegi_webp_1.default,
                image_1280_webp: digital_1280_pegi_webp_1.default,
            },
        },
    },
    dk: {
        switch: {
            physicalLimited: {
                image_640: physical_LE_640_UK_jpg_1.default,
                image_1280: physical_LE_1280_UK_jpg_1.default,
                image_640_webp: physical_LE_640_UK_webp_1.default,
                image_1280_webp: physical_LE_1280_UK_webp_1.default,
            },
            physicalStandard: {
                image_640: physical_SE_640_NSW_PEGI_png_1.default,
                image_1280: physical_SE_1280_NSW_PEGI_png_1.default,
                image_640_webp: physical_SE_640_NSW_PEGI_webp_1.default,
                image_1280_webp: physical_SE_1280_NSW_PEGI_webp_1.default,
            },
            digitalStandard: {
                image_640: digital_640_pegi_jpg_1.default,
                image_1280: digital_1280_pegi_jpg_1.default,
                image_640_webp: digital_640_pegi_webp_1.default,
                image_1280_webp: digital_1280_pegi_webp_1.default,
            },
            digitalDeluxe: {
                image_640: digital_640_pegi_jpg_1.default,
                image_1280: digital_1280_pegi_jpg_1.default,
                image_640_webp: digital_640_pegi_webp_1.default,
                image_1280_webp: digital_1280_pegi_webp_1.default,
            },
            digitalSuper: {
                image_640: digital_640_pegi_jpg_1.default,
                image_1280: digital_1280_pegi_jpg_1.default,
                image_640_webp: digital_640_pegi_webp_1.default,
                image_1280_webp: digital_1280_pegi_webp_1.default,
            },
        },
        ps5: {
            physicalLimited: {
                image_640: physical_LE_640_NSW_png_1.default,
                image_1280: physical_LE_1280_NSW_png_1.default,
                image_640_webp: physical_LE_640_NSW_webp_1.default,
                image_1280_webp: physical_LE_1280_NSW_webp_1.default,
            },
            physicalStandard: {
                image_640: physical_SE_640_ps5_PEGI_png_1.default,
                image_1280: physical_SE_1280_ps5_PEGI_png_1.default,
                image_640_webp: physical_SE_640_ps5_PEGI_webp_1.default,
                image_1280_webp: physical_SE_1280_ps5_PEGI_webp_1.default,
            },
            digitalStandard: {
                image_640: digital_640_pegi_jpg_1.default,
                image_1280: digital_1280_pegi_jpg_1.default,
                image_640_webp: digital_640_pegi_webp_1.default,
                image_1280_webp: digital_1280_pegi_webp_1.default,
            },
            digitalDeluxe: {
                image_640: digital_640_pegi_jpg_1.default,
                image_1280: digital_1280_pegi_jpg_1.default,
                image_640_webp: digital_640_pegi_webp_1.default,
                image_1280_webp: digital_1280_pegi_webp_1.default,
            },
            digitalSuper: {
                image_640: digital_640_pegi_jpg_1.default,
                image_1280: digital_1280_pegi_jpg_1.default,
                image_640_webp: digital_640_pegi_webp_1.default,
                image_1280_webp: digital_1280_pegi_webp_1.default,
            },
        },
        xbox: {
            physicalLimited: {
                image_640: physical_LE_640_NSW_png_1.default,
                image_1280: physical_LE_1280_NSW_png_1.default,
                image_640_webp: physical_LE_640_NSW_webp_1.default,
                image_1280_webp: physical_LE_1280_NSW_webp_1.default,
            },
            physicalStandard: {
                image_640: physical_SE_640_xbox_PEGI_png_1.default,
                image_1280: physical_SE_1280_xbox_PEGI_png_1.default,
                image_640_webp: physical_SE_640_xbox_PEGI_webp_1.default,
                image_1280_webp: physical_SE_1280_xbox_PEGI_webp_1.default,
            },
            digitalStandard: {
                image_640: digital_640_pegi_jpg_1.default,
                image_1280: digital_1280_pegi_jpg_1.default,
                image_640_webp: digital_640_pegi_webp_1.default,
                image_1280_webp: digital_1280_pegi_webp_1.default,
            },
            digitalDeluxe: {
                image_640: digital_640_pegi_jpg_1.default,
                image_1280: digital_1280_pegi_jpg_1.default,
                image_640_webp: digital_640_pegi_webp_1.default,
                image_1280_webp: digital_1280_pegi_webp_1.default,
            },
            digitalSuper: {
                image_640: digital_640_pegi_jpg_1.default,
                image_1280: digital_1280_pegi_jpg_1.default,
                image_640_webp: digital_640_pegi_webp_1.default,
                image_1280_webp: digital_1280_pegi_webp_1.default,
            },
        },
        steam: {
            digitalStandard: {
                image_640: digital_640_pegi_jpg_1.default,
                image_1280: digital_1280_pegi_jpg_1.default,
                image_640_webp: digital_640_pegi_webp_1.default,
                image_1280_webp: digital_1280_pegi_webp_1.default,
            },
            digitalDeluxe: {
                image_640: digital_640_pegi_jpg_1.default,
                image_1280: digital_1280_pegi_jpg_1.default,
                image_640_webp: digital_640_pegi_webp_1.default,
                image_1280_webp: digital_1280_pegi_webp_1.default,
            },
            digitalSuper: {
                image_640: digital_640_pegi_jpg_1.default,
                image_1280: digital_1280_pegi_jpg_1.default,
                image_640_webp: digital_640_pegi_webp_1.default,
                image_1280_webp: digital_1280_pegi_webp_1.default,
            },
        },
    },
    at: {
        switch: {
            physicalLimited: {
                image_640: physical_LE_640_UK_jpg_1.default,
                image_1280: physical_LE_1280_UK_jpg_1.default,
                image_640_webp: physical_LE_640_UK_webp_1.default,
                image_1280_webp: physical_LE_1280_UK_webp_1.default,
            },
            physicalStandard: {
                image_640: physical_SE_640_NSW_PEGI_png_1.default,
                image_1280: physical_SE_1280_NSW_PEGI_png_1.default,
                image_640_webp: physical_SE_640_NSW_PEGI_webp_1.default,
                image_1280_webp: physical_SE_1280_NSW_PEGI_webp_1.default,
            },
            digitalStandard: {
                image_640: digital_640_pegi_jpg_1.default,
                image_1280: digital_1280_pegi_jpg_1.default,
                image_640_webp: digital_640_pegi_webp_1.default,
                image_1280_webp: digital_1280_pegi_webp_1.default,
            },
            digitalDeluxe: {
                image_640: digital_640_pegi_jpg_1.default,
                image_1280: digital_1280_pegi_jpg_1.default,
                image_640_webp: digital_640_pegi_webp_1.default,
                image_1280_webp: digital_1280_pegi_webp_1.default,
            },
            digitalSuper: {
                image_640: digital_640_pegi_jpg_1.default,
                image_1280: digital_1280_pegi_jpg_1.default,
                image_640_webp: digital_640_pegi_webp_1.default,
                image_1280_webp: digital_1280_pegi_webp_1.default,
            },
        },
        ps5: {
            physicalLimited: {
                image_640: physical_LE_640_NSW_png_1.default,
                image_1280: physical_LE_1280_NSW_png_1.default,
                image_640_webp: physical_LE_640_NSW_webp_1.default,
                image_1280_webp: physical_LE_1280_NSW_webp_1.default,
            },
            physicalStandard: {
                image_640: physical_SE_640_ps5_PEGI_png_1.default,
                image_1280: physical_SE_1280_ps5_PEGI_png_1.default,
                image_640_webp: physical_SE_640_ps5_PEGI_webp_1.default,
                image_1280_webp: physical_SE_1280_ps5_PEGI_webp_1.default,
            },
            digitalStandard: {
                image_640: digital_640_pegi_jpg_1.default,
                image_1280: digital_1280_pegi_jpg_1.default,
                image_640_webp: digital_640_pegi_webp_1.default,
                image_1280_webp: digital_1280_pegi_webp_1.default,
            },
            digitalDeluxe: {
                image_640: digital_640_pegi_jpg_1.default,
                image_1280: digital_1280_pegi_jpg_1.default,
                image_640_webp: digital_640_pegi_webp_1.default,
                image_1280_webp: digital_1280_pegi_webp_1.default,
            },
            digitalSuper: {
                image_640: digital_640_pegi_jpg_1.default,
                image_1280: digital_1280_pegi_jpg_1.default,
                image_640_webp: digital_640_pegi_webp_1.default,
                image_1280_webp: digital_1280_pegi_webp_1.default,
            },
        },
        xbox: {
            physicalLimited: {
                image_640: physical_LE_640_NSW_png_1.default,
                image_1280: physical_LE_1280_NSW_png_1.default,
                image_640_webp: physical_LE_640_NSW_webp_1.default,
                image_1280_webp: physical_LE_1280_NSW_webp_1.default,
            },
            physicalStandard: {
                image_640: physical_SE_640_xbox_PEGI_png_1.default,
                image_1280: physical_SE_1280_xbox_PEGI_png_1.default,
                image_640_webp: physical_SE_640_xbox_PEGI_webp_1.default,
                image_1280_webp: physical_SE_1280_xbox_PEGI_webp_1.default,
            },
            digitalStandard: {
                image_640: digital_640_pegi_jpg_1.default,
                image_1280: digital_1280_pegi_jpg_1.default,
                image_640_webp: digital_640_pegi_webp_1.default,
                image_1280_webp: digital_1280_pegi_webp_1.default,
            },
            digitalDeluxe: {
                image_640: digital_640_pegi_jpg_1.default,
                image_1280: digital_1280_pegi_jpg_1.default,
                image_640_webp: digital_640_pegi_webp_1.default,
                image_1280_webp: digital_1280_pegi_webp_1.default,
            },
            digitalSuper: {
                image_640: digital_640_pegi_jpg_1.default,
                image_1280: digital_1280_pegi_jpg_1.default,
                image_640_webp: digital_640_pegi_webp_1.default,
                image_1280_webp: digital_1280_pegi_webp_1.default,
            },
        },
        steam: {
            digitalStandard: {
                image_640: digital_640_pegi_jpg_1.default,
                image_1280: digital_1280_pegi_jpg_1.default,
                image_640_webp: digital_640_pegi_webp_1.default,
                image_1280_webp: digital_1280_pegi_webp_1.default,
            },
            digitalDeluxe: {
                image_640: digital_640_pegi_jpg_1.default,
                image_1280: digital_1280_pegi_jpg_1.default,
                image_640_webp: digital_640_pegi_webp_1.default,
                image_1280_webp: digital_1280_pegi_webp_1.default,
            },
            digitalSuper: {
                image_640: digital_640_pegi_jpg_1.default,
                image_1280: digital_1280_pegi_jpg_1.default,
                image_640_webp: digital_640_pegi_webp_1.default,
                image_1280_webp: digital_1280_pegi_webp_1.default,
            },
        },
    },
};
exports.demoLinks = {
    en: {
        switch: 'https://www.nintendo.com/us/store/products/daemon-x-machina-titanic-scion-switch-2/',
        ps5: 'https://store.playstation.com/en-us/product/UP1023-PPSA29624_00-REXDEMO000000001',
        xbox: 'https://www.xbox.com/en-us/games/store/daemon-x-machina-titanic-scion-demo/9pbk6q4dmgtb',
        steam: 'https://store.steampowered.com/app/1342490/Daemon_X_Machina_Titanic_Scion/',
    },
    ca: {
        switch: 'https://www.nintendo.com/en-ca/store/products/daemon-x-machina-titanic-scion-switch-2/',
        ps5: 'https://store.playstation.com/en-ca/product/UP1023-PPSA29624_00-REXDEMO000000001',
        xbox: 'https://www.xbox.com/en-ca/games/store/daemon-x-machina-titanic-scion-demo/9pbk6q4dmgtb',
        steam: 'https://store.steampowered.com/app/1342490/Daemon_X_Machina_Titanic_Scion/',
    },
    uk: {
        switch: 'https://www.nintendo.com/en-gb/Games/Nintendo-Switch-2-games/Daemon-X-Machina-Titanic-Scion-2849025.html?s=countries',
        ps5: 'https://store.playstation.com/product/EP4492-PPSA29640_00-REXDEMO000000001/',
        xbox: 'https://www.xbox.com/games/store/daemon-x-machina-titanic-scion-demo/9pbk6q4dmgtb',
        steam: 'https://store.steampowered.com/app/1342490/Daemon_X_Machina_Titanic_Scion/',
    },
    au: {
        switch: 'https://ec.nintendo.com/AU/en/titles/70010000098438',
        ps5: 'https://store.playstation.com/product/EP4492-PPSA29640_00-REXDEMO000000001/',
        xbox: 'https://www.xbox.com/games/store/daemon-x-machina-titanic-scion-demo/9pbk6q4dmgtb ',
        steam: 'https://store.steampowered.com/app/1342490/Daemon_X_Machina_Titanic_Scion/',
    },
    nz: {
        switch: 'https://ec.nintendo.com/AU/en/titles/70010000098438',
        ps5: 'https://store.playstation.com/product/EP4492-PPSA29640_00-REXDEMO000000001/',
        xbox: 'https://www.xbox.com/games/store/daemon-x-machina-titanic-scion-demo/9pbk6q4dmgtb ',
        steam: 'https://store.steampowered.com/app/1342490/Daemon_X_Machina_Titanic_Scion/',
    },
    fr: {
        switch: 'https://www.nintendo.com/en-gb/Games/Nintendo-Switch-2-games/Daemon-X-Machina-Titanic-Scion-2849025.html?s=countries',
        ps5: 'https://store.playstation.com/product/EP4492-PPSA29640_00-REXDEMO000000001/',
        xbox: 'https://www.xbox.com/games/store/daemon-x-machina-titanic-scion-demo/9pbk6q4dmgtb',
        steam: 'https://store.steampowered.com/app/1342490/Daemon_X_Machina_Titanic_Scion/',
    },
    de: {
        switch: 'https://www.nintendo.com/en-gb/Games/Nintendo-Switch-2-games/Daemon-X-Machina-Titanic-Scion-2849025.html?s=countries',
        ps5: 'https://store.playstation.com/product/EP4492-PPSA29640_00-REXDEMO000000001/',
        xbox: 'https://www.xbox.com/games/store/daemon-x-machina-titanic-scion-demo/9pbk6q4dmgtb',
        steam: 'https://store.steampowered.com/app/1342490/Daemon_X_Machina_Titanic_Scion/',
    },
    es: {
        switch: 'https://www.nintendo.com/en-gb/Games/Nintendo-Switch-2-games/Daemon-X-Machina-Titanic-Scion-2849025.html?s=countries',
        ps5: 'https://store.playstation.com/product/EP4492-PPSA29640_00-REXDEMO000000001/',
        xbox: 'https://www.xbox.com/games/store/daemon-x-machina-titanic-scion-demo/9pbk6q4dmgtb',
        steam: 'https://store.steampowered.com/app/1342490/Daemon_X_Machina_Titanic_Scion/',
    },
    it: {
        switch: 'https://www.nintendo.com/en-gb/Games/Nintendo-Switch-2-games/Daemon-X-Machina-Titanic-Scion-2849025.html?s=countries',
        ps5: 'https://store.playstation.com/product/EP4492-PPSA29640_00-REXDEMO000000001/',
        xbox: 'https://www.xbox.com/games/store/daemon-x-machina-titanic-scion-demo/9pbk6q4dmgtb',
        steam: 'https://store.steampowered.com/app/1342490/Daemon_X_Machina_Titanic_Scion/',
    },
    pt: {
        switch: 'https://www.nintendo.com/en-gb/Games/Nintendo-Switch-2-games/Daemon-X-Machina-Titanic-Scion-2849025.html?s=countries',
        ps5: 'https://store.playstation.com/product/EP4492-PPSA29640_00-REXDEMO000000001/',
        xbox: 'https://www.xbox.com/games/store/daemon-x-machina-titanic-scion-demo/9pbk6q4dmgtb',
        steam: 'https://store.steampowered.com/app/1342490/Daemon_X_Machina_Titanic_Scion/',
    },
    nl: {
        switch: 'https://www.nintendo.com/en-gb/Games/Nintendo-Switch-2-games/Daemon-X-Machina-Titanic-Scion-2849025.html?s=countries',
        ps5: 'https://store.playstation.com/product/EP4492-PPSA29640_00-REXDEMO000000001/',
        xbox: 'https://www.xbox.com/games/store/daemon-x-machina-titanic-scion-demo/9pbk6q4dmgtb',
        steam: 'https://store.steampowered.com/app/1342490/Daemon_X_Machina_Titanic_Scion/',
    },
    ch: {
        switch: 'https://www.nintendo.com/en-gb/Games/Nintendo-Switch-2-games/Daemon-X-Machina-Titanic-Scion-2849025.html?s=countries',
        ps5: 'https://store.playstation.com/product/EP4492-PPSA29640_00-REXDEMO000000001/',
        xbox: 'https://www.xbox.com/games/store/daemon-x-machina-titanic-scion-demo/9pbk6q4dmgtb',
        steam: 'https://store.steampowered.com/app/1342490/Daemon_X_Machina_Titanic_Scion/',
    },
    be: {
        switch: 'https://www.nintendo.com/en-gb/Games/Nintendo-Switch-2-games/Daemon-X-Machina-Titanic-Scion-2849025.html?s=countries',
        ps5: 'https://store.playstation.com/product/EP4492-PPSA29640_00-REXDEMO000000001/',
        xbox: 'https://www.xbox.com/games/store/daemon-x-machina-titanic-scion-demo/9pbk6q4dmgtb',
        steam: 'https://store.steampowered.com/app/1342490/Daemon_X_Machina_Titanic_Scion/',
    },
    pl: {
        switch: 'https://www.nintendo.com/en-gb/Games/Nintendo-Switch-2-games/Daemon-X-Machina-Titanic-Scion-2849025.html?s=countries',
        ps5: 'https://store.playstation.com/product/EP4492-PPSA29640_00-REXDEMO000000001/',
        xbox: 'https://www.xbox.com/games/store/daemon-x-machina-titanic-scion-demo/9pbk6q4dmgtb',
        steam: 'https://store.steampowered.com/app/1342490/Daemon_X_Machina_Titanic_Scion/',
    },
    se: {
        switch: 'https://www.nintendo.com/en-gb/Games/Nintendo-Switch-2-games/Daemon-X-Machina-Titanic-Scion-2849025.html?s=countries',
        ps5: 'https://store.playstation.com/product/EP4492-PPSA29640_00-REXDEMO000000001/',
        xbox: 'https://www.xbox.com/games/store/daemon-x-machina-titanic-scion-demo/9pbk6q4dmgtb',
        steam: 'https://store.steampowered.com/app/1342490/Daemon_X_Machina_Titanic_Scion/',
    },
    no: {
        switch: 'https://www.nintendo.com/en-gb/Games/Nintendo-Switch-2-games/Daemon-X-Machina-Titanic-Scion-2849025.html?s=countries',
        ps5: 'https://store.playstation.com/product/EP4492-PPSA29640_00-REXDEMO000000001/',
        xbox: 'https://www.xbox.com/games/store/daemon-x-machina-titanic-scion-demo/9pbk6q4dmgtb',
        steam: 'https://store.steampowered.com/app/1342490/Daemon_X_Machina_Titanic_Scion/',
    },
    dk: {
        switch: 'https://www.nintendo.com/en-gb/Games/Nintendo-Switch-2-games/Daemon-X-Machina-Titanic-Scion-2849025.html?s=countries',
        ps5: 'https://store.playstation.com/product/EP4492-PPSA29640_00-REXDEMO000000001/',
        xbox: 'https://www.xbox.com/games/store/daemon-x-machina-titanic-scion-demo/9pbk6q4dmgtb',
        steam: 'https://store.steampowered.com/app/1342490/Daemon_X_Machina_Titanic_Scion/',
    },
    at: {
        switch: 'https://www.nintendo.com/en-gb/Games/Nintendo-Switch-2-games/Daemon-X-Machina-Titanic-Scion-2849025.html?s=countries',
        ps5: 'https://store.playstation.com/product/EP4492-PPSA29640_00-REXDEMO000000001/',
        xbox: 'https://www.xbox.com/games/store/daemon-x-machina-titanic-scion-demo/9pbk6q4dmgtb',
        steam: 'https://store.steampowered.com/app/1342490/Daemon_X_Machina_Titanic_Scion/',
    },
};
exports.DLCLinks = {
    en: {
        switch: 'https://www.nintendo.com/us/store/products/daemon-x-machina-titanic-scion-switch-2/dlc/',
        ps5: 'https://store.playstation.com/en-us/product/UP1023-PPSA29154_00-DXMTSFULLGAME000',
        xbox: 'https://www.xbox.com/en-us/games/store/daemon-x-machina-titanic-scion/9N43XQB60804',
        steam: 'https://store.steampowered.com/dlc/1342490/Daemon_X_Machina_Titanic_Scion/',
    },
    ca: {
        switch: 'https://www.nintendo.com/en-ca/store/products/daemon-x-machina-titanic-scion-switch-2/dlc/',
        ps5: 'https://store.playstation.com/en-ca/product/UP1023-PPSA29154_00-DXMTSFULLGAME000',
        xbox: 'https://www.xbox.com/en-CA/games/store/daemon-x-machina-titanic-scion/9N43XQB60804',
        steam: 'https://store.steampowered.com/dlc/1342490/Daemon_X_Machina_Titanic_Scion/',
    },
    uk: {
        switch: 'https://www.nintendo.com/en-gb/Games/Nintendo-Switch-2-games/Daemon-X-Machina-Titanic-Scion-2849025.html?s=countries#dlcItems',
        ps5: 'https://store.playstation.com/product/EP4492-PPSA29136_00-DXMTSFULLGAME000',
        xbox: 'https://www.xbox.com/games/store/daemon-x-machina-titanic-scion/9MSTS8GMBR8P',
        steam: 'https://store.steampowered.com/dlc/1342490/Daemon_X_Machina_Titanic_Scion/',
    },
    au: {
        switch: 'https://ec.nintendo.com/AU/en/titles/70010000098438/aocs',
        ps5: 'https://store.playstation.com/product/EP4492-PPSA29136_00-DXMTSFULLGAME000',
        xbox: 'https://www.xbox.com/games/store/daemon-x-machina-titanic-scion/9MSTS8GMBR8P',
        steam: 'https://store.steampowered.com/dlc/1342490/Daemon_X_Machina_Titanic_Scion/',
    },
    nz: {
        switch: 'https://ec.nintendo.com/NZ/en/titles/70010000098438/aocs',
        ps5: 'https://store.playstation.com/product/EP4492-PPSA29136_00-DXMTSFULLGAME000',
        xbox: 'https://www.xbox.com/games/store/daemon-x-machina-titanic-scion/9MSTS8GMBR8P',
        steam: 'https://store.steampowered.com/dlc/1342490/Daemon_X_Machina_Titanic_Scion/',
    },
    fr: {
        switch: 'https://www.nintendo.com/en-gb/Games/Nintendo-Switch-2-games/Daemon-X-Machina-Titanic-Scion-2849025.html?s=countries#dlcItems',
        ps5: 'https://store.playstation.com/product/EP4492-PPSA29136_00-DXMTSFULLGAME000',
        xbox: 'https://www.xbox.com/games/store/daemon-x-machina-titanic-scion/9MSTS8GMBR8P',
        steam: 'https://store.steampowered.com/dlc/1342490/Daemon_X_Machina_Titanic_Scion/',
    },
    de: {
        switch: 'https://www.nintendo.com/en-gb/Games/Nintendo-Switch-2-games/Daemon-X-Machina-Titanic-Scion-2849025.html?s=countries#dlcItems',
        ps5: 'https://store.playstation.com/product/EP4492-PPSA29136_00-DXMTSFULLGAME000',
        xbox: 'https://www.xbox.com/games/store/daemon-x-machina-titanic-scion/9MSTS8GMBR8P',
        steam: 'https://store.steampowered.com/dlc/1342490/Daemon_X_Machina_Titanic_Scion/',
    },
    es: {
        switch: 'https://www.nintendo.com/en-gb/Games/Nintendo-Switch-2-games/Daemon-X-Machina-Titanic-Scion-2849025.html?s=countries#dlcItems',
        ps5: 'https://store.playstation.com/product/EP4492-PPSA29136_00-DXMTSFULLGAME000',
        xbox: 'https://www.xbox.com/games/store/daemon-x-machina-titanic-scion/9MSTS8GMBR8P',
        steam: 'https://store.steampowered.com/dlc/1342490/Daemon_X_Machina_Titanic_Scion/',
    },
    it: {
        switch: 'https://www.nintendo.com/en-gb/Games/Nintendo-Switch-2-games/Daemon-X-Machina-Titanic-Scion-2849025.html?s=countries#dlcItems',
        ps5: 'https://store.playstation.com/product/EP4492-PPSA29136_00-DXMTSFULLGAME000',
        xbox: 'https://www.xbox.com/games/store/daemon-x-machina-titanic-scion/9MSTS8GMBR8P',
        steam: 'https://store.steampowered.com/dlc/1342490/Daemon_X_Machina_Titanic_Scion/',
    },
    pt: {
        switch: 'https://www.nintendo.com/en-gb/Games/Nintendo-Switch-2-games/Daemon-X-Machina-Titanic-Scion-2849025.html?s=countries#dlcItems',
        ps5: 'https://store.playstation.com/product/EP4492-PPSA29136_00-DXMTSFULLGAME000',
        xbox: 'https://www.xbox.com/games/store/daemon-x-machina-titanic-scion/9MSTS8GMBR8P',
        steam: 'https://store.steampowered.com/dlc/1342490/Daemon_X_Machina_Titanic_Scion/',
    },
    nl: {
        switch: 'https://www.nintendo.com/en-gb/Games/Nintendo-Switch-2-games/Daemon-X-Machina-Titanic-Scion-2849025.html?s=countries#dlcItems',
        ps5: 'https://store.playstation.com/product/EP4492-PPSA29136_00-DXMTSFULLGAME000',
        xbox: 'https://www.xbox.com/games/store/daemon-x-machina-titanic-scion/9MSTS8GMBR8P',
        steam: 'https://store.steampowered.com/dlc/1342490/Daemon_X_Machina_Titanic_Scion/',
    },
    ch: {
        switch: 'https://www.nintendo.com/en-gb/Games/Nintendo-Switch-2-games/Daemon-X-Machina-Titanic-Scion-2849025.html?s=countries#dlcItems',
        ps5: 'https://store.playstation.com/product/EP4492-PPSA29136_00-DXMTSFULLGAME000',
        xbox: 'https://www.xbox.com/games/store/daemon-x-machina-titanic-scion/9MSTS8GMBR8P',
        steam: 'https://store.steampowered.com/dlc/1342490/Daemon_X_Machina_Titanic_Scion/',
    },
    be: {
        switch: 'https://www.nintendo.com/en-gb/Games/Nintendo-Switch-2-games/Daemon-X-Machina-Titanic-Scion-2849025.html?s=countries#dlcItems',
        ps5: 'https://store.playstation.com/product/EP4492-PPSA29136_00-DXMTSFULLGAME000',
        xbox: 'https://www.xbox.com/games/store/daemon-x-machina-titanic-scion/9MSTS8GMBR8P',
        steam: 'https://store.steampowered.com/dlc/1342490/Daemon_X_Machina_Titanic_Scion/',
    },
    pl: {
        switch: 'https://www.nintendo.com/en-gb/Games/Nintendo-Switch-2-games/Daemon-X-Machina-Titanic-Scion-2849025.html?s=countries#dlcItems',
        ps5: 'https://store.playstation.com/product/EP4492-PPSA29136_00-DXMTSFULLGAME000',
        xbox: 'https://www.xbox.com/games/store/daemon-x-machina-titanic-scion/9MSTS8GMBR8P',
        steam: 'https://store.steampowered.com/dlc/1342490/Daemon_X_Machina_Titanic_Scion/',
    },
    se: {
        switch: 'https://www.nintendo.com/en-gb/Games/Nintendo-Switch-2-games/Daemon-X-Machina-Titanic-Scion-2849025.html?s=countries#dlcItems',
        ps5: 'https://store.playstation.com/product/EP4492-PPSA29136_00-DXMTSFULLGAME000',
        xbox: 'https://www.xbox.com/games/store/daemon-x-machina-titanic-scion/9MSTS8GMBR8P',
        steam: 'https://store.steampowered.com/dlc/1342490/Daemon_X_Machina_Titanic_Scion/',
    },
    no: {
        switch: 'https://www.nintendo.com/en-gb/Games/Nintendo-Switch-2-games/Daemon-X-Machina-Titanic-Scion-2849025.html?s=countries#dlcItems',
        ps5: 'https://store.playstation.com/product/EP4492-PPSA29136_00-DXMTSFULLGAME000',
        xbox: 'https://www.xbox.com/games/store/daemon-x-machina-titanic-scion/9MSTS8GMBR8P',
        steam: 'https://store.steampowered.com/dlc/1342490/Daemon_X_Machina_Titanic_Scion/',
    },
    dk: {
        switch: 'https://www.nintendo.com/en-gb/Games/Nintendo-Switch-2-games/Daemon-X-Machina-Titanic-Scion-2849025.html?s=countries#dlcItemss',
        ps5: 'https://store.playstation.com/product/EP4492-PPSA29136_00-DXMTSFULLGAME000',
        xbox: 'https://www.xbox.com/games/store/daemon-x-machina-titanic-scion/9MSTS8GMBR8P',
        steam: 'https://store.steampowered.com/dlc/1342490/Daemon_X_Machina_Titanic_Scion/',
    },
    at: {
        switch: 'https://www.nintendo.com/en-gb/Games/Nintendo-Switch-2-games/Daemon-X-Machina-Titanic-Scion-2849025.html?s=countries#dlcItems',
        ps5: 'https://store.playstation.com/product/EP4492-PPSA29136_00-DXMTSFULLGAME000',
        xbox: 'https://www.xbox.com/games/store/daemon-x-machina-titanic-scion/9MSTS8GMBR8P',
        steam: 'https://store.steampowered.com/dlc/1342490/Daemon_X_Machina_Titanic_Scion/',
    },
};
